{
    "top-menu--tools--name": "Software",
    "top-menu--tools--title": "Software Builderall",
    "top-menu--tools--description": "Il marketing digitale è il processo di promozione di prodotti o servizi attraverso canali digitali come motori di ricerca, social media, e-mail e siti web.",
    "top-menu--university--name": "University ",
    "top-menu--university--title": "Builderall University ",
    "top-menu--university--description": "Il marketing digitale è il processo di promozione di prodotti o servizi tramite canali digitali come motori di ricerca, social media, e-mail e siti web.",
    "top-menu--connect--name": "Supporto",
    "top-menu--franchise-system--name": "Affiliati",
    "top-menu--become-affiliate--name": "Affiliati",
    "top-menu--concession--name": "Concessione",
    "top-menu--tools--builder--title": "Builder ",
    "top-menu--tools--email-and-engage--title": "Email e Contatti",
    "top-menu--tools--design-and-video--title": "Design/Video ",
    "top-menu--tools--website-builder--title": "Siti Web Builder  ",
    "top-menu--tools--website-builder--description": "Crea pagine e siti web dal design e dalle prestazioni ottimizzate con il builder più avanzato. ",
    "top-menu--tools--booking--title": "Booking Builder ",
    "top-menu--tools--booking--description": "Organizzate le vostre riunioni e gestite con facilità la partecipazione a eventi online o fisici con l'app di prenotazione più avanzata.",
    "top-menu--tools--elearning--title": "eLearning Builder ",
    "top-menu--tools--elearning--description": "Crea facilmente corsi con presentazioni moderne e intuitive (stile Netflix) e aumenta il valore percepito dei tuoi corsi.",
    "top-menu--tools--webinar--title": "Webinar Builder ",
    "top-menu--tools--webinar--description": "Crea webinar e corsi evergreen di valore elevato o organizza riunioni dal vivo con funzioni avanzate.",
    "top-menu--tools--funnel-builder--title": "Funnel Builder ",
    "top-menu--tools--funnel-builder--description": "Usa un unico strumento per scegliere il tuo progetto, seleziona il modello, scrivi le tue e-mail, crea la gestione dei pagamenti e poi fai clic su un unico pulsante per generare il tuo sito.",
    "top-menu--tools--quiz--title": "Quiz Builder ",
    "top-menu--tools--quiz--description": "Attira più visitatori, cattura informazioni preziose e sfrutta il potere virale dei quiz.",
    "top-menu--tools--wordpress--title": "WordPress  ",
    "top-menu--tools--wordpress--description": "Gestisci il tuo server WordPress con accesso FTP, WooCommerce o il plugin WordPress di Builderall. ",
    "top-menu--tools--email-marketing-5--title": "MailingBoss  ",
    "top-menu--tools--email-marketing-5--description": "Cattura i contatti e invia campagne illimitate con automazioni avanzate per espandere il tuo business.",
    "top-menu--tools--whatsapp-central--title": "Centrale WhatsApp",
    "top-menu--tools--whatsapp-central--description": "Raccogli e converti facilmente i lead, lancia un prodotto, invia messaggi automatici e crea funnel completi per WhatsApp.",
    "top-menu--tools--telegram--title": "Telegram ",
    "top-menu--tools--telegram--description": "Cattura lead con funnel automatizzati e sfrutta le tue strategie online con questa potente piattaforma.",
    "top-menu--tools--sms--title": "Messaggistica SMS",
    "top-menu--tools--sms--description": "Migliorate i vostri risultati inviando tutti i messaggi di cui avete bisogno con la nostra automazione SMS. ",
    "top-menu--tools--messenger-chatbot--title": "Messenger / Instagram Chatbot ",
    "top-menu--tools--messenger-chatbot--description": "Automatizza le conversazioni, dai assistenza e aumenta le vendite con un Bot personalizzabile per il sito web e i social media. ",
    "top-menu--tools--website-chatbot--title": "Bot per Siti Web",
    "top-menu--tools--website-chatbot--description": "Create facilmente chat room per i vostri siti web o checkout per aumentare la fidelizzazione e il coinvolgimento.",
    "top-menu--tools--social-autopost--title": "App Social Autopost",
    "top-menu--tools--social-autopost--description": "Pianifica i post per Facebook, Instagram, Twitter e LinkedIn in modo organizzato e semplice.",
    "top-menu--tools--social-proof-pop-up--title": "Pop-Up Social Proof ",
    "top-menu--tools--social-proof-pop-up--description": "Aumenta le iscrizioni e le conversioni di vendita sul tuo sito web aggiungendo il nostro innovativo strumento di social proof.",
    "top-menu--tools--browser-notification--title": "Notifiche Browser",
    "top-menu--tools--browser-notification--description": "Raggiungi e comunica gli aggiornamenti ai tuoi contatti, ovunque essi si trovino.",
    "top-menu--tools--clickmap--title": "ClickMap ",
    "top-menu--tools--clickmap--description": "Traccia le visite e scopri quali sono i punti più cliccati per migliorare l'esperienza dell'utente sul tuo sito.",
    "top-menu--tools--helpdesk--title": "HelpDesk ",
    "top-menu--tools--helpdesk--description": "Migliora la percezione del valore della tua azienda con lo strumento di supporto più avanzato disponibile sul mercato.",
    "top-menu--tools--magazine-builder--title": "Builderall Plume",
    "top-menu--tools--magazine-builder--description": "Crea la tua rivista digitale interattiva e coinvolgente o il tuo ebook. Crea autorevolezza, cattura lead e vendi di più.",
    "top-menu--tools--branding-designs--title": "Mockup Studio ",
    "top-menu--tools--branding-designs--description": "Crea pagine sorprendenti e design unici con una delle più grandi librerie di mockup su Internet.",
    "top-menu--tools--video-hosting--title": "Video & Audio Hosting ",
    "top-menu--tools--video-hosting--description": "Archivia e incorpora in modo sicuro i video su qualsiasi sito web con tag, effetti, sottotitoli e altro ancora.",
    "top-menu--tools--legacy--pixel-perfect--title": "Vecchio builder - Pixel Perfect",
    "top-menu--tools--legacy--webinar-1--title": "Webinar ",
    "top-menu--tools--legacy--canvas--title": "Builderall Canvas ",
    "top-menu--tools--legacy--video-wrapper-1--title": "Video Wrapper ",
    "top-menu--tools--legacy--ecommerce-magento--title": "Ecommerce-Magento ",
    "top-menu--tools--legacy--roulette-1--title": "Roulette ",
    "top-menu--tools--legacy--mobile-first--title": "Mobile First Builder ",
    "top-menu--tools--legacy--instagram-autoresponder-1--title": "Autorisponditore Instagram",
    "top-menu--tools--legacy--facebook-inbox-answer--title": "Messenger Chatbot ",
    "top-menu--tools--legacy--videotag-1--title": "Video Tag ",
    "top-menu--tools--legacy--wordpress-builder-1--title": "Integrazione WordPress",
    "top-menu--tools--legacy--app-builder--title": "App Builder ",
    "top-menu--tools--legacy--responsive-blog--title": "Responsive Blog Builder ",
    "top-menu--tools--legacy--presentation-studio--title": "Presentation Studio ",
    "top-menu--tools--legacy--floating-videos--title": "Transparent Floating Videos  ",
    "top-menu--tools--legacy--heat-map--title": "Clickmap  ",
    "top-menu--tools--legacy--responsive-builder--title": "Responsive Builder ",
    "top-menu--tools--legacy--3d-photo-editor-studio--title": "3D Photo Studio ",
    "top-menu--university--training--title": "Formazione",
    "top-menu--university--add-ons--title": "Componenti aggiuntivi",
    "top-menu--university--training--quick-start-training--title": "Formazione rapida",
    "top-menu--university--training--quick-start-training--description": "Inizia a lavorare come associato con Builderall imparando a usare Google Ads per promuovere il tuo link di affiliazione. Sono incluse istruzioni passo-passo per impostare i vostri annunci Google per raggiungere il pubblico di riferimento.",
    "top-menu--university--training--email-marketing-mailingboss--title": "Email Marketing + Mailing Boss ",
    "top-menu--university--training--email-marketing-mailingboss--description": "Scopri come configurare il tuo sistema di email marketing con il nostro guru interno dell'email marketing, Julio Rocha. In qualità di sviluppatore di MailingBoss, ti guiderà attraverso le cose più importanti da sapere per far sì che la tua email lavori per te.",
    "top-menu--university--training--local-business-website-agency-course--title": "Corso di Agenzia di Siti Web per Aziende Locali",
    "top-menu--university--training--local-business-website-agency-course--description": "Segui Alvaro Salgado mentre ti insegna come costruire e far crescere la tua agenzia per fornire servizi ai tuoi clienti utilizzando gli strumenti di Builderall.",
    "top-menu--university--training--facebook-ads-course--title": "Corso Facebook Ads - Modulo 1",
    "top-menu--university--training--facebook-ads-course--description": "Scopri come utilizzare le pagine e le inserzioni di Facebook. Dalla creazione della pagina aziendale alla gestione degli annunci, imparerai a usare Facebook per far crescere la tua attività.",
    "top-menu--university--training--mailingboss-minicourse-practice--title": "Minicorso pratico di Mailingboss",
    "top-menu--university--training--mailingboss-minicourse-practice--description": "Diventa un MailingBoss Master e impara i principi fondamentali per creare automazioni intelligenti che rivoluzioneranno e semplificheranno la tua attività.",
    "top-menu--university--training--builderall-university-live--title": "Builderall University Live ",
    "top-menu--university--training--builderall-university-live--description": "Scopri questa risorsa formativa completa che comprende diversi livelli di strategie e risorse dedicate alla padronanza degli strumenti e dei servizi Builderall.",
    "top-menu--university--training--tybl-bonuses--title": "Bonus Tybl",
    "top-menu--university--training--tybl-bonuses--description": "Accedi ai tuoi bonus per il programma Taylor Your Best Life.",
    "top-menu--university--training--platform-training--title": "Formazione sulla piattaforma",
    "top-menu--university--training--platform-training--description": "Accedi a un catalogo completo di risorse per la formazione sugli strumenti Builderall, progettato per ottimizzarne l'utilizzo in base alle tue esigenze aziendali.",
    "top-menu--university--training--masterclass-video--title": "Masterclass Video ",
    "top-menu--university--training--masterclass-video--description": "Capire il metodo, la strategia e i modelli che stanno alla base delle aziende di successo e scoprire come iniziare a scalare la propria attività oggi.",
    "top-menu--university--training--bootcamp--title": "Bootcamp ",
    "top-menu--university--training--bootcamp--description": "Descrizione Bootcamp",
    "top-menu--university--add-ons--inbox-path--title": "InboxPath",
    "top-menu--university--add-ons--inbox-path--description": "È fondamentale monitorare e pulire le liste di posta elettronica per la tua attività. InboxPath ti aiuta a mantenere le tue liste pulite, in modo che la tua lista continui a essere reattiva e a lavorare per te.",
    "top-menu--university--add-ons--solo-ads--title": "Solo Ads ",
    "top-menu--university--add-ons--solo-ads--description": "Solo Ads sono un ottimo modo per far crescere le vostre liste di email e potenzialmente realizzare delle vendite. Usate una delle nostre risorse affidabili di Solo Ads per continuare a costruire la vostra lista di email marketing e far crescere il vostro business.",
    "top-menu--university--add-ons--tybl-solo-ads--title": "TyBL Solo Ads ",
    "top-menu--university--add-ons--tybl-solo-ads--description": "Solo Ads sono un ottimo modo per far crescere le vostre liste di email e potenzialmente realizzare delle vendite. Usate una delle nostre risorse affidabili di Solo Ads per continuare a costruire la vostra lista di email marketing e far crescere il vostro business. ",
    "top-menu--connect--community--title": "Community ",
    "top-menu--connect--community--description": "Segui <b>Builderall</b> sui social media",
    "top-menu--connect--real-time-support--title": "Supporto in Tempo Reale",
    "top-menu--connect--real-time-support--description": "Mettiti in contatto con uno dei nostri specialisti formati per assisterti",
    "top-menu--connect--help--title": "Aiuto ",
    "top-menu--connect--help--description": "Unisciti a <b>Builderall</b> sui social network",
    "top-menu--connect--real-time-support--ticket--title": "Ticket ",
    "top-menu--connect--real-time-support--chat--title": "Chat ",
    "top-menu--connect--help--support--title": "Supporto ",
    "top-menu--connect--help--certified-partners--title": "Partner Certificati",
    "top-menu--connect--help--glossary--title": "Glossario",
    "top-menu--connect--help--knowledgebase--title": "Knowledgebase ",
    "top-menu--connect--help--blog--title": "Blog ",
    "top-menu--connect--help--roadmap--title": "Roadmap ",
    "top-menu--connect--help--feedback--title": "Feedback ",
    "top-menu--connect--help--events-calendar--title": "Calendario eventi",
    "general-stuff--knowledgebase-title": "Knowledgebase ",
    "general-stuff--quick-meeting-title": "Meeting rapido",
    "general-stuff--support-title": "Supporto",
    "general-stuff--notifications-title": "Notifiche ",
    "right-menu--dns-manager--title": "DNS ",
    "right-menu--privacy-policy--title": "Privacy ",
    "right-menu--white-label--title": "White Label ",
    "right-menu--settings--title": "Impostazioni",
    "right-menu--help--title": "Aiuto ",
    "top-menu--tools--legacy--directory-builder--title": "Directory ",
    "top-menu--tools--legacy--delivery--title": "Delivery ",
    "top-menu--tools--legacy--video-funnel-builder--title": "Video Funnel Builder ",
    "top-menu--tools--legacy--market-place--title": "Marketplace ",
    "top-menu--tools--legacy--chat-builder--title": "Chat builder ",
    "top-menu--tools--legacy--copywriting--title": "generatore di script",
    "top-menu--tools--legacy--design-resources--title": "Risorse per il design",
    "top-menu--tools--legacy--funnel-club--title": "Funnel Club ",
    "top-menu--tools--legacy--viral-referrals--title": "Share Locker ",
    "top-menu--tools--legacy--worckie--title": "Worckie ",
    "left-menu--home--name": "Home ",
    "left-menu--ba-nation--name": "BA Nation ",
    "left-menu--get-started--name": "Inizia",
    "left-menu--business-center--name": "Il mio business",
    "left-menu--build--name": "Crea",
    "left-menu--engage--name": "Comunica",
    "left-menu--business-center--title": "Il mio business",
    "left-menu--business-center--description": "Usa gli strumenti di Builderall per gestire la tua attività.",
    "left-menu--build--title": "Usa la suite di strumenti di marketing di Builderall per costruire e far crescere il tuo business.",
    "left-menu--build--description": "Come la condivisione, il gradimento, i commenti, la creazione di contenuti e l'interazione con altri utenti.",
    "left-menu--engage--title": "Usare gli strumenti di Builderall per coinvolgere il tuo pubblico",
    "left-menu--engage--description": "Scegli uno dei seguenti oggetti per iniziare",
    "left-menu--business-center--dns-manager--title": "GESTORE DI DOMINI ED E-MAIL",
    "left-menu--business-center--dns-manager--subtitle": "Gestisci i tuoi domini e le tue e-mail personalizzate",
    "left-menu--business-center--url-shortener--title": "ACCORCIATORE URL",
    "left-menu--business-center--url-shortener--subtitle": "Accorcia il link e analizza il traffico",
    "left-menu--business-center--seo-report--title": "REPORT SEO",
    "left-menu--business-center--seo-report--subtitle": "Gestire la SEO per massimizzare il traffico organico",
    "left-menu--business-center--team-access--title": "ACCESSI x TEAM",
    "left-menu--business-center--team-access--subtitle": "Crea accessi personalizzati per i membri del team",
    "left-menu--business-center--crm--title": "CRM ",
    "left-menu--business-center--crm--subtitle": "Visualizza i percorsi dei miei visitatori",
    "left-menu--business-center--website-agency--title": "AGENZIA x SITI WEB",
    "left-menu--business-center--website-agency--subtitle": "Crea un subaccount da gestire per i tuoi clienti",
    "left-menu--build--website-builder--title": "Crea un Sito Web",
    "left-menu--build--email-marketing-5--title": "Crea una sequenza di email",
    "left-menu--build--booking--title": "Crea un calendario con Booking",
    "left-menu--build--elearning--title": "Crea un Corso",
    "left-menu--build--webinar--title": "Crea un webinar evergreen",
    "left-menu--build--magazine-builder--title": "Crea un Magazine",
    "left-menu--engage--email-marketing-5--title": "Creare un sequenza di e-mail",
    "left-menu--engage--messenger-chatbot--title": "Crea un chatbot per i social media",
    "left-menu--engage--website-chatbot--title": "Creare un chatbot per il tuo sito web",
    "left-menu--engage--sms--title": "Invia SMS",
    "left-menu--engage--browser-notification--title": "Automatizza i messaggi tramite browser",
    "left-menu--engage--social-proof-pop-up--title": "Creare social proof per il tuo sito web",
    "left-menu--history--website-builder--title": "Builder Siti Web",
    "left-menu--history--booking--title": "Booking Builder ",
    "left-menu--history--elearning--title": "eLearning Builder ",
    "left-menu--history--webinar--title": "Webinar Builder ",
    "left-menu--history--quiz--title": "Quiz Builder ",
    "left-menu--history--wordpress--title": "WordPress ",
    "left-menu--history--email-marketing-5--title": "MailingBoss ",
    "left-menu--history--whatsapp-automation--title": "Automazioni WhatsApp",
    "left-menu--history--whatsapp-launch-manager--title": "Centrale WhatsApp",
    "left-menu--history--whatsapp-central--title": "Centrale WhatsApp",
    "left-menu--history--telegram--title": "Telegram ",
    "left-menu--history--sms--title": "Messaggistica SMS",
    "left-menu--history--messenger-chatbot--title": "Messenger / Instagram Chatbot ",
    "left-menu--history--website-chatbot--title": "Bot per Siti Web",
    "left-menu--history--social-autopost--title": "App Autopost per Social",
    "left-menu--history--social-proof-pop-up--title": "Social Proof Pop-Up ",
    "left-menu--history--browser-notification--title": "Notifiche Browser",
    "left-menu--history--clickmap--title": "ClickMap ",
    "left-menu--history--helpdesk--title": "HelpDesk ",
    "left-menu--history--magazine-builder--title": "Builderall Plume",
    "left-menu--history--branding-designs--title": "Mockup Studio ",
    "left-menu--history--video-hosting--title": "Video & Audio Hosting ",
    "left-menu--history--3d-photo-editor-studio--title": "3D Photos Studio ",
    "left-menu--history--crm--title": "CRM ",
    "left-menu--history--website-agency--title": "Agenzia x Siti Web",
    "left-menu--history--seo-report--title": "SEO Report ",
    "left-menu--history--url-shortener--title": "Accorciatore URL",
    "left-menu--history--dns-manager--title": "GESTIONE DNS",
    "left-menu--history--team-access--title": "Accesso Team",
    "left-menu--history--funnel-builder--title": "Funnel Builder ",
    "top-menu--tools--legacy--omb-reviews--title": "Chat Review ",
    "top-menu--connect--community--facebook--builderall-br-affiliate-community--title": "Comunità di affiliati Builderall Brasile ",
    "top-menu--connect--community--facebook--builderall-br-affiliate-community--description": "5.9k membri ",
    "top-menu--connect--community--facebook--builderall-br-users-community--title": "Comunità di utenti Builderall ",
    "top-menu--connect--community--facebook--builderall-br-users-community--description": "22.4k membri ",
    "top-menu--connect--community--facebook--builderall-es-community--title": "Builderall - ES ",
    "top-menu--connect--community--facebook--builderall-es-community--description": "13.1k membri",
    "top-menu--connect--community--facebook--builderall-es-affiliate-community--title": "Builderall Affiliati - ES",
    "top-menu--connect--community--facebook--builderall-es-affiliate-community--description": "3 membri",
    "top-menu--connect--community--facebook--builderall-us-official--title": "Builderall (Ufficiale)",
    "top-menu--connect--community--facebook--builderall-us-official--description": "56.8k membri",
    "top-menu--connect--community--facebook--builderall-us-affiliate-community--title": "Builderall Affiliati (Ufficiale)",
    "top-menu--connect--community--facebook--builderall-us-affiliate-community--description": "17k membri",
    "top-menu--connect--community--facebook--builderall-us-community--title": "Builderall Community ",
    "top-menu--connect--community--facebook--builderall-us-community--description": "27.6k membri",
    "top-menu--connect--community--facebook--builderall-de-community--title": "Builderall Tedesco (gruppo utenti)",
    "top-menu--connect--community--facebook--builderall-de-community--description": "2.5k membri ",
    "top-menu--connect--community--facebook--builderall-de-affiliate-community--title": "Builderall Germania - Gli utenti aiutano gli utenti",
    "top-menu--connect--community--facebook--builderall-de-affiliate-community--description": "Comunità tedesca",
    "top-menu--connect--community--facebook--builderall-fr-community--title": "La comunità francese di Builderall",
    "top-menu--connect--community--facebook--builderall-fr-community--description": "249 membri",
    "top-menu--connect--community--facebook--builderall-it-viral-team--title": "BuilderAll Viral team Italia ",
    "top-menu--connect--community--facebook--builderall-it-viral-team--description": "5.8k membri",
    "general-stuff--help--title": "Aiuto",
    "footer-menu--terms-of-use--title": "Termini e Condizioni",
    "footer-menu--privacy-policy--title": "Privacy Policy ",
    "footer-menu--franchise-system--title": "Affiliati",
    "footer-menu--support--title": "Supporto",
    "top-menu--connect--community--facebook--title": "Unisciti alla comunità di Builderall su Facebook",
    "top-menu--connect--community--facebook--join-now": "Partecipa ora",
    "top-menu--university--training--war-arsenal--title": "Arsenale di guerra",
    "top-menu--university--training--war-arsenal--description": "Accesso alla formazione Arsenale di Guerra.",
    "top-menu--university--training--super-funnels--title": "Super Funnel ",
    "top-menu--university--training--super-funnels--description": "Inizia un viaggio entusiasmante per acquisire le competenze necessarie a costruire super funnel altamente efficaci utilizzando Builderall.",
    "top-menu--university--training--camp-mentoring--title": "Corso di mentoring ",
    "top-menu--university--training--camp-mentoring--description": "Imparare l'intelligenza finanziaria, accedere a un mentoring di livello mondiale e imparare a vivere il business. ",
    "top-menu--university--training--checklist-sf30d--title": "Checklist SF30D ",
    "top-menu--university--training--checklist-sf30d--description": "Lista di controllo milionaria con marketer di alto livello che vi insegnano come mantenere una mentalità milionaria. ",
    "top-menu--university--training--es-niche-training--title": "Corsi di formazione per nicchie",
    "top-menu--university--training--es-niche-training--description": "Scopri come costruire e far crescere la tua agenzia web con i prodotti e i servizi Builderall.",
    "top-menu--university--training--the-lead-whisperer--title": "Scaricare L'incantatore di Lead",
    "top-menu--university--training--the-lead-whisperer--description": "I segreti dei più grandi copywriter del mondo svelati affinché la vostra lettera di vendita sia potente e converta i vostri contatti in clienti paganti.",
    "top-menu--university--training--funnel-club-bonuses--title": "Bonus Funnel Club",
    "top-menu--university--training--funnel-club-bonuses--description": "Accedi a un elenco completo di preziosi bonus che ti guidano nella costruzione e nella crescita del tuo business utilizzando gli strumenti e i servizi di Builderall.",
    "top-menu--university--training--mailingboss-extreme--title": "Mailingboss Serie 5.0 all'estremo ",
    "top-menu--university--training--mailingboss-extreme--description": "Mailingboss Serie 5.0 all'estremo ",
    "top-menu--university--training--successful-affiliate--title": "Associato di Successo",
    "top-menu--university--training--successful-affiliate--description": "Capire i segreti, i suggerimenti e i trucchi per diventare un associato di successo.",
    "top-menu--university--training--community-without-guru--title": "La comunità senza guru",
    "top-menu--university--training--community-without-guru--description": "Ottieni l'accesso alle risorse e alla formazione dei più grandi esperti del mondo e impara a generare molteplici fonti di reddito online grazie a lanci di prodotti, webinar e altro ancora!",
    "top-menu--university--training--es-builderall-university--title": "Università di Builderall",
    "top-menu--university--training--es-builderall-university--description": "Scopri questa risorsa formativa completa che comprende diversi livelli di strategie e risorse dedicate alla padronanza degli strumenti e dei servizi Builderall.",
    "top-menu--university--training--secretos-de-afiliados-top--title": "I segreti degli affiliati TOP",
    "top-menu--university--training--secretos-de-afiliados-top--description": "Scopri i segreti degli affiliati Builderall di maggior successo e come hanno raggiunto il loro successo.",
    "top-menu--university--training--cheetah-quick-website-creation--title": "Formazione rapida sulla creazione di siti web con Cheetah",
    "top-menu--university--training--cheetah-quick-website-creation--description": "Guardate questo potente corso di formazione, passo dopo passo, su come costruire il vostro sito web professionale con il costruttore di siti web drag-and-drop e pixel perfect di Builderall.",
    "top-menu--university--training--mentoring-30days-of-automation--title": "Mentoring di 30 giorni sull'automazione",
    "top-menu--university--training--mentoring-30days-of-automation--description": "Un'esperienza esaltante di 30 giorni di formazione commerciale e di marketing online di alto livello, condotta da esperti di fama mondiale. ",
    "header-menu--pay-now--message": "Mantieni l'accesso a tutte le tue risorse",
    "header-menu--pay-now--title": "Paga ora",
    "get-started-video-link": "https://www.youtube.com/embed/oV0bBCLCxJ8?cc_load_policy=1&cc_lang_pref=it-IT&rel=0&autoplay=1",
    "top-menu--university--training--viral-team-italia--title": "Formazione in lingua Italiana",
    "top-menu--university--training--viral-team-italia--description": "Benvenuti alla Builderall University, dove avete accesso a corsi di formazione, contenuti esclusivi e canali di social media.",
    "top-menu--tools--premium--title": "Premium",
    "top-menu--tools--essentials--title": "Essentials",
    "top-menu--tools--advanced--title": "Advanced",
    "appshell-unlock": "Sbloccare",
    "top-menu--tools--dns-manager--title": "DNS Manager",
    "top-menu--tools--dns-manager--description": "Gestire i domini e le e-mail personalizzate",
    "top-menu--tools--seo-report--title": "SEO Report",
    "top-menu--tools--seo-report--description": "Gestire la SEO per massimizzare il traffico organico",
    "top-menu--tools--url-shortener--title": "URL Shortener",
    "top-menu--tools--url-shortener--description": "Accorciare i link e analizzare il traffico",
    "top-menu--tools--crm--title": "CRM",
    "top-menu--tools--crm--description": "Visualizza i percorsi dei miei visitatori",
    "top-menu--tools--team-access--title": "Team Access",
    "top-menu--tools--team-access--description": "Creare accessi personalizzati per i membri del team",
    "top-menu--tools--website-agency--title": "Website Agency",
    "top-menu--tools--website-agency--description": "Crea un subaccount da gestire per i propri clienti",
    "avatar-hi": "Ciao",
    "avatar-manage-your-account": "Gestisci il tuo account",
    "avatar-earn-profile-badges": "Ottenete i badge del profilo lavorando con la piattaforma.",
    "avatar-coming-soon": "In arrivo",
    "avatar-your-domains": "I tuoi domini",
    "avatar-domain": "Dominio",
    "avatar-your-emails": "Le tue e-mail",
    "avatar-plan-information": "Informazioni sul piano",
    "avatar-white-label-access": "Accesso al White Label",
    "avatar-domains": "Domini",
    "avatar-hard-drive-space": "Spazio su disco rigido",
    "avatar-subscribers": "Max. Iscritti",
    "avatar-associate-sponsor": "Sponsor associato",
    "avatar-associate-id": "ID Associato",
    "avatar-next-payment-date": "Data del prossimo pagamento",
    "avatar-of": "di",
    "avatar-yearly": "Annuale",
    "avatar-biannual": "Biannuale",
    "avatar-monthly": "Mensile",
    "avatar-quarterly": "Trimestrale",
    "avatar-english": "Inglese",
    "avatar-portuguese": "Portoghese",
    "avatar-italian": "Italiano",
    "avatar-french": "Francese",
    "avatar-spanish": "Spagnolo",
    "avatar-german": "Tedesco",
    "avatar-no-domains": "Nessun dominio",
    "avatar-no-emails": "Nessuna e-mail",
    "top-menu--university--training--curso-afiliados-hotmart--title": "Corso di Hotmart",
    "top-menu--university--training--curso-afiliados-hotmart--description": "Aumentate le vendite digitali di Hotmart, create sistemi di vendita automatizzati e massimizzate le vostre vendite con Builderall.",
    "appshell-dont-show-again": "Non mostrare più questo messaggio",
    "enom-choose-the-best-name": "Scegliete il nome migliore per il vostro sito web",
    "enom-search-domain": "Ricerca Dominio",
    "enom-important-information": "Informazioni importanti",
    "enom-alert-info1": "Dopo il pagamento, il dominio verrà automaticamente configurato e reso disponibile sullo strumento DNS Manager. Affinché la propagazione avvenga, è necessario collegare il dominio a un sito web dopo l'acquisto; questo processo può richiedere fino a 2 ore.",
    "enom-alert-info2": "La connessione al dominio sarà consentita solo se la quota di connessione è disponibile.",
    "enom-alert-info3": "I prezzi dei domini possono variare al momento del rinnovo, poiché sono soggetti a condizioni di vendita speciali.",
    "enom-alert-info4": "Gli acquisti di domini non sono rimborsabili.",
    "enom-alert-info5": "Account di squadra: la connessione dei domini a un account Team è consentita solo attraverso i link del vostro funnel.",
    "enom-add-privacy-protection": "Aggiungere la protezione della privacy?",
    "enom-registration-length": "Lunghezza della registrazione",
    "appshell-selected": "Selezionato",
    "enom-additional-information": "Informazioni aggiuntive",
    "appshell-total": "Totale",
    "appshell-back": "Indietro ",
    "appshell-continue": "Continua ",
    "enom-payment-is-processing": "Il pagamento viene elaborato. Una volta verificato, troverete il vostro nuovo dominio elencato nello strumento DNS Manager. Fate clic su \"continua\" per accedere allo strumento.",
    "enom-registration-data": "Dati di registrazione",
    "enom-to-continue-verify-purchase": "Per continuare, abbiamo bisogno di alcune informazioni aggiuntive per verificare il vostro acquisto.",
    "enom-domain-extension-selected": "Avete selezionato un'estensione di dominio speciale",
    "appshell-select-a-option": "Selezionare un'opzione",
    "appshell-edit": "Modifica ",
    "appshell-address": "Indirizzo ",
    "appshell-city": "Città ",
    "appshell-state-province": "Stato/Provincia",
    "appshell-country": "Nazione",
    "appshell-terms-accepted-on": "Condizioni di utilizzo accettate il",
    "appshell-add-new": "Aggiungi nuovo ",
    "appshell-text-goes-here": "Il testo va qui",
    "appshell-name": "Nome",
    "appshell-last-name": "Cognome ",
    "enom-thank-you-for-purchase": "Grazie per l'acquisto!",
    "appshell-terms-of-use": "Condizioni d'uso e informativa sulla privacy",
    "appshell-i-accept-the": "Accetto il ",
    "appshell-job-title": "Titolo lavoro",
    "appshell-organization-name": "Nome dell'azienda",
    "appshell-phone": "Telefono ",
    "appshell-email-address": "Indirizzo e-mail ",
    "appshell-postal-code": "Codice postale ",
    "appshell-address-complement": "Indirizzo aggiuntivo",
    "appshell-state": "Stato",
    "appshell-province": "Provincia ",
    "appshell-province-choice": "Scelta Stato Provincia",
    "appshell-loading": "Caricamento ",
    "appshell-no-records-found": "Nessun record trovato ",
    "appshell-year": "Anno",
    "appshell-years": "Anni",
    "appshell-max-2-characters": "Massimo 2 caratteri ",
    "top-menu--connect--real-time-support--success-coaches--title": "Business Coach",
    "enom-alert-info-6": "Assicurati di verificare l'indirizzo e-mail utilizzato per l'acquisto nell'e-mail inviata alla tua casella di posta. La mancata verifica dell'e-mail entro 2 settimane dall'acquisto comporterà la disattivazione del dominio.",
    "avatar-send-a-message-to-your-sponsor": "Invia un messaggio al tuo sponsor",
    "avatar-type-your-message-below": "Inserisci il tuo messaggio qui sotto",
    "avatar-enter-message-textarea": "Inserisci il messaggio",
    "avatar-send-message-to-sponsor-send-btn": "Invia",
    "header-menu--unpause-account--title": "annullare la pausa",
    "header-menu--unpause-account--message": "Il tuo account è attualmente in pausa e l'accesso è limitato. Disattiva subito il tuo account.",
    "welcome-new-account": "Benvenuto nel tuo nuovo account!",
    "you-just-new-domain": "Hai appena acquistato un nuovo dominio da noi.",
    "access-free-trial": "Ora hai anche accesso alla nostra <b>prova gratuita premium di 14 giorni>.",
    "create-and-connect": "Crea e connetti",
    "create-and-connect-desc": "Impara a creare un sito web e a collegare il tuo dominio per iniziare il tuo viaggio in Builderall.",
    "watch-tutorial": "Guarda il tutorial",
    "plan-upgrade": "Aggiornamento del piano",
    "plan-upgrade-desc": "Vuoi saltare il periodo di prova? Consulta i nostri piani di aggiornamento.",
    "see-plans": "Vedi Piani",
    "external-domain": "Dominio esterno",
    "external-domain-desc": "Vuoi utilizzare il tuo dominio all'esterno? Contatta uno dei nostri operatori per saperne di più.",
    "talk-to-support": "Parla con il supporto",
    "access-knowledgebase": "Vuoi saperne di più? Accedi alla nostra <b>KnowledgeBase</b>",
    "appshell-already-have-account": "Hai già un account?",
    "appshell-login": "Accesso",
    "appshell-ba-terms-1": "Procedendo con la registrazione, l'utente accetta che Builderall",
    "appshell-single-terms-of-use": "Condizioni di utilizzo",
    "appshell-privacy-policy": "Privacy Policy",
    "appshell-ba-terms-2": "e la creazione di un account di prova gratuito.",
    "appshell-and": "e",
    "appshell-complete-the-fields-correctly": "Completare correttamente i campi",
    "appshell-quotas-80-alert": "Hai utilizzato oltre l'80% dei limiti del piano standard. Il superamento dei limiti può comportare un aumento della fattura.",
    "appshell-quotas-100-alert": "Hai superato i limiti del piano standard.",
    "appshell-click-here-preview-bill": "Fai clic qui per visualizzare l'anteprima della fattura in arrivo",
    "appshell-view-usage": "Visualizzazione dell'utilizzo",
    "top-menu--university--training--email-marketing-mastery-course--title": "Corso di perfezionamento sull'email marketing",
    "top-menu--university--training--email-marketing-mastery-course--description": "Scopri i segreti per convertire il 60% in più con l'email marketing senza bisogno di annunci costosi.",
    "top-menu--tools--legacy--seo-report--title": "Rapporto SEO",
    "top-menu--tools--legacy--social-autopost--title": "App Social Autopost",
    "top-menu--tools--legacy--website-agency--title": "Sito web Agenzia",
    "top-menu--tools--legacy--branding-designs--title": "Mockup Studio",
    "top-menu--tools--legacy--clickmap--title": "ClickMap",
    "top-menu--tools--legacy--helpdesk--title": "HelpDesk",
    "top-menu--tools--core--title": "Core",
    "sent-emails-mo": "Max Email inviate /mese",
    "file-exceed-limit": "La dimensione del file supera il limite (50MB)",
    "upload-file": "Caricare il file",
    "select-folder-to-save": "Selezionare la cartella in cui salvare il file.",
    "folders": "Cartelle",
    "cancel-btn": "ANNULLARE",
    "save-btn": "SALVA",
    "directory-create": "Creazione della directory",
    "delete-folder": "Cancellare la cartella",
    "delete-folder-confirm": "Sei sicuro di voler eliminare la cartella [{delete_folder}] e tutto il suo contenuto?",
    "delete-btn": "CANCELLARE",
    "move-file": "Spostare i file",
    "delete-file": "Eliminare i file",
    "delete-file-confirm": "Sei sicuro di voler eliminare i file?",
    "global-file-repository": "Archivio file globale",
    "new-upload": "NUOVO CARICAMENTO",
    "new-folder": "NUOVA CARTELLA",
    "top-menu--tools--professional-email--title": "Email professionale",
    "top-menu--connect--help--builderall-learn--title": "Imparare Builderall",
    "grid-view": "Schermata a griglia",
    "list-view": "visualizzazione elenco",
    "reload-content": "ricaricare il contenuto",
    "show-asc": "ordine ascendente",
    "show-desc": "ordine decrescente",
    "move-files-to": "spostare i file",
    "delete-files": "Eliminare i file",
    "show-all": "mostra tutti",
    "show-image": "immagine",
    "show-sound": "suono",
    "show-video": "film",
    "show-gif": "gif",
    "show-others": "altri",
    "delete-files-permanently": "I file eliminati verranno rimossi definitivamente dopo 30 giorni.",
    "Formats allowed by the application: ": "Formati consentiti dall'applicazione:",
    "formats-allowed": "Formati consentiti dall'applicazione:",
    "restore": "ripristinare",
    "enom-alert-info7": "Il prezzo del dominio viene visualizzato in dollari USA.",
    "General": "Generale",
    "top-menu--tools--livechat--title": "Chat live di Builderall",
    "global-script--installed-description": "Il tuo sito web ha già installato lo script, quindi puoi saltare questo passaggio.",
    "apply": "Applica",
    "files-are-not-format": "Uno o più file non sono in un formato supportato da questa applicazione e non possono essere utilizzati.",
    "top-menu--tools--exit-pop-up--title": "Pop-up di uscita",
    "top-menu--tools--instagram-autorespond--title": "Risponditore automatico di meta-commenti",
    "top-menu--tools--instagram-autoresponder-1--title": "Risponditore automatico di meta-commenti",
    "top-menu--tools--exit-popup--title": "Popup di uscita",
    "top-menu--tools--meta-comment-autoresponder--title": "Commenti Risponditore",
    "left-menu--history--livechat--title": "Chat Live",
    "left-menu--history--exit-popup--title": "Popup ad Uscita",
    "left-menu--history--meta-comment-autoresponder--title": "Autorisponditore per Commenti",
    "file-exceed-limit-to-upload": "Le dimensioni del file superano il limite di memoria disponibile",
    "apply-coupon": "Apply Coupon",
    "view-resources": "View Resources",
    "top-menu--university--training--marketing-machine-resources--title": "Marketing Machine - Risorse",
    "top-menu--university--training--marketing-machine-resources--description": "Ottenete l'accesso a tutte le risorse necessarie per creare la vostra Ultimate Marketing Machine con Builderall.",
    "rename-file": "Rename File",
    "top-menu--connect--help--upwork--title": "Builderall x Upwork Partner",
    "left-menu--business-center--my-brands--title": "I miei brand",
    "left-menu--business-center--my-brands--subtitle": "Crea, gestisci e organizza i tuoi brand",
    "left-menu--business-center--my-files--title": "I miei file",
    "left-menu--business-center--my-files--subtitle": "Accedi ai tuoi file multimediali con il Business Toolkit",
    "toolkit-home": "Home",
    "toolkit-my-files": "I miei file",
    "toolkit-my-brands": "I miei brand",
    "toolkit-upload": "Carica",
    "toolkit-ai-builder": "AI Creator",
    "toolkit-coming-soon": "Prossimamente",
    "toolkit-resume": "Il tuo Business Toolkit è il Luogo in cui Gestisci I Tuoi File, Risorse del Brand e Contenuti Personalizzati",
    "toolkit-close-toolkit": "Chiudi il Toolkit",
    "toolkit-new-brand": "Nuovo Brand",
    "toolkit-brand-name": "Nome del Brand",
    "toolkit-brand-logo": "Logo del Brand",
    "toolkit-or": "Oppure",
    "toolkit-select-image": "Seleziona Immagine",
    "toolkit-website-url": "URL del Sito Web",
    "toolkit-cancel": "Annulla",
    "toolkit-save": "Salva",
    "toolkit-delete": "Elimina",
    "toolkit-move": "Sposta",
    "toolkit-new-folder": "Nuova cartella",
    "toolkit-move-files": "Sposta i file",
    "toolkit-rename-file": "Rinomina il file",
    "toolkit-new-content": "Nuovo Contenuto",
    "toolkit-search": "Cerca",
    "toolkit-all": "Tutti",
    "toolkit-question-delete-files": "Sei sicuro di voler eliminare il(i) file?",
    "tookit-delete-folder": "Elimina cartella",
    "tookit-delete-brand": "Elimina marca",
    "toolkit-info-trash-30-days": "I file eliminati verranno rimossi definitivamente dopo 30 giorni",
    "toolkit-info-brand-trash-30-days": " I brand eliminati verranno rimossi definitivamente dopo 30 giorni.",
    "toolkit-select-all": "Seleziona tutto",
    "toolkit-days": "giorni",
    "tookit-empty-files-brand": "Ancora nessun file. Clicca per aggiungere contenuti e avviare il tuo brand",
    "toolkit-no-files-yet": "Ancora nessun file.",
    "toolkit-no-files-yet-click-to-add": "Ancora nessun file. Clicca per aggiungere contenuti.",
    "toolkit-new-upload": "Nuovo upload",
    "toolkit-stock-elements": "Elementi in stock",
    "toolkit-size-largest": "Dimensione (più grande)",
    "toolkit-size-smallest": "Dimensione (più piccola)",
    "toolkit-ascending": "Ascendente",
    "toolkit-descending": "Discendente",
    "toolkit-show-all": "Mostra tutti",
    "toolkit-image": "Immagine",
    "toolkit-info-upload-max-size": "Carica il tuo file. Massimo 50 MB",
    "toolkit-audio": "Audio",
    "toolkit-video": "Video",
    "toolkit-others": "Altri",
    "toolkit-gif": "Gif",
    "toolkit-error-to-move": "Errore durante lo spostamento di uno o più file",
    "toolkit-success-to-move": "File spostati con successo",
    "toolkit-error-to-add": "Errore durante l'aggiunta di uno o più file",
    "toolkit-success-to-add": "File aggiunti con successo",
    "toolkit-error-to-brand-merge": "Errore durante la fusione delle marche",
    "toolkit-error-upload-file": "Errore durante il caricamento del file",
    "toolkit-brands": "Marche",
    "toolkit-error-to-delete": "Errore durante l'eliminazione di uno o più file",
    "toolkit-success-to-delete": "File eliminati con successo",
    "toolkit-success-upload": "Caricato con successo",
    "toolkit-enter-brand-name": "Inserisci un nome per il tuo nuovo brand",
    "toolkit-invalid-url": "URL non valida",
    "toolkit-enter-folder-name": "Inserisci un nome per la tua nuova cartella",
    "toolkit-folder-already-exists": "Esiste già una cartella con questo nome. Prova un altro",
    "toolkit-folder-cannot-50c": "Il nome della cartella non può superare i 50 caratteri",
    "toolkit-error-to-restore": "Errore durante il ripristino di uno o più file",
    "toolkit-success-to-restore": "File ripristinati con successo",
    "toolkit-deleted": "Eliminato",
    "toolkit-no-deleted-files-yet": "Ancora nessun file eliminato.",
    "toolkit-name": "Nome del brand",
    "toolkit-select": "Seleziona",
    "toolkit-update-brand": "Aggiorna marca",
    "toolkit-delete-folder": "Elimina cartella",
    "toolkit-question-delete-folder": "Sei sicuro di voler eliminare la cartella [FOLDER_NAME] e il suo contenuto?",
    "toolkit-brand-merge": "Unisci",
    "toolkit-question-delete-brand": "Are you sure you want to delete the brand [BRAND_NAME] ?",
    "toolkit-delete-file": "Elimina file",
    "toolkit-upload-file": "Carica file",
    "toolkit-select-folder-to-upload-file": "Seleziona la cartella in cui desideri salvare il file.",
    "toolkit-add-to-brand": "Aggiungi alla marca",
    "toolkit-add": "Aggiungi",
    "toolkit-merge": "Unisci",
    "toolkit-no-deleted-brands-yet": "Nessuna marca eliminata finora.",
    "toolkit-restore": "Ripristina",
    "toolkit-remove-from-brand": "Rimuovi dal brand",
    "toolkit-question-unlink-file-brand": "Sei sicuro di voler rimuovere questo file da [BRAND_NAME]?",
    "toolkit-remove": "Rimuovi",
    "toolkit-success-to-merge-brand": "Brand unito con successo",
    "toolkit-success-to-link-file": "File collegato con successo",
    "toolkit-error-to-link-file": "Errore nel collegamento del file",
    "toolkit-success-to-create-brand": "Marchio creato con successo",
    "toolkit-error-to-create-brand": "Errore nella creazione del marchio",
    "toolkit-success-to-update-brand": "Marchio aggiornato con successo",
    "toolkit-error-to-update-brand": "Errore nell'aggiornamento del marchio",
    "toolkit-success-to-create-folder": "Cartella creata con successo",
    "toolkit-error-to-create-folder": "Errore nella creazione della cartella",
    "toolkit-success-to-delete-folder": "Cartella eliminata con successo",
    "toolkit-error-to-delete-folder": "File rinominato con successo",
    "toolkit-success-to-rename-file": "File renamed successfully",
    "toolkit-error-to-rename-file": "Errore nella rinominazione del file",
    "toolkit-success-to-delete-file": "File eliminato con successo",
    "toolkit-error-to-delete-file": "Errore nell'eliminazione del file",
    "toolkit-success-to-delete-brand": "Marchio eliminato con successo",
    "toolkit-error-to-delete-brand": "Errore nell'eliminazione del marchio",
    "toolkit-success-to-unlink-file": "File scollegato con successo",
    "toolkit-error-to-unlink-file": "Errore nello scollegamento del file",
    "scheduled-maintenance-notice-2025-04-18": "Eseguiremo interventi di manutenzione programmata il giorno 18/04/2025 tra le 09:00 e le 11:00 CET. Durante questo intervallo, i nostri servizi potrebbero subire un interruzione di circa 15 minuti, insieme a possibili brevi periodi di instabilità per tutta la durata dell'intervento.\n<br>\nStrumenti interessati: Site Builder (server USA), Mailingboss, WordPress Legacy e WhatsApp Central.",
    "dashboard-filter-alphabetical": "Alfabeticamente",
    "dashboard-filter-date": "Data",
    "ct-add": "Aggiungi",
    "ct-my-sites": "I Miei Siti",
    "ct-create-website": "Crea nuovo sito",
    "ct-page-create": "Crea nuova pagina",
    "ct-page-edit": "Modifica pagina",
    "ct-edit-website": "Modifica Sito",
    "ct-delete": "Elimina",
    "ct-edit": "Modifica",
    "ct-domain-connect": "Connettere dominio/sottodominio (usare solo domini con ns3 e ns4 o ns5 e ns6 o NS7 e NS8)",
    "ct-domain-desconnect": "Disconnettere dominio",
    "ct-go-to-website": "Vai al sito",
    "ct-publish": "Pubblica",
    "ct-categories": "Categorie",
    "ct-category-new": "Nuova Categoria",
    "ct-alphabetical": "Alfabeticamente",
    "ct-creation": "Creazione",
    "ct-search": "Ricerca",
    "ct-cancel": "Annulla",
    "ct-all": "Tutti",
    "ct-settings": "Impostazioni",
    "ct-image-share-add": "Aggiungere Immagine di Condivisione",
    "ct-image-share-edit": "Modifica immagine di Condivisione",
    "ct-enter-editor": "Modifica pagina",
    "ct-website-settings": "Impostazione Sito",
    "ct-back-home": "Torna alla home",
    "ct-items-edit": "Modifica Popup",
    "ct-personal": "Personale",
    "ct-panel": "Pannello",
    "ct-elements": "Elementi",
    "ct-font": "Font",
    "ct-blank-panel": "Pannello Vuoto",
    "ct-bg-color": "Colore Sfondo",
    "ct-bg-color-hover": "Colore Sfondo al passaggio del mouse",
    "ct-general-settings": "Impostazioni Generali",
    "ct-opacity": "Opacità",
    "ct-size": "Dimensione",
    "ct-width": "Larghezza",
    "ct-height": "Altezza",
    "ct-border": "Bordo",
    "ct-boxShadow": "Ombra",
    "ct-shadow": "Ombra",
    "ct-borderRadius": "Raggio Bordo",
    "ct-radius": "Raggio Bordi",
    "ct-boxShadowInset": "Ombra interna",
    "ct-color": "Colore",
    "ct-animation": "Animazione",
    "ct-time": "Tempo",
    "ct-click": "Clic",
    "ct-hover": "Al passaggio del mouse",
    "ct-timeToStart": "E' ora di iniziare",
    "ct-effect": "Effetto",
    "ct-infinite": "Infinito",
    "ct-speed": "Velocità",
    "ct-down": "Basso",
    "ct-up": "Sopra",
    "ct-save-element": "Salva elemento",
    "ct-description": "Descrizione",
    "ct-align": "Allineamento",
    "ct-left": "Sinistra",
    "ct-right": "Destra",
    "ct-descending": "Discendente",
    "ct-ascending": "Ascendente",
    "ct-delete-yes": "Si, elimina",
    "ct-change-region": "Cambia Regione",
    "ct-domain": "Dominio",
    "ct-where-publish-region": "Dove dovrebbe essere pubblicato il tuo sito?",
    "ct-publish-confirmed": "Il tuo sito è stato pubblicato",
    "ct-ok": "Ok",
    "ct-publish-error": "E' successo qualcosa durante la pubblicazione del tuo sito, controlla le impostazioni",
    "ct-my-site": "Il mio sito",
    "ct-item-menu": "Elemento menu",
    "ct-sub-item": "Sottoelemento",
    "ct-input-style": "Stile Campo",
    "ct-image": "Immagine",
    "ct-images": "Immagini",
    "ct-invalid-url-regex": "Url non valido, permesse solo lettere, numeri e -\n",
    "ct-website": "Sito",
    "ct-user-settings": "Impostazioni Utente",
    "ct-language": "Lingua",
    "ct-user": "Utente",
    "ct-tutorials": "Tutorial",
    "ct-feedback": "Commenti",
    "ct-report-bug": "Segnala Errore",
    "ct-bg-page": "Sfondo pagina",
    "ct-show-grid-line": "Mostra Griglia",
    "ct-font-family": "Famiglia Font",
    "ct-font-size": "Dimensione Font ",
    "ct-font-size-mobile": "Dimensione del Font su Mobile",
    "ct-line-height": "Altezza linea",
    "ct-style": "Stile",
    "ct-seo-settings": "Impostazioni SEO",
    "ct-initial": "Iniziale",
    "ct-yes": "Si",
    "ct-no": "No",
    "ct-choose": "Scegli",
    "ct-confirm-delete": "Sei Sicuro di Voler Eliminare?",
    "ct-choose-language": "Scegli la tua lingua",
    "ct-adv": "Avanzate & Config. Mobile ",
    "ct-when-visible": "Quando Visibile",
    "ct-slow": "Lenta",
    "ct-slower": "Lentissima",
    "ct-fast": "Veloce",
    "ct-faster": "Velocissimo",
    "ct-items": "Elementi",
    "ct-item": "Elemento",
    "ct-bg-color-active": "Colore Sfondo Attivo",
    "ct-label": "Etichetta",
    "ct-child": "Sottomenu",
    "ct-childs": "Sottomenu",
    "ct-add-field": "Aggiungi Campo",
    "ct-input-height": "Altezza Campo",
    "ct-input-border": "Bordo del Campo",
    "ct-input-bg-color": "Colore dello Sfondo del Campo",
    "ct-show-list-icon": "Mostra Elenco Icone",
    "ct-subtext": "Sottotesto",
    "ct-width-button": "Larghezza Tasto",
    "ct-show-label": "Mostra Etichetta",
    "ct-show-placeholder": "Mostra Testo di Aiuto",
    "ct-text": "Testo",
    "ct-full-width": "Larghezza intera",
    "ct-embed-url": "URL da incorporare",
    "ct-embed-doc": "Codice iframe HTML",
    "ct-validation-required": "Il campo è richiesto.",
    "ct-validation-regex": "Formato invalido.",
    "ct-sub-bg-color": "Colore Sfondo",
    "ct-sub-bg-color-hover": "Colore Sfondo al passaggio del mouse",
    "ct-sub-bg-color-active": "Colore Sfondo attivo",
    "ct-ruler": "Righello",
    "ct-pre-view": "Anteprima",
    "ct-show-hidden-elements": "Mostra Elementi Nascosti",
    "ct-return-edit": "Torna all'Editor",
    "ct-inputRadius": "Raggio",
    "ct-layer": "Posizionamento Livello",
    "ct-warning-save-item": "Ora puoi salvare gli elementi come elementi standard ed averli a disposizione nel menu Personale.",
    "ct-label-save-item": "Salva Elemento",
    "ct-save-element-name-item": "Nome dell'elemento",
    "ct-horizontal-form": "Modulo in Orizzontale",
    "ct-vertical-menu": "Menu Verticale",
    "ct-title-h4": "Testo H4",
    "ct-title-h1": "Testo H1",
    "ct-title-h2": "Testo H2",
    "ct-title-h3": "Testo H3",
    "ct-title-h6": "Testo H6",
    "ct-title-p": "Paragrafo",
    "ct-title-h5": "Testo H5",
    "ct-create-new-popup": "Crea nuovo popup",
    "ct-title": "Testo",
    "ct-duplicate": "Duplica",
    "ct-transfer-choose-option": "Scegli il tipo di trasferimento",
    "ct-transfer-only": "Solo trasferimento",
    "ct-transfer-duplicate": "Duplica il sito e trasferiscilo",
    "ct-hide-ruler": "Nascondi Righello",
    "ct-success-false": "Errore",
    "ct-success-true": "Successo",
    "ct-validation-email": "La Email deve essere un indirizzo email valido",
    "ct-invalid-url-page-regex": "URL non valida, permesse solo lettere, numeri e -",
    "ct-hide-grid-line": "Nascondi le Linee della Griglia",
    "ct-go-to-website-page": "Vai alla pagina del sito",
    "ct-not-now": "Non adesso!",
    "ct-thats-fine": "Si va bene!",
    "ct-saved": "Salvato!",
    "ct-do-want-publish-website": "Vuoi pubblicare questo sito?",
    "ct-close": "Chiudi",
    "ct-dont-show-again": "Non mostrare più",
    "gdpr-accept-btn-label-app": "Accetto i Cookies",
    "ct-preview": "Anteprima",
    "ct-body": "Body",
    "ct-footer": "Footer",
    "ct-header": "Header",
    "ct-back": "Indietro",
    "gdpr-title-app": "Cookies & Privacy",
    "gdpr-message-app": "Questo Sito Fa Uso Di Cookies Per Migliorare L’esperienza Di Navigazione Degli Utenti E Per Raccogliere Informazioni Sull’utilizzo Del Sito Stesso. Configura i Cookies e poi clicca su Accetta se vuoi continuare la navigazione in questo sito. Per maggiori informazioni clicca qui:",
    "gdpr-more-info-label-app": "Più Informazioni",
    "gdpr-advanced-btn-label-app": "Configura i Cookie",
    "gdpr-cookie-types-title-app": "Selezionare i Cookie Da Accettare",
    "gdpr-fixed-cookie-type-label-app": "Necessario",
    "gdpr-fixed-cookie-type-desc-app": "Questi Sono I Cookie Che Sono Essenziali Per Far Funzionare Correttamente Il Sito Web .",
    "gdpr-cookie-types-preferences-type-app": "Preferenze Del Sito",
    "gdpr-cookie-types-preferences-desc-app": "Questi Sono I Cookies Che Sono Legati Alle Vostre Preferenze Del Sito, Per Esempio Ricordano La Lingua, La Nazione, Etc.",
    "gdpr-cookie-types-analytics-type-app": "Statistiche",
    "gdpr-cookie-types-analytics-desc-app": "I Cookie Relativi A Visite Locali, Tipi Di Browser, Etc",
    "gdpr-cookie-types-marketing-type-app": "Marketing",
    "gdpr-cookie-types-marketing-desc-app": "I Cookie Legati Al Marketing, Per Esempio Newsletter, Social Media, Etc",
    "ct-gdpr-reload-language": "Ricarica Lingua",
    "ct-gdpr-colors": "Colori",
    "ct-gdpr-background-color": "Colore Di Sfondo",
    "ct-gdpr-color-title": "Colore Del Titolo",
    "ct-gdpr-color-paragraph": "Colore Del Paragrafo",
    "ct-gdpr-color-link": "Colore Link \"Più Informazioni\"",
    "ct-gdpr-button-background": "Sfondo del Tasto Accetta",
    "ct-gdpr-button-color": "Colore Tasto Hover",
    "ct-gdpr-button-advanced-bg": "Sfondo del Tasto Avanzate",
    "ct-gdpr-button-advanced-color": "Colore Del Testo Avanzate",
    "ct-gdpr-title": "Testo",
    "ct-gdpr-message": "Messaggio",
    "ct-gdpr-accept-btn-label": "Testo Del Tasto Accetta",
    "ct-gdpr-more-info": "Descrizione Del Tasto Maggiori Informazioni",
    "ct-gdpr-more-link": "Url Del Tasto Maggiori Informazioni",
    "ct-gdpr-advanced-btn-label": "Tasto Di Personalizzazione Cookies",
    "ct-gdpr-cookie-types-title": "Personalizzazione Di Cookies",
    "ct-gdpr-fixed-title": "Testo del Tipo Cookie: Necessario",
    "ct-gdpr-preferences-message": "Descrizione Tipo Cookie: Preferenze",
    "ct-gdpr-analytics-title": "Testo Del Tipo Cookie: Statistiche",
    "ct-gdpr-marketing-type": "Descrizione Tipo Cookie: Marketing",
    "ct-gdpr-fixed-type": "Testo Del Tipo Cookie: Necessario",
    "ct-gdpr-fixed-message": "Descrizione Tipo Cookie: Necessario",
    "ct-gdpr-preferences-title": "Testo Del Tipo Cookie: Preferenze",
    "ct-gdpr-preferences-type": "Descrizione Delle Preferenze",
    "ct-gdpr-analytics-type": "Testo Del Tipo Cookie: Statistiche",
    "ct-gdpr-analytics-message": "Descrizione Tipo Cookie: Statistiche",
    "ct-gdpr-marketing-title": "Testo Del Cookie Tipo: Marketing",
    "ct-gdpr-marketing-message": "Descrizione Tipo Cookie: Marketing",
    "ct-gdpr-settings": "Impostazioni GDPR",
    "ct-page-settings": "Pagina",
    "ct-background": "Sfondo",
    "ct-button-headline": "Testo",
    "ct-button-sub-headline": "Sotto-Testo",
    "ct-simpleform": "Modulo Semplice",
    "ct-Button": "Tasto",
    "ct-gdpr-additional-texts": "Testo addizionale",
    "ct-font-style": "Stile Font",
    "ct-popup-settings": "Impostazioni Popup",
    "ct-desktop": "Desktop",
    "ct-mobile": "Mobile",
    "ct-which-popup": "Quale è il Popup?",
    "ct-popup-empty": "Nessun Popup Selezionato",
    "ct-type-of-popup": "Tipo di Popup",
    "ct-time-popup-min": "Minuti",
    "ct-time-popup-sec": "Secondi",
    "ct-scroll-popup-value": "Percentuale Scroll per apertura pop-up",
    "ct-time-popup": "Popup a tempo",
    "ct-exit-popup": "Popup ad Uscita",
    "ct-scroll-popup": "Popup basato su Scroll",
    "ct-gdpr-active": "Attiva",
    "ct-language-success": "Lingua ricaricata correttamente!",
    "ct-gdpr": "GDPR",
    "ct-gdpr-texts": "Testi",
    "cheetah-category-template-1": "Novità",
    "ct-gdpr-position": "Posizione",
    "ct-gdpr-colors-and-position": "Colori e Posizione",
    "ct-gdpr-position-top-left": "In alto a Sinistra",
    "ct-gdpr-position-top-right": "In altro a Destra",
    "ct-gdpr-position-full-top": "In alto",
    "ct-gdpr-position-full-bottom": "In basso",
    "ct-gdpr-position-center-center": "Al Centro",
    "ct-gdpr-position-bottom-left": "In basso a Sinistra",
    "ct-gdpr-position-bottom-right": "In basso a Destra",
    "ct-save-personal-element": "Salva come Elemento Personale",
    "ct-component-BoxComponent": "Box",
    "ct-component-ButtonComponent": "Tasto",
    "ct-component-MailingBossFormComponent": "Modulo Mailing Boss",
    "ct-component-SimpleFormComponent": "Modulo Contatto",
    "ct-component-IframeComponent": "Iframe(Box HTML)",
    "ct-component-ImageComponent": "Immagine",
    "ct-component-LineComponent": "Linea",
    "ct-component-MenuComponent": "Menu",
    "ct-component-PanelComponent": "Pannello",
    "ct-component-TextComponent": "Testo",
    "ct-component-YoutubeVideoComponent": "Video Youtube",
    "ct-you-are-editing": "Stai modificando:",
    "cheetah-template-9506": "Pulizia Dentale e Controllo",
    "ct-alll-templates": "Tutti",
    "ct-choose-a-template": "Seleziona un Template",
    "ct-blank-template": "Template Vuoto",
    "cheetah-template-9594": "Business",
    "cheetah-template-9595": "WebDesigner",
    "cheetah-template-9618": "Cura dell'Auto",
    "cheetah-template-9620": "Chiropratico",
    "cheetah-template-9621": "Impianti Dentali",
    "cheetah-template-9623": "Avvocato Divorzista",
    "cheetah-template-9627": "Rifacimento",
    "cheetah-template-9629": "Webinar Funnel",
    "ct-success-action": "Fatto",
    "ct-transfer-invalid-user-email": "Non esiste un account Cheetah con questa email",
    "ct-component-VimeoVideoComponent": "Video Vimeo",
    "ct-transfer": "Trasferisci",
    "ct-disconnect-domain-before-delete": "Disconnetti il dominio prima di cancellarlo!",
    "ct-do-you-want-save-site": "Vuoi salvare il sito?",
    "bg-color-text-hover": "Colore Testo al passaggio del mouse",
    "ct-resource-bg-color": "Colore Sfondo",
    "ct-resource-bg-color-hover": "Colore Sfondo al passaggio del mouse",
    "ct-resource-bg-text-hover": "Colore Testo al passaggio del mouse",
    "ct-font-style-family": "Famiglia Font",
    "ct-font-style-size": "Dimensione Font",
    "ct-font-style-color": "Colore",
    "ct-font-style-size-mobile": "Dimensione Font Mobile",
    "ct-arrow-left": "Freccia sinistra",
    "ct-anchor": "Ancora",
    "ct-fixed": "Fissaggio",
    "ct-minHeight": "Altezza Minima",
    "ct-panel-1st-fold": "1° Blocco",
    "ct-panel-blocks": "Blocchi",
    "ct-panel-call-to-action": "Chiamata all'azione",
    "ct-panel-contacts": "Contatti",
    "ct-panel-contents": "Contenuti",
    "ct-panel-features": "Caratteristiche",
    "ct-panel-footer": "Footer",
    "ct-panel-funnel": "Funnel",
    "ct-panel-header": "Header",
    "ct-panel-pricing-table": "Tabella Prezzi",
    "ct-panel-team": "Team",
    "ct-panel-testimonials": "Testimonianze",
    "ct-element-texts": "Testi",
    "ct-element-box": "Box",
    "ct-element-button": "Tasto",
    "ct-element-contact-form": "Modulo di Contatto",
    "ct-element-email-marketing-form": "Modulo Email Marketing",
    "ct-element-iframe": "Iframe(Box HTML)",
    "ct-element-image": "Immagine",
    "ct-element-menu": "Menu",
    "ct-element-text": "Testi",
    "ct-element-video": "Video",
    "ct-resource-image-upload": "Carica",
    "ct-resource-image-all": "Tutto",
    "ct-active": "Attivo",
    "ct-layer-level": "Livello:",
    "ct-sticky-header": "Header Fissato in alto",
    "ct-active-desktop": "Attivo su Desktop",
    "ct-active-mobile": "Attivo su Mobile",
    "ct-open-in-another-page": "Apri in un'altra pagina",
    "ct-open-in-same-page": "Apri nella stessa pagina",
    "ct-page-name": "Nome Pagina",
    "ct-url": "URL",
    "ct-input-label-color": "Colore Etichetta di Input",
    "ct-bg-color-text-hover": "Colore Testo al passaggio del mouse",
    "ct-icon": "Icona",
    "ct-padding": "Spaziatura",
    "ct-select": "Seleziona",
    "ct-email-receiver": "Email del Ricevente",
    "ct-subject": "Soggetto",
    "ct-action": "Azione",
    "ct-action-url": "URL Azione",
    "ct-fields": "Campi",
    "ct-type": "Tipo",
    "ct-tag": "Tag",
    "ct-default-value": "Valore di default",
    "ct-required": "Richiesto",
    "ct-visibility": "Visibilità",
    "ct-visible": "Visibile",
    "ct-hidden": "Nascosto",
    "ct-help-text": "Testo di Aiuto",
    "ct-options": "Opzioni",
    "ct-value": "Valore",
    "ct-resource-external-image": "Immagine Esterna",
    "ct-resource-apply": "Applica",
    "ct-margin": "Margine",
    "ct-sub-menus": "Sotto Menu",
    "ct-sub-menu": "Sotto Menu",
    "ct-target": "Target",
    "ct-reset-action": "Resetta Azione",
    "ct-apply": "Applica",
    "ct-youtube-embed-url": "Url Embed",
    "ct-fonts": "Fonts",
    "ct-component-TimerComponent": "Timer",
    "ct-option-timer-theme-panels": "Pannelli",
    "ct-option-timer-theme-circles": "Cerchi",
    "ct-option-timer-theme-squares": "Quadrato",
    "ct-option-timer-theme-text": "Testo",
    "ct-option-timer-theme-simple": "Semplice",
    "ct-option-timer-theme-pill": "Pillola",
    "ct-option-timer-type-until-date-specifies": "Data e Ora ",
    "ct-option-timer-type-sum-interval-hours": "Conto alla rovescia",
    "ct-option-timer-type-evergreen": "Evergreen",
    "ct-option-timer-type-sum-time-user": "Riavvia Timer",
    "ct-textDescription": "Testo descrizione",
    "ct-theme": "Tema",
    "ct-resource-bg-color-effect": "Colore Effetto dello Sfondo",
    "ct-resource-font-color": "Colore Font",
    "ct-resource-font-label-color": "Colore Font Etichetta",
    "ct-resource-font-desc-color": "Colore Font Descrizione",
    "ct-date-end": "Data di fine",
    "ct-supercheckout": "Super Checkout",
    "cheetah-template-12145": "Pagina Optin/Squeeze",
    "cheetah-template-12150": "Pagina Optin/Squeeze",
    "ct-arrow-size": "Dimensione Freccia",
    "ct-arrow-color": "Colore Freccia",
    "ct-component-LineVComponent": "Linea Verticale",
    "ct-alt": "Alt",
    "ct-redirect-url": "URL di Redirect Dopo L'Invio",
    "burguerMenu": "Burguer Menu",
    "ct-burguer-menu": "Burguer Menu",
    "ct-arrow-right": "Freccia Destra",
    "ct-arrow-top": "Freccia Su",
    "ct-arrow-bottom": "Tasto Freccia",
    "ct-spacing": "Spazio",
    "cheetah-template-7268": "cheetah-template-7268",
    "cheetah-template-8087": "Funnel Immobiliare - Guida per Acquirenti Case",
    "cheetah-template-7238": "Funnel Immobiliare - Quiz Acquirenti Case",
    "cheetah-template-7743": "Funnel Immobiliare - Marketing Affitti",
    "cheetah-template-7186": "Funnel Immobiliare",
    "cheetah-template-8091": "Funnel Immobiliare - Calcola il valore della casa",
    "cheetah-template-7217": "Funnel Immobiliare - Generazione Clienti Potenziali",
    "cheetah-template-8111": "Allenamento Funzionale",
    "cheetah-template-8093": "Botox",
    "cheetah-template-8262": "Pittura e Vino",
    "cheetah-template-8101": "Personal Trainer",
    "cheetah-template-8318": "Yoga",
    "ct-new-directory": "Nuova cartella",
    "ct-my-files": "I miei File",
    "ct-create-new-directory": "Crea nuova cartella",
    "ct-move": "Sposta",
    "ct-neutral": "Neutro",
    "ct-tag-config": "Configurazione Tag",
    "ct-joyride-skip-tour": "Salta il Tour",
    "ct-joyride-previous": "Precedente",
    "ct-joyride-next": "Avanti",
    "ct-joyride-finish": "Finito",
    "ct-joyride-panel-components-right": "Ecco la tua barra principale, per la personalizzazione e l'aggiunta di elementi, qui troverai tutto il necessario per creare il tuo sito.",
    "ct-joyride-add-panel": "Cliccando su questo menu sarai in grado di aggiungere blocchi ed elementi.\n",
    "ct-joyride-add-panel-action": "Cliccando sui blocchi avrai numerosi blocchi pre-assemblati e il pannello vuoto",
    "ct-joyride-add-panel-action-list": "Questo è l'elenco di blocchi, separati da categorie, per una facile ricerca, per aggiungerne uno basta fare clic e verrà automaticamente aggiunto al tuo sito, per gli elementi, è necessario trascinare e rilasciare l'elemento esattamente dove vogliamo posizionarlo.",
    "ct-joyride-top-menu-left": "Ecco l'area dove è possibile cambiare visualizzazione e dove offrire un caffè ai nostri sviluppatori\n",
    "ct-joyride-top-menu-right": "Ecco l'area in cui è possibile visualizzare gli elementi nascosti, abilitare e disabilitare il righello e le linee della griglia, visualizzare in anteprima il lavoro e salvare e pubblicare il sito Web.\n",
    "ct-element-lines": "Linee",
    "ct-element-timer": "Timers",
    "ct-all-files": "Tutti i file",
    "ct-tab-file-images-user": "File utente",
    "ct-helper-type-files-accept-images": "Puoi caricare immagini in formato .ICO.",
    "ct-tab-file-images-images": "Immagini",
    "ct-directory-create": "Crea Directory",
    "ct-directory-edit": "Modifica Directory",
    "ct-tab-file-images-icons": "Icone",
    "ct-tab-file-images-buttons": "Tasti",
    "ct-tab-file-images-gifs": "Gif",
    "ct-directory-image-is-empty": "La Directory è vuota",
    "ct-directory-image-search-not-found": "Nessuna immagine trovata",
    "ct-minimun-size": "Dimensione Minima su Mobile",
    "ct-uploading-file": "File in caricamento",
    "ct-select-file": "Seleziona file",
    "ct-file-name": "Nome File:",
    "ct-directory-name": "Nome Directory:",
    "ct-deleted": "Eliminato",
    "ct-moved": "Spostato",
    "ct-with-success": "con successo",
    "ct-created": "Creato",
    "ct-directory": "Directory",
    "ct-file": "File",
    "ct-edited": "modificato",
    "ct-images-file-edit": "Modifica il nome del file",
    "cheetah-template-8544": "Impianti Dentali",
    "cheetah-template-8395": "Avvocato lesioni personali",
    "cheetah-template-8438": "Acquirente di casa ipoteca",
    "cheetah-template-8826": "Consulente finanziario",
    "cheetah-template-8695": "Dottore",
    "cheetah-template-8538": "052 - Chiropratico Valutazione del Dolore",
    "cheetah-template-8515": "056 - Avvocato Divorzista",
    "cheetah-template-13930": "056 - Avvocato divorzista",
    "cheetah-template-8592": "Cura della casa",
    "cheetah-template-8081": "Chirurghi Plastici",
    "cheetah-template-8380": "Ortodontista",
    "cheetah-template-8308": "029 - Calcolatrice del Concessionario Auto",
    "cheetah-template-8192": "Funnel Immobiliare - Generazione Potenziali Acquirenti SMS",
    "cheetah-template-8296": "Cura delle vetture",
    "cheetah-template-8266": "Broker Ipotecario",
    "cheetah-template-8250": "Scuola di Arti Marziali BR",
    "cheetah-template-8273": "Sculture Fantastiche",
    "cheetah-template-8558": "Salone",
    "cheetah-template-8201": "039 - Med Spa Facciale",
    "cheetah-template-8104": "Immobiliare Quiz per Venditori",
    "ct-create": "Crea",
    "ct-share-img-info": "Per l'immagine di condivisione raccomandiamo la dimensione di  1200 x 628 pixel. ",
    "ct-files-name": "Nomi File",
    "ct-move-files": "Sposta i file",
    "cheetah-category-template-3": "Nuovi",
    "cheetah-template-13656": "Pulizia e Checkup Odontotecnica",
    "cheetah-template-13789": "Agenzia Immobiliare - Lista di Case in Vendita per Acquirenti e Compratori",
    "cheetah-template-14332": "Agenzia Immobiliare - Guida agente immobiliare",
    "cheetah-template-14402": "Agenzia Immobiliare - Guida dell'Acquirente",
    "cheetah-template-14357": "Agenzia Immobiliare - Quiz Acquirente",
    "cheetah-template-13679": "Agenti Immobiliari",
    "cheetah-template-14403": "Agenzia Immobiliare - Annuncio di valutazione immobiliare",
    "cheetah-template-14019": "Agenzia Immobiliare",
    "cheetah-template-14342": "Guida agente immobiliare - Lista di invio di WhatsApp",
    "cheetah-template-13765": "Cura delle vetture",
    "cheetah-template-13670": "Scuola di Arti Marziali BR",
    "cheetah-template-13712": "Crossfit",
    "cheetah-template-13738": "Estetista",
    "cheetah-template-13774": "Bagno gratuito per cuccioli",
    "cheetah-template-13724": "025 - Chirurgia estetica riduzione del grasso",
    "cheetah-template-14408": "Applicazione di Botox",
    "cheetah-template-13747": "Apparecchio dentistico",
    "cheetah-template-14362": "Analisi del credito per l'acquisto di auto",
    "cheetah-template-13889": "Corso di pittura con degustazione di vini",
    "cheetah-template-14404": "Personal Trainer",
    "cheetah-template-13785": "Yoga",
    "cheetah-template-13754": "Accademia palestra",
    "cheetah-template-14352": "Salone di Bellezza",
    "cheetah-template-14349": "Trattamento facciale",
    "cheetah-template-13816": "Impianti dentali",
    "cheetah-template-11132": "SitoWeb Agenzia",
    "ct-upload-font": "Carica i tuoi font",
    "ct-label-upload-user-font": "Upload Font",
    "ct-label-upload-font-name": "Nome Font",
    "ct-label-upload-font-file": "File (.ttf, .woff, .woff2)",
    "ct-save-personal-font": "Salva come Font Personale",
    "ct-prefered-language": "La tua lingua preferita",
    "ct-publicados": "Siti Pubblicati",
    "ct-nao-publicados": "Non Pubblicati",
    "ct-component-SliderGalleryComponent": "Slider",
    "ct-component-WebinarVideoComponent": "Webinar",
    "ct-id": "Id",
    "ct-secret": "Secret",
    "ct-component-WistiaVideoComponent": "Wistia",
    "ct-my-pages": "Le mie pagine",
    "ct-unpublish": "Non pubblicare",
    "ct-timer-slider": "Tempo Autoplay",
    "ct-arrow-options-slider": "Frecce di navigazione",
    "ct-auto-play-slider": "Autoplay",
    "ct-restrict-area-create": "Crea Area Riservata",
    "ct-restrict-all": "Tutte le aree riservate",
    "ct-restrict-areas": "Aree Riservate",
    "ct-restrict-area-create-title": "Nome Area Riservata",
    "ct-select-color": "Seleziona Colore",
    "ct-restrict-area-access-release": "Tipologia di sblocco di accesso alle aree Riservate",
    "ct-pages": "Pagine",
    "ct-release-automatically": "Permette automaticamente l'accesso all'area riservata ",
    "ct-manual-payment": "Manuale/Pagamento",
    "ct-automatically-grant-access-partners": "Permette l'accesso automatico ai partner Attivi in Builderall",
    "ct-allow-access-with-confirm-mailingboss": "Permetti l'accesso all'area riservata quando l'utente ha confermato la registrazione tramite email di mailing Boss.",
    "ct-members-area": "Area Riservata",
    "ct-different-layout": "Cambia Visualizzazione",
    "ct-different-layout-alert": "Per una migliore visualizzazione le pagine sono state duplicate, se si effettua una modifica, cambierà su tutte le pagine uguali.",
    "ct-restrict-area-update-title": "Modifica Area Riservata",
    "ct-password": "Password",
    "ct-parallax-effect-scroll": "Scorrimento",
    "ct-parallax-effect-scale": "Scala",
    "ct-parallax-effect-opacity": "Opacità",
    "ct-parallax-effect-scroll-opacity": "Scorrimento-Opacità",
    "ct-parallax-effect-scale-opacity": "Scala-Opacità",
    "ct-parallax-effect": "Effetto",
    "ct-parallax-speed": "Velocità",
    "ct-parallax": "Parallasse",
    "ct-Auto-Play-Youtube": "Auto Play",
    "ct-loop": "Loop",
    "ct-Control-Youtube": "Non visualizzare i controlli",
    "ct-startYoutube": "Inizia a (sec):",
    "ct-endYoutube": "Termina in (sec):",
    "ct-permissions": "Autorizzazione",
    "ct-none": "Nessuna",
    "ct-text-decoration": "Sottolineatura Testo",
    "ct-line-through": "Linea centrale",
    "ct-underline": "Linea Inferiore ",
    "ct-overline": "Linea superiore",
    "ct-members-list-is-empty": "Nessun Membro registrato",
    "cheetah-template-21994": "Teste 01",
    "ct-joyride-add-one-panel": "Aggiungi un Pannello ed inizia a costruire il tuo Sito Web",
    "ct-joyride-add-one-element": "Ottimo Lavoro! Adesso Trascina un Elemento nel Pannello",
    "ct-arrow-active": "Abilita effetti freccia",
    "ct-arrow-size-width": "Larghezza freccia",
    "ct-arrow-size-width-mobile": "Larghezza freccia su Mobile",
    "ct-arrow-size-height": "Altezza freccia",
    "cheetah-template-22606": "Caramelle Sito Express",
    "cheetah-template-22615": "Snacks Sito Express",
    "cheetah-template-22617": "Steak House Sito Express",
    "cheetah-template-22618": "Designer di Interni 03",
    "cheetah-template-22646": "Guida Turistica Sito express",
    "cheetah-template-22647": "Guida Turistica Sito express",
    "cheetah-template-22655": "FoodTruck Sito Express",
    "cheetah-template-22668": "Gelateria Sito Express",
    "cheetah-template-22688": "Analisi Finanziaria Sito Express",
    "cheetah-template-22870": "Negozio di bacche di Acai Sito Express",
    "cheetah-template-22880": "Negozio Caffè Sito Express",
    "cheetah-template-22899": "Ristorante Sito express",
    "cheetah-template-22905": "Bar Sito express",
    "cheetah-template-22908": "Nightclub 03",
    "cheetah-template-23096": "Designer di Interni 02",
    "cheetah-template-23130": "Pizzeria Sito Express",
    "cheetah-template-23140": "Organizzazione Personale Sito Express",
    "cheetah-template-23156": "Pitturazione Sito Express",
    "cheetah-template-23175": "Recupero Crediti Sito Express",
    "cheetah-template-23193": "Muratore Sito Express",
    "cheetah-template-24184": "Coach Finanziario Sito Express",
    "ct-share": "Condividi",
    "cheetah-category-template-4": "Marketing a Risposta Diretta",
    "cheetah-template-24372": "Tema 01 - Sales Page Applicazione",
    "cheetah-template-24392": "Fotografo 02",
    "cheetah-template-24401": "Tema 01 - Pagina Richieste",
    "cheetah-template-24403": "Tema 01 - Bridge Page",
    "cheetah-template-24404": "Tema 01 - Lead Magnet Optin Page",
    "cheetah-template-24405": "Tema 01 - Pagina Area Membership",
    "cheetah-template-24407": "Tema 01 - Pagina One Time Offer (OTO)",
    "cheetah-template-24409": "Tema 01 - Pagina Optin/Squeeze",
    "cheetah-template-24410": "Tema 01 - Pagina Optin Lancio Prodotto",
    "cheetah-template-24411": "Tema 01 - Video Pagina Lancio Prodotto",
    "cheetah-template-24413": "Tema 01 - Optin page Inversa",
    "cheetah-template-24414": "Tema 01 - Thank You Page",
    "cheetah-template-24415": "Tema 01 - VSL + Sales Page Tasto Acquista Ora",
    "cheetah-template-24416": "Tema 01 - Pagina Indottrinamento Webinar",
    "cheetah-template-24418": "Tema 01 - Pagina Registrazione Webinar",
    "cheetah-template-24420": "Tema 01 - Pagina Replica Webinar",
    "cheetah-template-24674": "Coach Perdita di Peso Sito Express",
    "cheetah-template-24697": "Tema 01 - Sales Page Applicazione",
    "cheetah-template-24698": "Tema 02 - Sales Page Applicazione",
    "cheetah-template-24699": "Tema 02 - Pagina \"Questionario\" ",
    "cheetah-template-24700": "Tema 02 - Bridge Page",
    "cheetah-template-24701": "Tema 02 - Lead Magnet Optin Page",
    "cheetah-template-24702": "Tema 02 - Pagina Area Membership",
    "cheetah-template-24703": "Tema 02 - Pagina One Time Offer (OTO)",
    "cheetah-template-24704": "Tema 02 - Pagina Optin/Squeeze",
    "cheetah-template-24705": "Tema 02 - Pagina Optin Lancio Prodotto",
    "cheetah-template-24707": "Tema 02 - Pagina Video Lancio Prodotto",
    "cheetah-template-24708": "Tema 02 - Optin page Inversa",
    "cheetah-template-24709": "Tema 02 - Thank You Page",
    "cheetah-template-24710": "Tema 02 - VSL + Sales Page con Tasto Acquista Ora",
    "cheetah-template-24711": "Tema 02 - Pagina Indottrinamento Webinar",
    "cheetah-template-24712": "Tema 02 - Pagina Registrazione Webinar",
    "cheetah-template-24713": "Tema 02 - Pagina \"Replay Webinar\"",
    "cheetah-template-24819": "Tema 03 - Sales Page Applicazione",
    "cheetah-template-24826": "Tema 03 - Sales Page Applicazione",
    "cheetah-template-24828": "Tema 03 - Pagina Richieste",
    "cheetah-template-24829": "Tema 03 - Bridge Page",
    "cheetah-template-24832": "Tema 03 - Lead Magnet Optin Page",
    "cheetah-template-24833": "Tema 03 - Pagina Area Membership",
    "cheetah-template-24834": "Tema 03 - Pagina One Time Offer (OTO) ",
    "cheetah-template-24836": "Tema 03 - Pagina Optin/Squeeze",
    "cheetah-template-24837": "Tema 03 - Pagina Optin Lancio Prodotto",
    "cheetah-template-24838": "Tema 03 - Pagina Video Lancio Prodotto",
    "cheetah-template-24839": "Tema 03 - Optin Page Inversa",
    "cheetah-template-24841": "Tema 03 - Thank You Page",
    "cheetah-template-24842": "Tema 03 - VSL + Sales Page con Tasto Acquista Ora",
    "cheetah-template-24843": "Tema 03 - Pagina Indottrinamento Webinar ",
    "cheetah-template-24844": "Tema 03 - Pagina Registrazione Webinar",
    "cheetah-template-24845": "Tema 03 - Pagina Replay Webinar",
    "ct-anchor-name": "Nome Ancora",
    "ct-file-label": "File da scaricare (Click per cambiare):",
    "ct-file-download": "Seleziona file",
    "ct-supercheckout-label": "Seleziona il prodotto che vuoi vendere su questo bottone:",
    "ct-refresh-supercheckout": "Ricarica la lista",
    "ct-goto-supercheckout": "Vai al supercheckout",
    "ct-telefone-mask": "Seleziona il formato da dare al tuo numero di telefono",
    "ct-supercheckout-info-name": "Nome Prodotto",
    "ct-supercheckout-info-url": "URL",
    "ct-supercheckout-info-currency": "Valuta",
    "ct-supercheckout-info-pricing": "Prezzo",
    "ct-url-validate-warning": "Questo URL non è corretto",
    "cheetah-template-24948": "Dottori Sito Express",
    "ct-telefone-action": "Numero di telefono da chiamare con questo tasto",
    "ct-telefone-open-as": "Quando i visitatori fanno click su questo tasto dovranno:",
    "ct-telefone-opt-phone": "Chiamata Telefonica",
    "ct-telefone-opt-sms": "Invia SMS",
    "ct-telefone-opt-whatsapp": "Messaggio WhatsApp",
    "cheetah-template-25285": "Tema 04 - Sales Page Applicazione",
    "cheetah-template-25286": "Tema 04 - Sales Page Applicazione",
    "cheetah-template-25287": "Tema 04 - Pagina Richieste",
    "cheetah-template-25288": "Tema 04 - Bridge Page",
    "cheetah-template-25289": "Tema 04 - Pagina Lead Magnet Optin",
    "cheetah-template-25290": "Tema 04 - Pagina Area Membership",
    "cheetah-template-25291": "Tema 04 - Pagina One Time Offer (OTO)",
    "cheetah-template-25293": "Tema 04 - Pagina Optin/Squeeze",
    "cheetah-template-25294": "Tema 04 - Pagina Optin Lancio Prodotto",
    "cheetah-template-25295": "Tema 04 - Pagina Video Lancio Prodotto",
    "cheetah-template-25296": "Tema 04 - Pagina Optin Inversa",
    "cheetah-template-25297": "Tema 04 - Pagina Optin Inversa",
    "cheetah-template-25298": "Tema 04 - Thank You Page",
    "cheetah-template-25299": "Tema 04 - VSL + Sales Page con Tasto Acquista Ora",
    "cheetah-template-25300": "Tema 04 - Pagina Indottrinamento Webinar",
    "cheetah-template-25301": "Tema 04 - Pagina Registrazione Webinar",
    "cheetah-template-25302": "Tema 04- Pagina Replay Webinar",
    "cheetah-template-25315": "Tema 03 - Pagina \"Application Sales\"",
    "cheetah-template-25319": "Commercialisti Sito Express",
    "cheetah-template-25328": "Nutrizionista Sito Express",
    "cheetah-template-25363": "Crossfit Sito Express",
    "cheetah-template-25364": "Allenamento Funzionale Sito Express 04",
    "cheetah-template-25365": "Personal Trainer Sito Express",
    "cheetah-template-25366": "Running Training Sito Express",
    "cheetah-template-25455": "Psicologo Sito Express",
    "cheetah-template-25511": "Marketing Digital Sito Express",
    "cheetah-template-25536": "Animale - Sito Express",
    "cheetah-template-25592": "Video corso",
    "cheetah-template-25594": "Video corso",
    "cheetah-template-25611": "Agenzia Viaggi Sito Express",
    "cheetah-template-25767": "Cibo Salutare - 03",
    "cheetah-template-24528": "Struttura Sales Pages",
    "cheetah-template-26177": "Struttura della pagina di vendita",
    "ct-domain-rules": "Per connettere i tuo dominio esistente, segui questi passi:\n\nInserisci il dominio nel campo qui sopra; <br>\nAttendi 5 minuti affinchè il nostro sistema registri il tuo dominio ; <br>\nVai al sito dove hai acquistato il dominio (godaddy, namecheap, etc); <br>\nVai nelle impostazioni per cambiare i Server Names (NameServers, o DNS); <br>\nInserisci questi dati: NS5.L4DNS.COM e NS6.L4DNS.COM; <br>\nSe il tuo Hosting richiede anche gli indirizzi IP usa i seguenti;<br> per NS5:     64.251.13.230<br> per NS6:    185.80.220.28 <br>\nFATTO, adesso devi attendere che l tuo dominio sia propagato su internet, questo processo richiede da 1 ora  fino a 48 ore;<br>\nIl certificato SSL sarà aggiunto automaticamente al tuo sito web entro pochi minuti;<br>\n",
    "cheetah-template-26413": "Dentista Sito express",
    "ct-members-form": "Modulo Area Riservata",
    "ct-automatic-emails": "Email Automatiche",
    "ct-members-form-config": "Impostazioni modulo area membri",
    "ct-field-action-create": "Crea nuovo campo",
    "ct-textarea": "Area Testo",
    "ct-checkbox": "Checkbox",
    "ct-radio": "Radio",
    "ct-date": "Data",
    "ct-datetime": "Data e ora",
    "ct-email-new-theme": "Nuovo tema email automatica",
    "ct-email-theme-name": "Nome tema",
    "ct-email-theme-edit": "Modifica il tema",
    "ct-email-theme-welcome": "Benvenuto",
    "ct-available-tags": "Tag disponibili",
    "ct-user-name": "Nome Utente",
    "ct-user-email": "E-mail utente",
    "ct-user-password": "Password utente",
    "ct-field-action-update": "Modifica campo",
    "ct-option-delete": "Elimina",
    "ct-validation-already-been-taken": "Questo valore è già stato preso\n",
    "ct-members-link-redirect-before": "Reindirizzamento dopo l'azione\n",
    "ct-members-link-action": "Azione Link",
    "ct-no-mask": "Nessuna maschera",
    "ct-option-grip-vertical": "grip verticale",
    "ct-option-grip-horizontal": "grip orizzontale",
    "ct-option-save": "Salva elemento",
    "ct-option-edit": "Modifica elemento",
    "ct-option-center": "Centra elemento",
    "ct-option-set-fields": "Imposta campi",
    "ct-option-arrow-up": "Freccia su",
    "ct-option-arrow-down": "Freccia giù",
    "ct-option-clone": "Clona elemento",
    "ct-option-hide": "Nascondi elemento",
    "cheetah-template-26991": "Fornitura mobili Sito Express",
    "ct-save-free-whitout-domain-title": "Congratulazioni! Il tuo sito web è stato pubblicato con successo.",
    "ct-save-free-whitout-domain-message": "Puoi accedere al tuo sito Web al dominio:",
    "ct-i-want-connect-my-domain": "Voglio connettere un mio dominio",
    "ct-i-am-satisfied-domain": "Sono soddisfatto con questo dominio",
    "ct-title-upgrade-popup": "Fantastico, avere il tuo dominio è il primo passo per una presenza professionale su Internet!",
    "ct-message-upgrade-popup": "Per connettere il tuo sito Web al tuo dominio devi aggiornare il tuo account. Scopri ora tutti i vantaggi del Piano Builder su Builderall.",
    "ct-button-upgrade-popup": "Scopri di più sul Piano Builder e fai l'Upgrade",
    "ct-not-now-tks": "Non adesso, Grazie!",
    "ct-title-upgrade-popup-wait": "Attendi mentre stiamo aggiornando il tuo account Builderall.\nQuesto processo potrebbe richiedere alcuni minuti!",
    "ct-message-upgrade-popup-wait": "Una volta aggiornato il tuo account, sarai in grado di pubblicare i tuoi siti Web con i tuoi domini.\nDurante l'attesa del completamento del processo di aggiornamento, puoi comunque modificare il tuo sito Web, ma ricorda di connettere il dominio in un secondo momento.",
    "ct-action-upgrade-popup": "Capito, voglio chiudere questa finestra.",
    "ct-title-domain-popup": "Connetti il tuo dominio",
    "ct-message-domain-popup": "Se non hai ancora un dominio, puoi acquistare il tuo dominio proprio qui su Builderall e verrà automaticamente impostato per funzionare con i nostri siti Web senza che tu debba fare nulla.",
    "ct-buy-domain": "Acquista il Dominio su Builderall",
    "ct-i-have-domain": "Ho già un dominio.",
    "ct-connected-domain": "Connetti un Dominio Esistente",
    "ct-title-connected-domain-popup": "Attendi, stiamo collegando il tuo dominio alla nostra rete di server (CDN) ...",
    "ct-message-connected-domain-popup": "Una volta completata questa operazione, attendi qualche minuto per la propagazione del tuo dominio su Internet, questo processo può richiedere da 5 minuti a 48 ore a seconda del tuo provider di dominio.",
    "ct-title-connected-domain-popup-auto": "Questa finestra sarà chiusa automaticamente in",
    "ct-title-finish-popup": "Fatto!",
    "ct-message-finish-popup": "Il tuo sito web super-veloce è pubblicato su questo dominio:",
    "ct-update-domain": "Acquista un altro dominio su Builderall",
    "ct-option-link": "Imposta Link",
    "ct-align-left": "Sinistra",
    "ct-align-center": "Centro",
    "ct-align-right": "Destra",
    "ct-align-menu": "Allineamento menu",
    "ct-editing-mobile": "Mobile",
    "ct-panels": "Pannelli",
    "ct-iframe": "Iframe(Box HTML)",
    "ct-videos": "Video",
    "ct-preset-fonts": "Font",
    "ct-panel-pricings": "Prezzi",
    "ct-change-image": "Modifica immagine",
    "ct-page-script": "Script",
    "ct-page-name-here": "Nome della Pagina qui",
    "ct-buttons": "Tasti",
    "ct-key-words": "parole chiave",
    "ct-page-share-img": "Immagine di condivisione",
    "ct-address-url": "Indirizzo URL",
    "ct-title-separator": "separatore",
    "ct-crm-enable": "Abilita CRM",
    "ct-overview": "Panoramica",
    "ct-key-word": "parola chiave",
    "ct-metatag": "Metatag",
    "ct-robots": "robots",
    "ct-ads": "ADS",
    "ct-scripts-settings": "impostazioni script",
    "ct-script": "script",
    "ct-script-pixel": "script pixel",
    "ct-script-analytics": "script analytics",
    "ct-title-age": "Titolo",
    "ct-element-images": "Immagini",
    "ct-element-media": "Media",
    "ct-email-mkt-form": "Modulo Email marketing ",
    "ct-headers-and-footers": "Headers e footers",
    "ct-boxes": "Box",
    "ct-savePanelsTab": "Salva Pannelli",
    "ct-fontSizeMobile": "Dimensione Font mobile",
    "ct-imageSizeMobile": "Dimensione immagine mobile",
    "ct-editor-overview": "Panoramica Editor",
    "ct-add-new-page": "Aggiungi Nuova Pagina",
    "ct-connect-domain-confirm": "Conferma Connessione Dominio",
    "ct-publish-confirm": "Conferma Pubblicazione",
    "title-disconnect-domain-confirm": "Conferma Disconnessione Dominio",
    "label-disconnect-domain-confirm": "Conferma Disconnessione Dominio",
    "ct-element-galleries": "Gallerie",
    "ct-element-webinar": "Webinar",
    "ct-addElements": "Aggiungi Elementi",
    "ct-panel-created": "Panello Creato",
    "ct-textStyle": "Stile Testo",
    "ct-subTextStyle": "Stile Sotto Testo",
    "ct-inputStyle": "Stile del Campo",
    "ct-arrowConfig": "Configurazione Frecce",
    "ct-option-set-list": "Imposta Lista",
    "ct-create-new-list": "Crea nuova Lista",
    "ct-creation-list-name": "Nome della Lista",
    "ct-creation-list-description": "Descrizione della Lista",
    "ct-creation-list-from-name": "Da email della Lista",
    "ct-creation-list-from-email": "Da nome della Lista",
    "ct-creation-list-reply-to": "Rispondi a della lista",
    "ct-subscribe-pending": "Sottoscrizione in attesa",
    "ct-no-action": "Nessuna Azione",
    "ct-subscribe-confirm": "Conferma Sottoscrizione",
    "ct-unsubscribe-confirm": "Conferma cancellazione sottoscrizione",
    "ct-title-page": "Titolo Pagina",
    "ct-publish-confirm-within-five-min": "Il tuo sito è stato pubblicato!",
    "ct-page-edit-success": "Modifica Pagina",
    "ct-component-CounterBarComponent": "Barra Progresso",
    "ct-component-CounterTextComponent": "Contatore",
    "ct-resource-bg-color-bar": "Colore Barra",
    "ct-counter-init": "Numero Iniziale",
    "ct-counter-finish": "Numero Finale",
    "ct-counter-timer": "Tempo",
    "ct-panel-banner": "Banner Business",
    "ct-panel-checkout": "Banner Checkout",
    "ct-panel-optin": "Banner Optin",
    "ct-panel-tourist-guide": "Guida Turistica",
    "ct-element-animated-elements": "Elementi Animati",
    "ct-delete-field": "Cancella campo",
    "ct-automatic-emails-is-empty": "Non hai ancora nessun tema per email registrato",
    "ct-saved-successfully": "Salvato correttamente",
    "ct-error-saving": "Errore di salvataggio",
    "ct-email-members-theme": "Tema email automatiche membri",
    "ct-default": "Predefinito",
    "ct-page": "Pagina",
    "ct-members-link-area-helper": "Scegli l'area riservata che vuoi sbloccare con la registrazione.",
    "ct-members-link-area": "Area Riservata",
    "cheetah-template-29346": "Teste Wanny",
    "cheetah-template-29360": "Spose Sito Express",
    "cheetah-template-29362": "Personal Stylist Sito Express",
    "cheetah-template-29363": "Massaggi Site Express",
    "cheetah-template-29364": "Drenaggio Linfatico Sito Express",
    "cheetah-template-29365": "Podologo Sito Express",
    "cheetah-template-29367": "Drenaggio Linfatico Sito Express",
    "cheetah-template-29372": "Manicure and Pedicure Sito Express",
    "cheetah-template-29401": "Salone per Party 02",
    "ct-add-element": "Aggiungi Elemento",
    "cheetah-template-29439": "Veterinario Sito Express",
    "cheetah-template-29503": "Cerimoniale Sito Express",
    "cheetah-template-29506": "Organizzazione Domestica Sito Express",
    "cheetah-template-29516": "Marito a Noleggio",
    "cheetah-template-29517": "Pulizia Piscine",
    "cheetah-template-29598": "Organizzazione Domestica Sito Express",
    "cheetah-template-29599": "Organizzazione Domestica Sito Express",
    "cheetah-template-29600": "Organizzazione Domestica Sito Express",
    "cheetah-template-30739": "Giornalisti Sito Express",
    "cheetah-template-30889": "Insegnante Sito Express",
    "cheetah-template-30909": "Montaggio Mobili",
    "cheetah-template-30916": "Rete di protezione Sito Express",
    "cheetah-template-31028": "Giardinaggio 02",
    "cheetah-template-31029": "Makeup Artist",
    "cheetah-template-31086": "Fisioterapisti",
    "cheetah-template-31460": "Manicure and Pedicure Sito Express",
    "cheetah-template-31545": "Economisti Sito Express",
    "cheetah-template-31552": "Avvocati Sito Express",
    "cheetah-template-31589": "Parrucchieri",
    "cheetah-template-31592": "Parrucchieri",
    "cheetah-template-31593": "Design delle Sopracciglia",
    "cheetah-template-31607": "Rimodellamento Sito Express",
    "cheetah-template-31716": "Idraulico Sito Express",
    "cheetah-template-31765": "Infermieri Sito Express",
    "cheetah-template-31808": "Logopedisti Sito Express",
    "cheetah-template-32190": "Salone per Feste Sito Express 01",
    "cheetah-template-32235": "Rimozione Peli Sito Express",
    "cheetah-template-32431": "Illuminazione Residenziale Sito Express",
    "ct-vimeovideo": "Vimeo",
    "ct-youtubevideo": "Youtube",
    "ct-wistiavideo": "Wistia",
    "cheetah-template-32812": "Amministratori Sito Express",
    "cheetah-template-32941": "Abbigliamento e Accessori per il Fitness Sito Express",
    "cheetah-template-33158": "Integratori Alimentari Sito Express",
    "ct-clean": "Pulisci",
    "ct-example": "Esempio",
    "ct-create-group": "Crea Gruppo",
    "ct-create-tag": "Crea Tag",
    "ct-members-form-theme": "Tema Modulo",
    "ct-theme-type": "Tipo",
    "ct-theme-style": "Stile",
    "ct-three-tabs": "Tre schede",
    "ct-two-tabs": "Due schede\n",
    "ct-two-columns": "Due colonne",
    "ct-in-block": "Nel blocco",
    "ct-light": "Chiaro",
    "ct-dark": "Scuro",
    "ct-members-list-is-empty-search": "Lista membri è vuota",
    "ct-tags": "Tag",
    "cheetah-template-36201": "Architetti",
    "ct-success-message": "Messaggio inviato con successo",
    "ct-is-required-message": "È richiesto un messaggio",
    "ct-success-message-and-errors": "Messaggio di successo ed errori\n",
    "cheetah-template-36833": "Biologi",
    "cheetah-template-37086": "Ingegnieri",
    "ct-option-up": "Elemento Su",
    "ct-option-down": "Elemento Giù",
    "ct-subdomain-must-be-at-least-5-characters": "Sottodominio minimo 5 caratteri",
    "ct-subdomain-may-not-be-greater-than-100-char": "Sottodominio max 100 caratteri",
    "ct-divider": "Divisori Pannelli",
    "ct-shape-divider-first-color": "Primo Colore",
    "ct-shape-divider-second-color": "Secondo Colore",
    "ct-shape-divider-third-color": "Terzo Colore",
    "ct-shape-divider-fourth-color": "Quarto Colore",
    "ct-divider-effect-waves-floating": "Onde in movimento",
    "ct-divider-effect-drip-up": "Gocce Su",
    "ct-divider-effect-drip-down": "Gocce Giù",
    "ct-divider-effect-mid-arrow": "Freccia Media",
    "ct-divider-effect-waves-fixed": "Onde fisse",
    "ct-divider-effect-polygon": "Poligoni",
    "ct-divider-effect-polygon-up": "Poligoni Su",
    "ct-divider-effect-banner-lateral": "Banner Laterale",
    "ct-divider-effect-drops": "Gocce",
    "ct-divider-effect-waves-lateral": "Onde Laterali",
    "ct-divider-effect-zigzag": "Zig Zag",
    "ct-divider-effect-big-arrow": "Freccia Grande",
    "ct-divider-effect-clouds": "Nuvole",
    "ct-divider-effect-curve": "Curve",
    "ct-divider-effect-arrow-reverse": "Freccia Inversa",
    "ct-divider-effect-pixels": "Pixels",
    "ct-divider-effect-big-round": "Grande Cerchio",
    "ct-divider-effect-breaker": "Interruttore",
    "ct-public-link-confirm-text": "Conferma l'importazione",
    "ct-hello": "Ciao",
    "ct-from": "Da",
    "ct-to": "A",
    "ct-public-link-success": "Successo!",
    "ct-go-to-site-dashboard": "Vai alla dashboard del sito",
    "ct-public-link-error": "Errore",
    "ct-go-to-home": "Vai alla home",
    "ct-public-link-need-login": "Accedi",
    "ct-public-link-publish": "Link Pubblico",
    "ct-public-link-for-copy": "Link da copiare",
    "ct-copy": "Copia",
    "ct-link-disable": "Disabilita il Link Pubblico",
    "ct-manage-public-link": "Gestione Link Pubblico",
    "ct-active-public-link": "Attiva Link Pubblico",
    "ct-copy-success": "Copia effettuata",
    "ct-form-members": "Modulo Membri",
    "ct-subdomain": "Sottodominio",
    "ct-change-subdomain-confirm": "Confermi il cambio del nome del sottodominio?",
    "ct-change-subdomain-confirm-text": "Quando cambi il nome del sottodominio devi ripubblicare tutti i tuoi siti",
    "ct-padding-left-right": "Sinistra+Destra",
    "ct-padding-left": "Sinistra",
    "ct-padding-right": "Destra",
    "ct-padding-top": "Sopra",
    "ct-padding-bottom": "Sotto",
    "ct-field-may-not-be-greater-than-255-char": "Il campo non può essere più grande di 255 caratteri",
    "ct-field-must-be-at-least-3-characters": "Il campo deve avere almeno e caratteri",
    "cheetah-template-38372": "Stuccatori",
    "ct-public-link-user-free": "Gli utenti con piano Gratuito non possono continuare questa azione",
    "ct-invalid-subdomain-user-regex": "Nome Sottodominio non valido; può contenere solo lettere, numeri e -",
    "ct-inline-html": "HTML in linea",
    "ct-not-found": "Non trovato",
    "cheetah-template-37639": "Pulizia Dentale e Controllo",
    "cheetah-template-37649": "Funnel Agenzie Immobiliari - Lista Case per Acquirenti e Venditori",
    "cheetah-template-33705": "017 - Arti Marziali | Sales page",
    "cheetah-template-37862": "Scuola di Arti Marziali EN",
    "cheetah-template-37754": "Cura delle vetture",
    "cheetah-category-template-5": "Funnel di Nicchia",
    "cheetah-template-38262": "Allenamento Funzionale 01",
    "cheetah-template-37845": "Toelettatore",
    "cheetah-template-38318": "Palestra",
    "cheetah-template-38298": "Funnel Salone Bellezza",
    "cheetah-template-38297": "Trattamento Viso e Spa",
    "cheetah-template-38283": "Yoga | Funnel",
    "cheetah-category-template-6": "Funnel di Nicchia",
    "cheetah-template-40357": "Scrittori",
    "cheetah-template-40358": "Scrittori",
    "ct-monetizze": "Monetizza",
    "ct-restrict-area-my-tokens": "I miei Token",
    "ct-mailing-boss": "Mailing Boss",
    "ct-token-type-random": "Casuale",
    "ct-token-type-custom": "Personalizza",
    "ct-restrict-area-auth-type": "Tipo Autorizzazione",
    "ct-auth-type-token": "Token",
    "ct-auth-type-register": "Accedi",
    "ct-auth-type-both": "Entrambi",
    "ct-token-value": "Valore Token",
    "cheetah-template-43299": "Ristorante Sito Express",
    "cheetah-template-43338": "Ristorante Sito Express",
    "cheetah-template-43346": "Pizzeria - Sito Express",
    "ct-option-config-items": "Configura elementi",
    "cheetah-template-43775": "Guida Turistica - Sito Express",
    "cheetah-template-43817": "Gelateria Sito Express",
    "ct-restrict-area-has-expires": "Il token è scaduto",
    "ct-height-button": "Altezza Tasto",
    "cheetah-template-43957": "Negozio Bacche di Goji Sito Express",
    "ct-validation-may-not-be-greater-than": "Il campo non può essere più grande di",
    "ct-validation-must-be-at-least": "Il campo deve essere almeno",
    "ct-char": "caratt",
    "ct-characters": "caratteri",
    "cheetah-template-43990": "Analista Finanziario Sito Express",
    "cheetah-template-44042": "Analista finanziario Sito Express",
    "cheetah-template-44069": "Food Truck",
    "cheetah-template-45110": "Nightclub 02",
    "cheetah-template-45375": "Pub Sito Express",
    "cheetah-template-45637": "Caffetteria Sito Express",
    "cheetah-template-45818": "Gelateria - Sito Express",
    "cheetah-template-46080": "Decoratore Sito Express",
    "cheetah-template-46757": "Designer di Interni 01",
    "cheetah-template-47003": "Dolci Sito Express",
    "cheetah-template-47043": "Training Funzionale Sito Express 03",
    "cheetah-template-47100": "Party Snacks 02",
    "cheetah-template-47101": "Barbecue - Sit0 Express",
    "cheetah-template-47103": "Agenzia Viaggi - Sito Express",
    "cheetah-template-47105": "Crossfit - Sito Express",
    "cheetah-template-47187": "Personal Trainer Sito Express",
    "cheetah-template-47626": "Pittore Sito Express",
    "cheetah-template-47628": "Fotografi Sito Express",
    "cheetah-template-47872": "Dentisti Sito Express",
    "ct-restrict-mb-list-warning": "Affinché la registrazione nella lista avvenga correttamente, i campi della lista devono essere uguali ai campi di registrazione, altrimenti la registrazione dell'utente non verrà eseguita.",
    "ct-warning": "Attenzione",
    "ct-add-token": "Aggiungi token",
    "ct-my-tokens": "I miei token",
    "ct-restrict-area-tokens": "Token",
    "ct-restrict-email-config-warning": "Per modificare l'e-mail inviata durante la registrazione dell'utente, devi configurare la lista in",
    "cheetah-template-48147": "Assicuratori 02",
    "cheetah-template-48192": "Coach Perdita Peso Sito Express",
    "ct-internal-background": "Sfondo Interno",
    "ct-video": "Video",
    "ct-boxcomponent": "Box",
    "ct-gradient-solid-color": "Colore Solido",
    "ct-gradient-gradient-color": "Colori con Sfumature",
    "ct-remove-color": "Rimuovi Colore",
    "ct-gradient-incompatible-with-bg-image": "Attenzione, il tipo di sfumatura dello sfondo  non è compatibile con l'immagine di sfondo.",
    "ct-text-shadow-title": "Ombra Testo",
    "ct-text-shadow-h": "Orizzontale",
    "ct-text-shadow-v": "Verticale",
    "ct-text-shadow-b": "Sfocatura",
    "ct-text-shadow-c": "Colore",
    "ct-text-shadow-title-preview": "Anteprima",
    "ct-text-shadow-note": "Nota: Internet Explorer 9 e precedenti non supportano la proprietà ombra-testo.",
    "ct-resource-external-video": "Video Esterno",
    "ct-bg-config-video-internal": "Interno",
    "ct-bg-config-autoplay": "Autoplay",
    "ct-bg-config-muted": "Mutato",
    "ct-bg-config-loop": "Loop",
    "ct-video-browsers-warning": "Alcuni browser non funzionano molto bene con i video di sfondo e possono anche aumentare il tempo di caricamento del tuo sito. La maggior parte dei telefoni cellulari non supporta questa funzione.",
    "ct-change-video": "Cambia Video",
    "ct-bg-config-origin": "Origine",
    "ct-bg-config-origin-padding": "Spaziatura Box",
    "ct-bg-config-origin-border": "Bordo del Box",
    "ct-bg-config-origin-content": "Contenuto Box",
    "ct-bg-config-size": "Dimensione",
    "ct-bg-config-size-auto": "Auto",
    "ct-bg-config-size-50": "50%",
    "ct-bg-config-size-100": "100% 100%",
    "ct-bg-config-size-cover": "Riempie",
    "ct-bg-config-size-contain": "Contiene",
    "ct-bg-config-repeat": "Ripeti",
    "ct-bg-config-repeat-no-repeat": "Non Ripetere",
    "ct-bg-config-repeat-repeat-x": "Ripeti X",
    "ct-bg-config-repeat-repeat-y": "Ripeti Y",
    "ct-bg-config-repeat-repeat-space": "Spazio",
    "ct-bg-config-repeat-repeat-round": "Arrotondare",
    "ct-bg-config-repeat-repeat": "Ripeti",
    "ct-box": "Box",
    "ct-button": "Tasto",
    "ct-helper-type-files-accept-videos": "Puoi caricare un video in MP4, WebM o Ogg. Dimensione video massima di 10 MB.",
    "ct-tab-file-videos-user": "Video",
    "cheetah-template-48503": "Pittore Sito Express",
    "cheetah-tag-1-description": "123",
    "cheetah-tag-1-example": "123",
    "ct-component-GetResponseFormComponent": "Get Response",
    "ct-get-response-target-field": "Campo corrispondente in Getresponse",
    "ct-target-field": "Campo Target",
    "ct-get-response-match-fields": "Campi di corrispondenza",
    "ct-get-response-success-message": "Messaggio di successo",
    "ct-get-response-done": "Fatto",
    "ct-get-response-select-a-list": "Seleziona una lista",
    "ct-get-response-select": "Seleziona",
    "ct-get-response-verify": "Verifica",
    "ct-get-response-authentication-message": "Ciao! Dobbiamo autenticare il tuo account GetResponse per creare un'integrazione con GetResponse.",
    "ct-get-response-invalid": "Token non valido",
    "ct-get-response-valid": "Token valido",
    "cheetah-template-48893": "Psicologo Sito Express",
    "ct-invalid-format": "Formato non valido. Supportato solo MP4, WebM e Ogg.",
    "ct-my-tokens-list-empty": "Nessun token presente",
    "ct-choose-smart-template": "Seleziona un template",
    "ct-template-tag": "Template con Tag",
    "ct-groups": "Gruppi",
    "cheetah-template-49615": "Commercialista Sito Express",
    "cheetah-template-49867": "Nutrizionista Sito Express",
    "cheetah-template-50033": "Alimentazione Salutare - 02",
    "cheetah-template-50064": "Organizzazione Personale 01",
    "ct-smart-tag": "Smart tag",
    "cheetah-template-50102": "Gym - Sito Express",
    "cheetah-template-50176": "Dottori Sito Express",
    "ct-panel-animated-video": "Pannello con Video di Sfondo",
    "cheetah-template-50380": "Coach Perdita Peso Sito Express",
    "cheetah-template-46764": "Fotografo",
    "cheetah-template-49871": "Fotografo 01",
    "cheetah-tag-2-description": "[TAG-NAME]",
    "cheetah-tag-2-example": "[TAG-NAME]",
    "ct-panel-f-a-q": "F.A.Q",
    "ct-edit-page": "Pagina modificata",
    "ct-component-Image3DComponent": "Immagine 3D",
    "ct-get-response-get-my-api-token": "Ottieni API Token",
    "ct-background-img": "Immagine sfondo",
    "ct-access-denied-msg": "Messaggio Accesso Negato",
    "ct-access-denied-btn-enable": "Tasto Accesso Home Negato abilitato",
    "ct-access-denied-btn-text": "Testo Tasto Accesso Home Negato",
    "ct-mboss-integration-key": "Chiave Integrazione",
    "ct-mboss-reference": "TAG Riferimento",
    "ct-action-link-builderall": "Builderall Autotags",
    "ct-builderall-link-office-main-product-1": "URL Addizionale 2",
    "ct-builderall-link-office-divulgation-link": "Link Promozionali",
    "ct-builderall-link-office-facebook": "Profilo Facebook",
    "ct-builderall-link-office-main-product-0": "URL Addizionale 1",
    "ct-builderall-link-office-main-product-2": "URL Addizionale 3",
    "ct-builderall-link-office-main-product": "URL del business principale",
    "ct-builderall-link-office-main-product-3": "URL Addizionale 4",
    "ct-builderall-link-office-main-product-4": "URL Addizionale 5",
    "ct-builderall-link-office-main-product-5": "URL Addizionale 6",
    "ct-builderall-link-office-main-product-6": "URL Addizionale 7",
    "ct-builderall-link-office-main-product-7": "URL Addizionale 8",
    "ct-builderall-link-office-main-product-8": "URL Addizionale 9",
    "ct-builderall-link-office-main-product-9": "URL Addizionale 10",
    "ct-component-ImageGalleryComponent": "Galleria Immagini",
    "ct-background-image-repeat": "Ripeti Sfondo ",
    "ct-bg-config-repeat-space": "Spazio",
    "ct-bg-config-repeat-round": "Arrotonda",
    "ct-images-per-page": "Immagini per pagina",
    "ct-columns": "Colonne",
    "ct-vertical-margin": "Margine Verticale",
    "ct-horizontal-margin": "Margini orizzontali",
    "ct-create-tag-group": "Crea gruppo tag",
    "ct-bg-config-size-100-100": "100% 100%",
    "ct-background-image-size": "Dimensione immagine sfondo",
    "cheetah-template-53131": "Professore particolare",
    "cheetah-template-55200": "Insegnante",
    "cheetah-tag-3-description": "Prima frase sulla pagina. Dì ai tuoi visitatori di cosa tratta la tua pagina e fai capire loro che si trovano nel posto giusto.",
    "cheetah-tag-3-example": "Attenzione a tutti gli imprenditori della Lombardia centrale in cerca di una nuova opportunità commerciale",
    "cheetah-tag-4-description": "Il nome della tua azienda",
    "cheetah-tag-4-example": "Builderall",
    "cheetah-tag-5-description": "Il messaggio più importante sul tuo sito Web. Esempio di formula del titolo: come .... che dà il risultato desiderato .... senza sofferenza",
    "cheetah-tag-5-example": "Scopri come creare una pagina di cattura lead che converte il 50% dei tuoi visitatori in lead senza dover pagare per il copywriting.",
    "cheetah-tag-6-description": "SOTTO TITOLO: scrivi qualcosa che renda il tuo visitatore ancora più curioso",
    "cheetah-tag-6-example": "Scopri come ho perso 30 chili in 30 giorni senza dieta o esercizio fisico.",
    "cheetah-tag-7-description": "Dì chi aiuti, come aiuti, senza la classica sofferenza",
    "cheetah-tag-7-example": "Aiutare gli imprenditori a costruire i loro siti Web in meno di 5 minuti senza conoscere il web design",
    "cheetah-tag-8-description": "Informa i tuoi clienti quando sei aperto",
    "cheetah-tag-8-example": "Dal lunedì al sabato - dalle 8:00 alle 19:00",
    "cheetah-tag-9-description": "Il tuo numero di telefono aziendale\n",
    "cheetah-tag-9-example": "+39 3456789879",
    "cheetah-tag-10-description": "Il tuo Numero di Whatsapp",
    "cheetah-tag-10-example": "+ 39 349 3493490",
    "cheetah-tag-11-description": "Il tuo indirizzo email aziendale",
    "cheetah-tag-11-example": "contatto@miaazienda.com",
    "cheetah-tag-12-description": "Indirizzo Aziendale completo",
    "cheetah-tag-12-example": "Via Tal dei tali n°29, Milano - MI - 10100 - Italia",
    "cheetah-tag-13-description": "Dì ai tuoi clienti dove fornisci i tuoi servizi",
    "cheetah-tag-13-example": "Serviamo orgogliosamente imprenditori in tutta l'Italia",
    "cheetah-tag-14-description": "Dì ai tuoi clienti cosa c'è di speciale nel tuo servizio o prodotto",
    "cheetah-tag-14-example": "Abbiamo il costruttore di siti Web più semplice e intuitivo al mondo",
    "cheetah-tag-15-description": "Scrivi 10 righe che spiegano come il tuo servizio o prodotto è speciale.",
    "cheetah-tag-15-example": "In che modo Builderall è diverso e come stiamo cambiando il settore?\r\nSiamo impegnati nella qualità e nella nostra esperienza del cliente. Mentre i nostri concorrenti si stanno concentrando sulla vendita con sistemi automatizzati, ci stiamo concentrando solo su 2 cose: costruire un prodotto migliore (la migliore piattaforma di marketing digitale al mondo) e offrire un'esperienza cliente straordinaria.\r\n\r\nQuando acquisti un account Builderall, sai di avere un software tecnologico all'avanguardia per la tua azienda. Forniamo inoltre un'assistenza clienti straordinaria 24 ore su 24, 7 giorni su 7 e Builderall è orgogliosa di essere l'unica piattaforma al mondo che ti offre una chiamata individuale gratuita e un follow-up con uno specialista Builderall. Ti daremo il risultato che desideri con Builderall!\r\nErick Salgado - CEO / Fondatore - Builderall",
    "cheetah-tag-16-description": "Informa i tuoi clienti sui servizi offerti dalla tua azienda",
    "cheetah-tag-16-example": "Siti web\r\nWeb hosting\r\nCostruttore di siti Web\r\nMarketing via email\r\nChatbot e bot per siti web\r\nAutomazione\r\nCRM",
    "cheetah-tag-17-description": "Utilizza questo campo per mostrare un numero importante della tua attività (1)",
    "cheetah-tag-17-example": "1.000 Clienti Soddisfatti",
    "cheetah-tag-18-description": "Utilizza questo campo per mostrare un numero importante della tua attività (2)",
    "cheetah-tag-18-example": "100,000 Siti web Online",
    "cheetah-tag-19-description": "Utilizza questo campo per mostrare un numero importante della tua attività (3)",
    "cheetah-tag-19-example": "50 Negozi in 20 Città",
    "cheetah-tag-20-description": "L'URL della tua pagina Facebook",
    "cheetah-tag-20-example": "https://www.facebook.com/viral-team-italia",
    "cheetah-tag-21-description": "L'URL del tuo gruppo Facebook",
    "cheetah-tag-21-example": "https://www.facebook.com/groups/builderall/",
    "cheetah-tag-22-description": "Il tuo URL di Instagram",
    "cheetah-tag-22-example": "https://www.instagram.com/viralnetworksystem",
    "cheetah-tag-23-description": "L'URL del tuo canale Youtube",
    "cheetah-tag-23-example": "https://www.youtube.com/channel/UCRzQ11vg83JBagbO8piZH1A/",
    "cheetah-tag-24-description": "Un'offerta speciale in una frase",
    "cheetah-tag-24-example": "Acquista ora per soli  €19,90",
    "cheetah-tag-25-description": "Un'offerta speciale in una frase\n",
    "cheetah-tag-25-example": "Acquista ora per soli  €19,90\n",
    "cheetah-tag-26-description": "Il tuo principale invito all'azione",
    "cheetah-tag-26-example": "Iscriviti ora!",
    "cheetah-tag-27-description": "Il vantaggio principale del prodotto numero 1",
    "cheetah-tag-27-example": "Crea un redditizio elenco di email in pochi giorni",
    "cheetah-tag-28-description": "Il vantaggio principale del prodotto numero 2",
    "cheetah-tag-28-example": "Crea un redditizio elenco di email in pochi giorni",
    "cheetah-tag-29-description": "Il vantaggio principale del prodotto numero 3",
    "cheetah-tag-29-example": "Crea un redditizio elenco di email in pochi giorni",
    "cheetah-tag-30-description": "Il vantaggio principale del prodotto numero 4",
    "cheetah-tag-30-example": "Crea un redditizio elenco di email in pochi giorni",
    "cheetah-tag-31-description": "Il vantaggio principale del prodotto numero 5",
    "cheetah-tag-31-example": "Crea un redditizio elenco di email in pochi giorni",
    "cheetah-tag-32-description": "Il vantaggio principale del prodotto numero 6",
    "cheetah-tag-32-example": "Crea un redditizio elenco di email in pochi giorni",
    "cheetah-tag-33-description": "Il vantaggio principale del prodotto numero 7",
    "cheetah-tag-33-example": "Crea un redditizio elenco di email in pochi giorni",
    "cheetah-tag-34-description": "Chi aiuterà i tuoi clienti",
    "cheetah-tag-34-example": "Chiama ora e parla con il nostro servizio clienti",
    "cheetah-tag-35-description": "Scrivi alcune righe sulla tua storia aziendale",
    "cheetah-tag-35-example": "Il progetto della piattaforma Builderall è iniziato nel 2011, con un obiettivo in mente: generare risultati online reali per le aziende di tutto il mondo, attraverso una piattaforma completa e completa. Tuttavia, non è qui che inizia la nostra storia. eBusiness4us, Inc. è stata fondata negli Stati Uniti nel 2008 dall'imprenditore brasiliano Erick Salgado, con due passioni fondamentali: il marketing digitale e l'imprenditorialità. All'epoca l'obiettivo dell'azienda era molto chiaro: \"trasformare il mondo attraverso l'imprenditorialità utilizzando il marketing digitale come strumento\".\r\n\r\nDi ritorno in Brasile, dove Erick Salgado è conosciuto come uno dei più brillanti imprenditori digitali nel paese, dal 2005 porta le aziende nel mondo digitale attraverso un programma locale di inclusione digitale che ha creato oltre 5.000 siti Web per piccole aziende. Ha anche creato un portale di mini-franchising, che è diventato rapidamente un enorme successo locale e ha lanciato la sua carriera internazionale.\r\n\r\nI sogni che cambiano il mondo erano ancora lì. Entro il 2010, con una vasta gamma di clienti di tutti i tipi di aziende, Erick ha iniziato a notare che il successo attraverso Internet non era accessibile a tutti. Un numero esponenzialmente crescente di concorrenti, spammer e strumenti incredibilmente costosi stava rendendo difficile per gli imprenditori ottenere risultati reali online.\r\n\r\nE se gli imprenditori avessero accesso a uno strumento che potrebbe davvero aiutarli a raggiungere il successo online? Sarebbe un'unica piattaforma intelligente, offerta a un prezzo basso che non è complicato da configurare o codificare. Bene, è esattamente così che è nato Builderall.\r\n\r\nOggi siamo qui per offrirti tutti gli strumenti e supportare la tua azienda per crescere!\r\n\r\nSappiamo che questa piattaforma è eccezionale perché la usiamo noi stessi per far crescere le nostre attività. Questo è anche il modo in cui sappiamo che Builderall ha gli strumenti di cui OGNI imprenditore ha bisogno per avere successo e far crescere il proprio business.",
    "cheetah-tag-36-description": "Scrivi alcune righe parlando del tuo prodotto principale",
    "cheetah-tag-36-example": "Presentazione del Nuovissimo costruttore di siti Web Drag-and-Drop Cheetah \r\n \r\nCostruire pagine belle (e follemente veloci) non è mai stato così facile.\r\n \r\nCrea tutti i tuoi siti Web, pagine e canalizzazioni con il nostro builder drag-and-drop di facile utilizzo. La nostra tecnologia reattiva semplifica la modifica dell'aspetto su qualsiasi dispositivo.\r\n \r\nSiediti e guarda le tue conversioni salire alle stelle con siti Web follemente veloci e ad alta conversione.",
    "cheetah-tag-37-description": "Quando è stata aperta la tua attività",
    "cheetah-tag-37-example": "Dal 2008",
    "cheetah-tag-38-description": "Informa i tuoi clienti sulle caratteristiche speciali della tua attività, luogo o prodotto",
    "cheetah-tag-38-example": "Disponibilità 24/7\r\nParcheggio disponibile\r\nCarta di credito accettata\r\nWifi gratis\r\nBuono per i bambini\r\nBuono per le famiglie\r\nAccessibile alle sedie a rotelle\r\nSolo su appuntamento\r\nDisponibile parcheggio per biciclette",
    "cheetah-tag-39-description": "Racconta ai tuoi clienti i tuoi successi e premi",
    "cheetah-tag-39-example": "Migliore assistenza clienti Lombardia/MI\r\nPiattaforma di marketing digitale Top-10 nel mondo\r\nPiattaforma SAAS in più rapida crescita nel mondo",
    "cheetah-tag-40-description": "Comunicaci chi possiede il contenuto del tuo sito Web",
    "cheetah-tag-40-example": "Tutti i diritti riservati builderall.com - 2021\nTutti i diritti riservati Builderall Italia",
    "cheetah-tag-41-description": "Titolo di uno dei tuoi servizi",
    "cheetah-tag-41-example": "Preventivo gratuito sul sito",
    "cheetah-tag-42-description": "Titolo di uno dei tuoi servizi",
    "cheetah-tag-42-example": "Preventivo gratuito sul sito",
    "cheetah-tag-43-description": "Titolo di uno dei tuoi servizi",
    "cheetah-tag-43-example": "Preventivo gratuito sul sito",
    "cheetah-tag-44-description": "Titolo di uno dei tuoi servizi",
    "cheetah-tag-44-example": "Preventivo gratuito sul sito",
    "cheetah-tag-45-description": "Descrivi il tuo servizio 1\n",
    "cheetah-tag-45-example": "Costruisci siti Web e pagine belle e incredibilmente veloci con il costruttore di siti Web più veloce e avanzato sul mercato\n",
    "cheetah-tag-46-description": "Descrivi il tuo servizio 2\n",
    "cheetah-tag-46-example": "Costruisci siti Web e pagine belle e incredibilmente veloci con il costruttore di siti Web più veloce e avanzato sul mercato\n",
    "cheetah-tag-47-description": "Descrivi il tuo servizio 3\n",
    "cheetah-tag-47-example": "Costruisci siti Web e pagine belle e incredibilmente veloci con il costruttore di siti Web più veloce e avanzato sul mercato\n",
    "cheetah-tag-48-description": "Descrivi il tuo servizio 4\n",
    "cheetah-tag-48-example": "Costruisci siti Web e pagine belle e incredibilmente veloci con il costruttore di siti Web più veloce e avanzato sul mercato\n",
    "cheetah-template-60276": "NL003 - Autofficina",
    "cheetah-template-62822": "Meccanico",
    "ct-integrations": "Integrazioni",
    "ct-restrict-area": "Area Riservata",
    "ct-integrations-config": "Integrazioni metodo di pagamento",
    "ct-integrations-offers": "Offerte",
    "ct-integration-name": "Nome Integrazione",
    "ct-integration-payment-config": "Impostazione metodo di pagamento",
    "ct-integration-action": "Integrazione Pagamento",
    "ct-payment-method-name": "Nome metodo di pagamento",
    "ct-payment-method-action": "Metodi di Pagamento",
    "ct-secret-key": "Secret key",
    "ct-navigation": "Navigazione",
    "ct-navigation-with-number": "Navigazione con numeri",
    "ct-navigation-background": "Sfondo Navigazione",
    "ct-navigation-background-hover": "Sfondo Navigazione Hover",
    "ct-navigation-background-active": "Sfondo Navigazione attiva",
    "ct-leave-page-msg": "Vuoi salvare i cambiamenti prima di lasciare questa pagina?",
    "ct-just-leave": "Esci senza salvare",
    "ct-save-and-leave": "Salva ed esci",
    "cheetah-template-67189": "Fernando Nogueira - Ancora libero\n",
    "ct-component-SocialBarComponent": "Barra Social",
    "ct-Show-orientation": "Orientamento",
    "ct-Show-Facebook": "Mostra Facebook",
    "ct-Facebook": "Facebook",
    "ct-Twitter": "Twitter",
    "ct-Instagram": "Instagram",
    "ct-Linkedin": "Linkedin",
    "ct-Show-Linkedin": "Mostra Linkedin",
    "ct-Show-Twitter": "Mostra Twitter",
    "ct-Show-Instagram": "Mostra Instagram",
    "ct-burguer-menu-position": "Posizione Burguer menu",
    "ct-burguer-menu-icon": "Icona Burguer menu",
    "ct-burguer-menu-color": "Colore icona Burguer menu",
    "ct-burguer-menu-background": "Colore sfondo Burguer menu ",
    "ct-tags-builderall-text": "Builderall Tags",
    "ct-smart-tags": "Smart Tags",
    "ct-tag-user-id": "ID Utente",
    "ct-tag-last-name": "Cognome",
    "ct-tag-wechat": "Wechat",
    "ct-tag-whatsapp": "Whatsapp",
    "ct-tag-address-postal-code": "Codice Postale",
    "ct-tag-address-number": "Numero indirizzo",
    "ct-tag-address-district": "Provincia",
    "ct-tag-address-state": "Stato",
    "ct-tag-email": "Email",
    "ct-tag-address-part1": "Indirizzo Parte 1",
    "ct-tag-name": "Nome",
    "ct-tag-skype": "Skype",
    "ct-tag-phone": "Telefono",
    "ct-tag-address-type": "Tipo di indirizzo",
    "ct-tag-address-description": "Descrizione Indirizzo",
    "ct-tag-address-complement": "Indirizzo Aggiuntivo",
    "ct-tag-address-city": "Città",
    "ct-tag-facebook-profile": "Profilo Facebook",
    "ct-tag-fullname": "Nome completo",
    "ct-tag-address-part2": "Indirizzo Parte 1",
    "ct-sync-script": "Sincronizzazione script, fai attenzione, quando selezioni questa opzione, lo script verrà caricato contemporaneamente in tutto il tuo sito, questo potrebbe finire per causare problemi di caricamento, come una pagina vuota o tagliata, controlla se lo script è completo.",
    "ct-element-get-response": "Get Response",
    "ct-see-again": "Guarda di nuovo",
    "ct-element-social-bars": "Barra Social",
    "cheetah-template-65542": "Parar de fumar",
    "cheetah-template-68149": "STOP SMOKING",
    "cheetah-template-65297": "Insegnante di Musica",
    "cheetah-template-68167": "Insegnante di Musica",
    "ct-browser-graph": "Accessi Browser",
    "ct-device-graph": "Accessi per Dispositivo",
    "ct-system-graph": "Accesso Sistema",
    "ct-date-graph": "Accessi per Data",
    "ct-empty-data": "Non hai ancora i dati di accesso su questo sito web",
    "ct-maximum-size": "Larghezza massima\n",
    "ct-max-width-tablet": "Larghezza massima (Versione Tablet)",
    "ct-option-tablet": "La versione per tablet è sostanzialmente un'anteprima della versione mobile, le modifiche apportate qui verranno apportate anche nella versione mobile",
    "cheetah-template-72409": "Ristorante",
    "cheetah-template-73312": "Ristorante",
    "ct-integration-url-checkout-external": "URL per checkout esterno",
    "ct-integration-url-checkout": "URL per checkout con area riservata",
    "ct-integration-webhook": "Webhook",
    "ct-jvzipn-secret-key": "JVZ IPN",
    "ct-vendor-name": "Nome del fornitore",
    "ct-product-id": "ID Prodotto",
    "ct-copy-link": "Copia link",
    "ct-copied-link": "Link copiato",
    "ct-integration-url-checkout-external-help": "Link di vendita per il tuo prodotto fornito dalla piattaforma esterna",
    "ct-custom-fields": "Campi personalizzati",
    "ct-external-link": "Apri link esterno",
    "ct-list-not-selected-warning": "Lista non selezionata",
    "ct-token-help": "Token fornito dalla piattaforma esterna",
    "ct-integration-name-help": "Nome per identificare la tua integrazione",
    "ct-restrict-areas-help": "Aree riservate da rilasciare",
    "ct-integration-expireted-time": "Tempo di scadenza dell'Area Riservata",
    "ct-week": "Settimana",
    "ct-weeks": "Settimane",
    "ct-months": "Mesi",
    "ct-month": "Mese",
    "ct-years": "Anni",
    "ct-year": "Anno",
    "ct-unique-key-help": "Unique key fornita dalla piattaforma esterna",
    "ct-vendor-name-id-help": "Nome del fornitore fornito dalla piattaforma esterna",
    "ct-secret-key-help": "Secret key fornita dalla piattaforma esterna",
    "ct-url-checkout-and-save": "Genera URL per vendita e salva",
    "ct-recurring-payment-time-help": "Pagamento ogni (esempio): 30",
    "ct-merchant-name": "Nome Venditore",
    "ct-merchant-name-help": "Nome del venditore fornito dalla piattaforma esterna",
    "ct-indefinite-period": "Periodo Indefinito",
    "ct-create-new-integration": "Crea nuova integrazione",
    "ct-recurring-payment-time": "Tempi di pagamento ricorrente",
    "ct-product-id-help": "ID prodotto fornito dalla piattaforma esterna",
    "ct-enable-recurrence": "Abilita ricorrenza",
    "ct-integration-url-checkout-help": "URL di checkout per vendita con area riservata",
    "ct-unique-key": "Unique key",
    "ct-search-language": "Ricerca Lingua",
    "ct-dont-have-a-tag-group-do-you-want-create": "Non hai un gruppo di tag, vuoi crearlo?",
    "ct-validation-integration-external-url": "Si prega di controllare l'URL",
    "ct-integrations-config-empty": "Non c'è ancora nessuna integrazione registrata",
    "ct-integration-restrict-manual-only": "E' possibile usare solo manuale/pagamento come metodo di sblocco",
    "ct-members-permission-type": "Tipo di autorizzazione dei membri",
    "ct-released": "Rilasciata",
    "ct-blocked": "Bloccato",
    "ct-open-in-parent": "Apri nell'origine, usato di più quando il sito è all'interno di un iframe",
    "cheetah-template-80659": "Chiropractors",
    "cheetah-tag-49-description": "Descrivi qui i termini della tua offerta",
    "cheetah-tag-49-example": "Iscriviti subito al piano Builderall Funnel Club! Ottieni pieno accesso a tutti i nostri strumenti e ricevi il nostro esclusivo pacchetto bonus per sfruttare il tuo business online con il Funnel Club di Builderall.",
    "cheetah-tag-50-description": "Il prezzo dell'offerta che stai facendo in questo momento",
    "cheetah-tag-50-example": "€100,00",
    "cheetah-tag-51-description": "Il prezzo normale del tuo prodotto o servizio, senza sconti",
    "cheetah-tag-51-example": "€200,00",
    "cheetah-tag-52-description": "copia e incolla ciò che i tuoi clienti dicono della tua attività o del tuo servizio",
    "cheetah-tag-52-example": "\"Builderall ha tutto ciò di cui hai bisogno per avere successo online. Ho trasformato un piccolo investimento in una piccola fortuna con la loro licenza commerciale 2Tier in poche settimane! Ringrazia a tutti in Builderall per aver offerto agli affiliati una piattaforma così straordinaria. Sarò un cliente fedele di Builderall per tutta la vita! \"",
    "cheetah-tag-53-description": "copia e incolla ciò che i tuoi clienti dicono della tua attività o del tuo servizio",
    "cheetah-tag-53-example": "\"Builderall ha tutto ciò di cui hai bisogno per avere successo online. Ho trasformato un piccolo investimento in una piccola fortuna con la loro licenza commerciale 2Tier in poche settimane! Ringrazia a tutti in Builderall per aver offerto agli affiliati una piattaforma così straordinaria. Sarò un cliente fedele di Builderall per tutta la vita! \"",
    "cheetah-tag-54-description": "copia e incolla ciò che i tuoi clienti dicono della tua attività o del tuo servizio",
    "cheetah-tag-54-example": "\"Builderall ha tutto ciò di cui hai bisogno per avere successo online. Ho trasformato un piccolo investimento in una piccola fortuna con la loro licenza commerciale 2Tier in poche settimane! Ringrazia a tutti in Builderall per aver offerto agli affiliati una piattaforma così straordinaria. Sarò un cliente fedele di Builderall per tutta la vita! \"",
    "cheetah-tag-55-description": "Nome del tuo cliente che ti fornisce la testimonianza 1",
    "cheetah-tag-55-example": "Erick",
    "cheetah-tag-56-description": "Nome del tuo cliente che ti fornisce la testimonianza 2",
    "cheetah-tag-56-example": "Antonio",
    "cheetah-tag-57-description": "Nome del tuo cliente che ti fornisce la testimonianza 3",
    "cheetah-tag-57-example": "Francesco",
    "cheetah-tag-58-description": "Città del tuo cliente che ti fornisce la testimonianza 1",
    "cheetah-tag-58-example": "Milano",
    "cheetah-tag-59-description": "Città del tuo cliente che ti fornisce la testimonianza 2",
    "cheetah-tag-59-example": "Torino",
    "cheetah-tag-60-description": "Città del tuo cliente che ti fornisce la testimonianza 3",
    "cheetah-tag-60-example": "Roma",
    "cheetah-tag-61-description": "Verifica con il proprietario del template di cosa tratta questo tag.\nA volte non si applica al template",
    "cheetah-tag-61-example": "Contenuto Gratis",
    "cheetah-tag-62-description": "Verifica con il proprietario del template di cosa tratta questo tag.\nA volte non si applica al template",
    "cheetah-tag-62-example": "Contenuto Gratis",
    "cheetah-tag-63-description": "Verifica con il proprietario del template di cosa tratta questo tag.\nA volte non si applica al template",
    "cheetah-tag-63-example": "Contenuto Gratis",
    "cheetah-tag-64-description": "Verifica con il proprietario del template di cosa tratta questo tag.\nA volte non si applica al template",
    "cheetah-tag-64-example": "Contenuto Gratis",
    "cheetah-tag-65-description": "Verifica con il proprietario del template di cosa tratta questo tag.\nA volte non si applica al template",
    "cheetah-tag-65-example": "Contenuto Gratis",
    "cheetah-tag-66-description": "Invito all'azione sul tuo pulsante",
    "cheetah-tag-66-example": "Acquista Ora / Registrati subito / Scarica il file / Iscriviti Ora",
    "cheetah-tag-67-description": "Il nome del tuo prodotto o servizio principale",
    "cheetah-tag-67-example": "Cheetah Website Builder",
    "cheetah-tag-68-description": "Il sito web che vuoi portare le persone - 1",
    "cheetah-tag-68-example": "https://www.it.builderall.com",
    "cheetah-tag-69-description": "Il sito web che vuoi portare le persone - 2",
    "cheetah-tag-69-example": "https://www.it.builderall.com",
    "cheetah-tag-70-description": "Il sito web che vuoi portare le persone - 3",
    "cheetah-tag-70-example": "https://www.it.builderall.com",
    "cheetah-template-82122": "Coach financeiro",
    "cheetah-template-80757": "NL006 - Coach financeiro-funil",
    "cheetah-template-82256": "Funnel Consulente Finanziario",
    "ct-brand-menu": "Logo Mobile",
    "ct-brand-image-menu": "Immagine Brand",
    "ct-brand-position-menu": "Posizione Brand",
    "ct-box-shadow": "Ombreggiatura",
    "ct-item-menu-box-shadow": "Ombreggiatura voce di menù",
    "ct-component-AccordionGroupComponent": "Gruppo Accordion",
    "ct-paddingContainer": "Spaziatura Interna",
    "ct-add-accordion": "Agg. Accordion",
    "ct-component-AccordionComponent": "Accordion",
    "ct-watermark": "Tasto Affiliazione \"Realizzato con Builderall\"",
    "ct-heightContainer": "Altezza Container",
    "ct-bg-color-header": "Colore Header",
    "ct-bg-color-container": "Colore Contenitore",
    "ct-border-container": "Bordo Contenitore",
    "ct-radius-container": "Raggio Contenitore",
    "ct-error-editing-page": "Errore durante la modifica della pagina",
    "ct-error-creating-page": "Errore durante la creazione della pagina",
    "ct-accordion-headline": "Titolo Accordion",
    "ct-element-accordion": "Accordion",
    "ct-bg-config-repeat-attachment-scroll": "Scorri Insieme",
    "ct-bg-config-repeat-attachment-fixed": "Mantieni Fissato",
    "ct-bg-config-repeat-attachment-title": "Durante lo scorrimento",
    "ct-accordiongroup": "Gruppo Accordion",
    "cheetah-template-84980": "NL007 - Corrieri",
    "cheetah-template-87275": "Corrieri",
    "ct-blank-page": "Pagina Vuota",
    "ct-page-templates": "Pagine Template",
    "ct-select-website-to-copy-page-from": "Seleziona il sito/template dal quale vuoi copiare la pagina",
    "ct-select-page-as-template": "Seleziona la pagina che vuoi usare come Template",
    "ct-page-template": "Pagine Template",
    "ct-brand-width-menu": "Dimensione Logo",
    "ct-item-menu-height": "Altezza dell'elemento del menu",
    "ct-item-menu-width": "Larghezza dell'elemento del menu",
    "ct-item-menu-border": "Bordo dell'elemento del menu",
    "ct-item-menu-sub-border": "Bordo dell'elemento sottomenu",
    "ct-recaptcha-site-key": "Site Key",
    "ct-recaptcha-secret-key": "Secret Key",
    "ct-recaptcha": "reCAPTCHA",
    "ct-lists": "Elenchi",
    "ct-recaptcha-take-your-key": "Ottieni la tua key reCAPTCHA v2",
    "ct-only-works-on-publication": "Funzione non disponibile nell'editor o in anteprima ",
    "ct-color-already-added": "Colore già aggiunto",
    "ct-color-linear-color-invalid": "Tipo di colore gradiente non valido",
    "ct-title-h2-blank-panel": "Ciao, sono un Box di Testo, fai doppio clic per modificarmi!",
    "ct-create-new-header": "Crea nuovo header",
    "ct-create-new-footer": "Crea nuovo footer",
    "cheetah-template-96538": "Business Squeeze Page",
    "cheetah-template-96544": "Business Funnel",
    "cheetah-template-96545": "Business Funnel",
    "ct-header-settings": "Impostazioni header",
    "ct-footer-settings": "Impostazioni Footer",
    "ct-which-header": "Scegli l'header",
    "ct-which-footer": "Scegli il  footer",
    "ct-header-empty": "Nessun header selezionato",
    "ct-footer-empty": "Nessun footer selezionato",
    "cheetah-category-template-7": "Funnel Business",
    "cheetah-template-96332": "Nutrizionista",
    "cheetah-template-91762": "NL008 - Nutrizionista - Funnel utente",
    "ct-go-to-sitemap": "Vai alla sitemap",
    "ct-popups": "Pop-ups",
    "ct-headers": "Headers",
    "ct-footers": "Footers",
    "ct-add-icon": "Aggiungi Icona",
    "ct-component-VimeoComponent": "Video Vimeo",
    "ct-add-panel": "Aggiungi un pannello",
    "cheetah-category-template-8": "Siti Mono Pagina",
    "ct-get-response-day-of-cycle": "Giorno del ciclo",
    "ct-get-response-action": "Azione",
    "ct-get-response-redirect-url": "URL Reindirizzamento",
    "ct-get-response-day-of-cycle-msg": "Il giorno in cui il contatto è nel ciclo dell'Autorisponditore. Vuoto significa che il contatto non è nel ciclo.",
    "ct-align-mobile": "Allineamento Testo su Mobile",
    "ct-align-justify": "Giustifica",
    "ct-integration-create-first-with": "Crea la tua prima integrazione con",
    "ct-error-message": "Ops, qualcosa non ha funzionato, riprova!",
    "ct-NewAba": "Apri in una nuova scheda",
    "ct-items-all-edit": "Elementi Globali",
    "ct-items-all-edit-info": "Gli Elementi Globali sono elementi del tipo pop ups, headers e footers",
    "cheetah-template-103346": "Business Squeeze Page",
    "cheetah-template-103410": "Pagina Squeeze Inverso -Business",
    "ct-select-panel": "Seleziona un pannello",
    "cheetah-template-103653": "Business Lead Magnet Page",
    "cheetah-template-103792": "Business Application Page",
    "ct-bg-image": "Immagine Sfondo",
    "ct-panel-restaurants-menu": "Menu dei Ristoranti",
    "cheetah-template-100882": "NL009 - Marido de aluguel",
    "cheetah-template-103700": "Riparazioni domestiche",
    "ct-remove": "Rimuovi",
    "ct-done": "Fatto",
    "ct-recaptcha-get-started": "Per iniziare a utilizzare reCAPTCHA, devi registrarti e ottenere le chiavi API per il tuo sito. La coppia di chiavi è composta da una chiave del sito e una chiave segreta. La chiave del sito viene utilizzata per richiamare il servizio reCAPTCHA sul tuo sito.",
    "ct-recaptcha-explanation": "reCAPTCHA è un servizio gratuito che protegge il tuo sito da spam e abusi. Utilizza tecniche avanzate di analisi del rischio per distinguere umani e robot.",
    "ct-recaptcha-title": "Configurazione reCaptcha",
    "ct-option-set-recaptcha": "Imposta reCaptcha",
    "cheetah-template-109079": "Business Bridge Page",
    "ct-sort": "Ordina",
    "ct-save-sort": "Salva ordinamento",
    "cheetah-template-109459": "Business Thank You Page",
    "cheetah-template-109519": "Pagina \"Questionario\"  Business",
    "cheetah-template-109573": "Business Oto Page",
    "ct-helper-type-files-accept-files": "Upload file in formato PNG, JPG, JPEG, GIF, PDF, DOC, XSL, PPT, TXT o ZIP. Ogni file può essere massimo fino a 10MB.",
    "ct-tab-file-files-user": "Archivi Utenti",
    "ct-upload-images-maxfile": "La dimensione della tua immagine supera il limite di 5MB",
    "ct-upload-files-maxfile": "Il tuo file supera il limite massimo di caricamento di 10MB",
    "ct-upload-videos-maxfile": "La dimensione del tuo video supera il limite di 10MB",
    "ct-members-area-integrations": "Integrazioni",
    "cheetah-template-110810": "Business Downsale Page",
    "cheetah-template-110845": "Business Video Sales Letter Page",
    "ct-component-SliderGroupComponent": "Banner Slider",
    "ct-component-SliderPageComponent": "Pagina Slider",
    "ct-option-add-image": "Aggiungi immagine",
    "ct-option-add-page": "Aggiungi Pagina",
    "ct-category-create": "Crea Categoria",
    "ct-websites": "Tutti i siti",
    "ct-websites-published": "Siti Pubblicati",
    "ct-websites-unpublished": "Siti Non Pubblicati",
    "ct-move-category": "Sposta alla categoria",
    "ct-categories-all": "Tutte le categorie",
    "ct-category-update": "Modifica Categoria",
    "ct-edition": "Edizione",
    "ct-order-by": "Ordina per",
    "ct-category-confirm-delete": "Vuoi realmente cancellare questa categoria?",
    "cheetah-template-110955": "Business Sales Letter Page",
    "ct-website-categories-save-success": "Categoria salvata con successo",
    "ct-website-categories-save-error": "Errore durante il salvataggio della categoria",
    "cheetah-template-111071": "Business Membership Area",
    "ct-websites-all": "Tutti i siti",
    "ct-slidergroup": "Banner Slider",
    "cheetah-template-112076": "Business Webinar Registration",
    "cheetah-template-112559": "Business Webinar Confirmation",
    "cheetah-template-112613": "Business Webinar Indocrination",
    "cheetah-template-112657": "Business Webinar Replay",
    "ct-confirm-pin": "Fisso l'elemento?",
    "ct-notmobile-pin": "La funzione \"fissa\" non funziona nella versione Mobile",
    "ct-manual-pin": "Fissaggio Manuale",
    "ct-orborder-pin": "o scegli il bordo",
    "ct-fix-remove": "Rimuovi",
    "ct-fix-yes": "Fatto",
    "ct-border-pin": "Clicca su uno dei Box per fissare l'elemento ",
    "cheetah-template-113735": "Business Daily Deal",
    "cheetah-template-113822": "Business Product Launch",
    "ct-vc-eh-besta": "Azione non permessa",
    "ct-warning-show-only-preview": "Funziona solo in anteprima o nel sito Live",
    "ct-option-next-slider": "Prossima Pagina",
    "ct-option-prev-slider": "Pagina Precedente",
    "ct-manual-pin-explain": "Quando usi l'opzione manuale, l'elemento resterà bloccato nella posizione in cui lo fissi. ",
    "ct-pin": "Fissa",
    "cheetah-template-115355": "Business Product Launch Order",
    "cheetah-template-115356": "Business Product Launch Order",
    "ct-warning-only-works-correctly-on-publicatio": "Il Fissaggio al bordo, funziona correttamente solo nella versione pubblicata, nell'anteprima potrebbe risultare non corretto.",
    "cheetah-template-115435": "Business Landing Page",
    "cheetah-template-115543": "Business 3 Step Thank You Page",
    "cheetah-template-115593": "Pagina Conferma Email Business",
    "cheetah-template-115655": "Business Download Page",
    "ct-link-web": "Web",
    "ct-link-page": "Pagina",
    "ct-link-phone": "Telefono",
    "ct-link-popup": "Popup",
    "ct-link-anchor": "Ancora",
    "ct-link-video": "Video",
    "ct-link-download": "Download",
    "ct-link-supercheckout": "Supercheckout",
    "ct-link-tags": "Tags",
    "ct-link-slider": "Banner a Rotazione",
    "ct-slider-label": "Seleziona la pagina del tuo banner a rotazione",
    "ct-group-slider": "Banner a Rotazione",
    "ct-refresh-sliders-app": "Ricarica la lista dei banner a rotazione",
    "ct-link-restrict-integration": "Integrazione Ristretta",
    "cheetah-template-119237": "App Squeeze Page",
    "cheetah-template-119296": "Pagina Squeeze Inverso  -App",
    "cheetah-template-121772": "App Lead Magnet Page",
    "ct-effect-slider": "Effetto di transizione",
    "ct-option-effect-none": "Nessuno",
    "ct-option-effect-slide": "Slider",
    "ct-option-effect-fade": "FadeIn/FadeOut",
    "cheetah-template-122214": "App Application Page",
    "cheetah-template-123181": "Site Smart Express - Coach",
    "ct-choose-a-site": "Scegli un sito",
    "ct-choose-a-page": "Scegli una pagina",
    "cheetah-template-123238": "App Bridge Page",
    "cheetah-template-123270": "App Thank You Page",
    "cheetah-template-123296": "Pagina \"Questionario\"  App",
    "cheetah-template-123206": "Coach Smart Express",
    "cheetah-template-123340": "App Oto Page",
    "cheetah-template-123397": "App Downsale Page",
    "cheetah-template-123422": "App VSL Page",
    "ct-panel-legal-pages": "Pagine Legali",
    "cheetah-template-123539": "App Sales Letter Page",
    "cheetah-template-128466": "App Membership Page",
    "ct-size-popup": "Dimensione",
    "ct-overlay-popup": "Sovrapposizione",
    "ct-size-auto": "Auto",
    "ct-size-full-size": "Dimensione massima",
    "ct-popup-overlay-true": "Sovrapposizione abilitata",
    "ct-popup-overlay-false": "Sovrapposizione disabilitata",
    "ct-direction-popup": "Direzione",
    "ct-popup-direction-center": "Centro",
    "ct-popup-direction-bottom": "In basso",
    "ct-popup-direction-top": "Sopra",
    "ct-popup-maxheight": "Altezza Max",
    "cheetah-template-128510": "App Webinar Registration",
    "cheetah-template-128533": "App Webinar Confirmation",
    "cheetah-template-128552": "App Webinar Indocrination",
    "cheetah-template-128568": "App Webinar Replay",
    "cheetah-template-128584": "App Daily Deal",
    "cheetah-template-128761": "App Product Launch",
    "cheetah-template-128846": "App Product Launch Order",
    "cheetah-template-128868": "App Landing Page",
    "cheetah-template-128879": "App 3 Step Thank You Page",
    "cheetah-template-128907": "Pagina Conferma Email App",
    "cheetah-template-128918": "App Download Page",
    "cheetah-category-template-9": "Pagine Funnel Applicazioni",
    "cheetah-category-template-10": "Pagine Legali",
    "cheetah-template-128959": "Privacy Policy - Legal Page",
    "ct-add-imagem": "Aggiungi Immagine",
    "ct-input-text": "Testo",
    "ct-input-textarea": "Area Testo",
    "ct-input-password": "Password",
    "ct-input-checkbox": "Check Box",
    "ct-input-radio": "Radio Box",
    "ct-input-select": "Seleziona",
    "ct-input-date": "Data",
    "ct-input-datetime": "Data e ora",
    "cheetah-template-129000": "Termini di utilizzo del sito Web - Pagine legali",
    "cheetah-template-129053": "Disclaimer - Legal Pages",
    "cheetah-template-129121": "Frequently Asked Questions - Pagine Legali",
    "cheetah-template-129138": "Refund Policy",
    "cheetah-template-129141": "Refund Policy - Legal Page",
    "ct-element-rotation-banner": "Banner a Rotazione",
    "ct-arrow-color-slider": "Colore Freccia",
    "ct-arrow-size-slider": "Dimensione Freccia",
    "ct-republish": "Pubblica di nuovo",
    "cheetah-template-129871": "Course Squeeze Page",
    "ct-popup": "Pop Up",
    "cheetah-template-130303": "Consulente Smart Tag Sito Express",
    "cheetah-template-130283": "Negozio Acai Berry Smart Tag Sito Express",
    "cheetah-template-130341": "Bar Smart Tag Sito Express",
    "cheetah-template-134209": "Memberships Page - Flat",
    "cheetah-template-121788": "NL010BR - Pizzeria",
    "cheetah-template-129215": "Pizzeria",
    "cheetah-category-template-11": "Pagine Corsi",
    "cheetah-template-134509": "Pagina Memberships - Nero",
    "ct-element-magic-form": "Modulo Magic",
    "ct-gdpr-only-btn-label": "Descrizione del Tasto per i soli Cookies obbligatori",
    "ct-gdpr-resetCookies-btn-label": "Etichetta pulsante cancella i cookie",
    "ct-gdpr-resetCookies-border": "il bordo pulsante cancella i cookie",
    "cheetah-template-136620": "Marketing Business",
    "cheetah-template-136630": "Pagina Squeeze Inverso -Corso",
    "cheetah-template-136705": "Course Lead Magnet Page",
    "cheetah-template-136731": "Course Application Page",
    "cheetah-template-136665": "Barbecue Smart Tag Sito Express",
    "cheetah-template-136891": "Course Bridge Page",
    "cheetah-template-136921": "Course Thank You Page",
    "cheetah-template-136807": "Dolci Smart Tag Sito Express",
    "cheetah-template-136947": "Pagina \"Questionario\"  Bridge ",
    "cheetah-template-136950": "Pagina \"Questionario\"  Corsi",
    "ct-link-magic-funnel-link": "Clicca qui",
    "ct-link-magic-funnel": "per aprire la pagina dove trovi il GENERATORE DI LINK per il Modulo Magico",
    "cheetah-template-136968": "Course Oto Page",
    "cheetah-template-137026": "Course Downsale Page",
    "cheetah-template-137061": "Course VSL Page",
    "cheetah-template-137006": "Negozio Caffè Smart Tag Sito Express",
    "cheetah-template-137096": "Course Sales Letter Page",
    "cheetah-template-137195": "Course Membership Area",
    "cheetah-template-137227": "Course Webinar Registration",
    "ct-hint-email-reply-to": "La risposta all'e-mail (replyTo) sarà il campo con il tag 'email' e un valore valido al momento dell'invio del modulo.",
    "cheetah-template-138151": "Course Webinar Confirmation",
    "cheetah-template-138207": "Course Webinar Indocrination",
    "cheetah-template-138248": "Course Webinar Replay",
    "cheetah-template-138310": "Course Daily Deal",
    "cheetah-template-138191": "Crossfit Smart Tag Sito Express",
    "ct-hidden-elements": "Elementi Nascosti\n",
    "cheetah-template-139012": "Course Product Launch",
    "cheetah-template-139085": "Course Product Launch Order",
    "cheetah-template-139154": "Course Landing Page",
    "ct-group": "Gruppo",
    "cheetah-template-139185": "Course 3 Step Thank You",
    "cheetah-template-139230": "Pagina Conferma Email Corsi",
    "ct-widthContainer": "Larghezza del contenitore",
    "ct-component-PlaceMenuComponent": "Pagina Menu Grande",
    "ct-resource-bg-color-selected": "Sfondo dell'Elemento Selezionato",
    "ct-resource-bg-text-selected": "Colore dell'Elemento Selezionato",
    "ct-component-GroupMenuComponent": "Gruppo Menu Grande",
    "cheetah-template-139266": "Course Download Page",
    "cheetah-template-138902": "Integratori Alimentari Smart Tag Sito Express",
    "ct-img-facebook": "Immagine Facebook",
    "ct-img-twitter": "Immagine Twitter",
    "ct-img-instagram": "Immagine Instagram ",
    "ct-img-linkedin": "Immagine Linkedin ",
    "ct-groupmenu": "Gruppo Menu Grande",
    "ct-menu": "Menu",
    "ct-image3d": "Immagine 3D",
    "ct-counterbar": "Barra contatore",
    "ct-imagegallery": "Galleria Immagini",
    "ct-timer": "Timer",
    "ct-getresponseform": "Modulo Get Response",
    "ct-accordion": "Accordion",
    "ct-slidergallery": "Galleria a Scorrimento",
    "cheetah-category-template-12": "Pagine Funnel Corso",
    "cheetah-template-139386": "Abbigliamento & Accessori Fitness Smart Tag Sito Express",
    "ct-add-menu": "Aggiungi menu",
    "ct-option-prev-order": "Muovi a Sinistra",
    "ct-option-next-order": "Muovi a Destra",
    "ct-toast-label-crop": "Ritaglia",
    "ct-toast-label-deleteall": "Cancella tutto",
    "ct-toast-label-delete": "Cancella",
    "ct-toast-label-undo": "Torna indietro",
    "ct-toast-label-redo": "Rifare",
    "ct-toast-label-reset": "Reimposta",
    "ct-toast-label-rotate": "Ruota",
    "ct-toast-label-flip": "Capovolgi",
    "ct-toast-label-draw": "Disegna",
    "ct-toast-label-shape": "Forma",
    "ct-toast-label-icon": "Icona",
    "ct-toast-label-text": "Testo",
    "ct-toast-label-mask": "Maschera",
    "ct-toast-label-filter": "Filtro",
    "cheetah-template-140199": "FoodTruck Smart Tag Sito Express",
    "ct-sticky-video": "Fissa Video",
    "ct-explaining-sticky-video": "Blocca l'elemento su uno dei bordi durante lo scorrimento\n* Non funziona al cellulare",
    "ct-check-sticky": "Abilita Sticky",
    "ct-sticky-select": "Scegli il bordo dove fissare ",
    "ct-sticky-Bright": "In basso a destra",
    "ct-sticky-Bleft": "In basso a sinistra",
    "ct-sticky-Tright": "In alto a destra",
    "ct-sticky-Tleft": "In alto a sinistra",
    "ct-sticky-width": "Larghezza (max:600)",
    "ct-gdpr-activeReset": "Attiva il Tasto Reimposta i Cookies",
    "ct-place-menu-100": "100% di larghezza",
    "ct-element-big-menu": "Menu Grande",
    "cheetah-template-140724": "Allenamento Funzionale Smart Tag Sito Express",
    "ct-republished": "Sito ripubblicato con successo",
    "ct-clear-cookies": "Pulisci i Cookies",
    "ct-gdpr-only-btn-label-app": "Solo Indispensabili",
    "gdpr-only-btn-label-app": "Accetta solo i Cookies Indispensabili",
    "cheetah-template-138113": "NL011BR - Limpeza de piscina",
    "cheetah-template-141684": "Pulizia Piscine",
    "ct-color-read-more": "Colore Leggi di più",
    "ct-color-details": "Colore Dettagli",
    "ct-button-blog-title-style-headline": "Stile Titolo",
    "ct-button-blog-content-style-headline": "Stile Contenuto Anteprima",
    "ct-format-date": "Formato Data",
    "ct-theme-blog": "Tema",
    "ct-news-per-page": "News per pagina",
    "ct-read-more-text": "Testo Leggi di più",
    "ct-theme-blog-align-left": "Allineamento Predefinito Sinistra",
    "ct-theme-blog-align-right": "Allineamento Predefinito Destra",
    "ct-theme-blog-align-mix": "Allineamento Predefinito Centro",
    "ct-theme-blog-cards": "Carte",
    "ct-theme-blog-grid": "Griglia",
    "ct-theme-blog-card-new": "Effetto Carta",
    "ct-redirect-to": "Reindirizza a",
    "ct-no-index": "<noindex> tag",
    "ct-no-index-helper": "Il valore noindex di un meta tag robot HTML richiede che i robot automatizzati Internet evitino l'indicizzazione di questa pagina Web.",
    "ct-redirect-to-helper": "Se desideri che l'utente venga reindirizzato a un'altra pagina, scrivi semplicemente l'URL in questo campo e ripubblica il tuo sito.",
    "ct-side-of-watermark": "Posizione del Tasto Affiliazione",
    "ct-center": "Centro",
    "ct-lang-of-watermark": "Lingua di apertura URL Tasto Affiliazione ",
    "cheetah-template-158481": "Course Daily Deal",
    "cheetah-template-158482": "Course Daily Deal",
    "cheetah-template-159091": "Barbiere",
    "ct-toast-editor-image": "Editor Immagini",
    "ct-show-burguer-menu-close-icon": "Mostra icona Chiudi",
    "ct-menu-mobile-effect": "Effetti Menu Mobile",
    "ct-option-menu-mobile-effect-blind": "Blind",
    "ct-option-menu-mobile-effect-bounce": "Rimbalzo",
    "ct-option-menu-mobile-effect-clip": "Clip",
    "ct-option-menu-mobile-effect-drop": "Goccia",
    "ct-option-menu-mobile-effect-fade": "Dissolvenza",
    "ct-option-menu-mobile-effect-fold": "Piega",
    "ct-option-menu-mobile-effect-puff": "Soffio",
    "ct-option-menu-mobile-effect-pulsate": "Pulsante",
    "ct-option-menu-mobile-effect-scale": "Scalare",
    "ct-option-menu-mobile-effect-shake": "Scossa",
    "ct-option-menu-mobile-effect-size": "Dimensione",
    "ct-option-menu-mobile-effect-slide": "Scorrimento",
    "cheetah-template-171936": "Coach",
    "cheetah-template-173055": "Agency Squeeze Page",
    "cheetah-template-173253": "Pagina Squeeze Inverso -Agenzia",
    "cheetah-template-173600": "Agency Lead Magnet Page",
    "cheetah-template-173704": "Agency Application Page",
    "cheetah-template-173730": "Agency Bridge Page",
    "cheetah-template-173803": "Agency Thank You Page",
    "cheetah-template-173816": "Pagina \"Questionario\"  Agenzia",
    "ct-option-menu-mobile-effect-none": "Nessuno",
    "ct-blog": "Blog",
    "ct-blog-page-not-authorized": "Disconnetti il blog per cancellare le pagine",
    "ct-component-BlogPostComponent": "Articolo",
    "ct-component-BlogFeedNewsComponent": "FeedNews",
    "ct-blog-pages": "Pagine Blog",
    "cheetah-template-155771": "Palestra Smart Tag Sito Express",
    "cheetah-template-179281": "Cibo Salutare Smart Tag Sito Express",
    "cheetah-template-179391": "Barbiere Pagina Singola",
    "ct-connect-domain-helper": "Collega prima il tuo dominio al tuo sito web e poi configura il DNS. Riceverai nuove informazioni nella schermata successiva",
    "cheetah-template-179312": "Gelateria Smart Tag Sito Express",
    "cheetah-template-179341": "Nightclub Smart Tag Sito Express",
    "cheetah-template-180513": "Agency Oto Page",
    "cheetah-template-180548": "Agency Downsale Page",
    "cheetah-template-180505": "Nutrizionista Smart Tag Sito Express",
    "cheetah-template-180529": "Party Snacks Smart Tag Sito Express",
    "cheetah-template-180547": "Personal Trainer Smart Tag Sito Express",
    "cheetah-template-180580": "Agency VSL Page",
    "cheetah-template-180610": "Agency Sales Letter Page",
    "cheetah-template-180577": "Pizzeria Smart Tag Sito Express",
    "cheetah-template-180617": "Pub Smart Tag Sito Express",
    "ct-confirm-delete-page": "Conferma cancellazione pagina",
    "cheetah-template-180619": "Ristorante Smart Tag Sito Express",
    "cheetah-category-template-13": "Barbiere ",
    "cheetah-category-template-14": "Coach",
    "cheetah-template-182827": "Agency Membership Area",
    "cheetah-template-158784": "NL012 - Móveis planejados",
    "cheetah-template-179302": "Vendita e montaggio mobili 01",
    "cheetah-template-205226": "Agency Webinar Registration",
    "cheetah-template-205227": "Agency Webinar Registration",
    "cheetah-template-205272": "Agency Webinar Confirmation",
    "cheetah-template-205312": "Agency Webinar Indocrination",
    "cheetah-template-205325": "Agency Webinar Broadcast",
    "cheetah-template-205330": "Agency Webinar Replay",
    "cheetah-template-180660": "Allenamento Running Smart Tag Sito Express",
    "ct-type-liberation": "Tipo di menu elemento rilasciato",
    "ct-type-liberation-none": "Già rilasciato",
    "ct-type-liberation-date": "Da una data specifica",
    "ct-type-liberation-time": "Per data di accesso",
    "ct-type-liberation-date-explain": "Questa opzione ti permette di scegliere una data per l'elemento del menu per farlo apparire su tutti i siti ",
    "ct-type-liberation-time-explain": "Questa opzione consente di definire un orario specifico per la visualizzazione di questo elemento agli utenti del sito. Attenzione, l'accesso dell'utente è contrassegnato al primo accesso alla pagina con questo menu.",
    "cheetah-template-205963": "Agency Daily Deal",
    "cheetah-template-205992": "Agency Product Launch",
    "ct-release-date": "Data Rilascio",
    "cheetah-template-206044": "Agency Product Launch Order",
    "cheetah-template-206094": "Agency Landing Page",
    "ct-component-MenuComponentDrip": "Menu Drip",
    "cheetah-template-206117": "Agency 3 Step Thank You Page",
    "cheetah-template-206208": "Pagina Conferma Email Agenzia",
    "cheetah-template-206230": "Agency Download Page",
    "cheetah-category-template-15": "Pagine Funnel Agenzia",
    "ct-sticky-okay": "Fatto!",
    "cheetah-template-249721": "Coach Squeeze Page",
    "cheetah-template-257872": "Pagina Squeeze Inverso -Coach",
    "ct-elearning": "E-Learning",
    "ct-elearning-courses-empty": "Non c'è ancora nessun corso",
    "ct-sticky-remove-rotate": "Lo stick video rimuove la rotazione dell'elemento nell'anteprima e in pubblicazione",
    "ct-sticky-small": "Piccolo",
    "ct-sticky-medium": "Medio",
    "ct-sticky-large": "Grande",
    "ct-sticky": "Sticky Video ",
    "cheetah-template-284381": "Coach Lead Magnet Page",
    "cheetah-template-289964": "Coach Application Page",
    "cheetah-template-290684": "Coach Bridge Page",
    "ct-remove-elearning": "Rimuovi E-learning",
    "ct-element-menu-dripping": "Menu Dripping",
    "ct-set-time": "Assegna sblocco",
    "ct-wait-10": "Attendi 10 minuti e riprova ancora",
    "ct-members-redirect-elearning": "Redirect dopo il Login",
    "ct-restrict-elearning-page": "Normalmente reindirizza alla pagina",
    "ct-restrict-elearning-course": "Reindirizza alla pagina del corso",
    "cheetah-template-309329": "Fitness Onepage",
    "ct-wait-one-week": "Gli account appena creati dovrebbero attendere una settimana per creare più siti",
    "ct-members-choose-course": "Scegli il corso",
    "ct-elearning-redirect": "Redirect dopo il Login",
    "ct-redirect-page-normally": "Normalmente reindirizza alla pagina",
    "ct-redirect-elearning-course": "Reindirizza alla pagina del corso",
    "ct-redirect-target-same": "Stesso tab",
    "ct-redirect-target-blank": "Nuovo tab",
    "ct-members-elearning-target": "Come si apre l'E-Learning",
    "ct-members-selected-course": "Scegli un corso E-Learning",
    "ct-colors": "Colori Generali",
    "ct-color-hover": "Colore Hover",
    "ct-component-BlogCategoriesListComponent": "Lista Articoli Blog",
    "ct-component-BlogSearchComponent": "Barra Ricerca Blog",
    "ct-search-label-text": "Etichetta Cerca",
    "ct-search-label-btn": "Etichetta Ricerca",
    "ct-button-style": "Stile Bottone",
    "cheetah-template-307294": "Imbianchini",
    "cheetah-template-220782": "NL013 - Pintor",
    "cheetah-template-314096": "Fitness",
    "cheetah-template-314646": "Coach Thank You Page",
    "cheetah-template-314695": "Pagina \"Questionario\" Coach",
    "cheetah-template-314768": "Coach Oto Page",
    "cheetah-template-314873": "Coach Downsale Page",
    "cheetah-template-314904": "Coach VSL Page",
    "cheetah-template-314956": "Coach Sales Letter Page",
    "ct-template-tags": "Template Tags ",
    "cheetah-template-316208": "Coach Membership Area",
    "ct-panel-membership-module": "Area Riservata",
    "cheetah-template-316281": "Coach Webinar Registration",
    "cheetah-template-316427": "Coach Webinar Confirmation",
    "cheetah-template-316499": "Coach Webinar Indocrination",
    "cheetah-template-316555": "Coach Webinar Broadcast",
    "cheetah-template-316567": "Coach Webinar Replay",
    "cheetah-template-316602": "Webinar Daily Deal",
    "cheetah-template-316604": "Webinar Daily Deal",
    "cheetah-template-316605": "Coach Daily Deal Page",
    "cheetah-template-316750": "Coach Product launch",
    "cheetah-template-316773": "Coach Product Launch Order",
    "cheetah-template-317512": "Coach Landing Page",
    "cheetah-template-317535": "Coach 3 Step Thank You Page",
    "sidebar-categories-button": "Categories",
    "cheetah-template-317593": "Pagina Conferma Email Coach",
    "cheetah-template-317833": "Coach Download Page",
    "cheetah-category-template-16": "Pagine Funnel Coach",
    "cheetah-template-318110": "Avvocato Divorzista",
    "ct-suggestions": "Suggestions",
    "ct-component-VidelloVideoComponent": "Vidello",
    "ct-videllovideo": "Vidello",
    "ct-component-VideoGalleryGroupComponent": "Video Gallery - Gruppo",
    "ct-videogallerygroup": "Video Gallery - Gruppo",
    "ct-component-VideoGalleryComponent": "Video Gallery - Elemento",
    "ct-perc-size-video": "Percentuale della dimensione del video ",
    "ct-container-close-icon-size": "Dimensione Icona Chiudi",
    "ct-container-close-icon": "Icona Chiudi",
    "ct-container-close-icon-color": "Colore Icona Chiudi",
    "ct-icon-close-config": "Configurazione Icona Chiudi",
    "ct-category": "Categoria",
    "ct-global-items": "Elementi",
    "ct-add-category": "Aggiungi Categoria",
    "ct-edit-category": "Modifica Categoria",
    "ct-add-video": "Aggiungi Video",
    "ct-video-url": "URL Video",
    "ct-video-thumbnail": "Miniatura Video",
    "ct-select-image": "Seleziona immagine",
    "ct-config-videos": "Configurazione degli elementi",
    "ct-amount-of-videos": "Numero di video per pagina",
    "cheetah-template-319730": "Muscle Mass Squeeze Page",
    "ct-height-content": "Altezza Contenuto",
    "ct-no-categories-on-your-blog": "No Categories Found",
    "ct-helper-create-articles": "Crea nuovi articoli nell'amministrazione del Blog",
    "ct-no-authors-blog": "No authors found",
    "ct-helper-create-categories": "Crea nuove categorie in blog admin",
    "ct-helper-create-authors": "Crea autori in blog admin",
    "ct-no-authors-on-your-blog": "No authors found",
    "ct-color-read-more-hover": "Colore Hover Leggi di più",
    "cheetah-template-320603": "Pagina Squeeze Inverso -Massa Muscolare",
    "cheetah-template-320844": "Muscle Mass Lead Magnet Page",
    "cheetah-category-template-17": "Salute & Fitness",
    "cheetah-category-template-18": "Avvocato",
    "cheetah-template-320905": "Muscle Mass Application Page",
    "cheetah-template-320971": "Muscle Mass Bridge Page",
    "cheetah-template-321027": "Muscle Mass Thank You Page",
    "cheetah-template-321052": "Pagina \"Questionario\"  Massa Muscolare",
    "cheetah-template-321080": "Muscle Mass Oto Page",
    "cheetah-template-321226": "Muscle Mass Downsale",
    "cheetah-template-316599": "NL014 - Traduttori",
    "cheetah-template-319954": "Traduttori",
    "ct-reset-password-notification": "Notifica Reset Password",
    "ct-receiving-because-password-reset": "Ricevi questa email perché abbiamo ricevuto una richiesta di reimpostazione della password per il tuo account.",
    "ct-reset-password": "Reset Password",
    "ct-reset-password-if-didnot-request": "Se non è stata richiesta la reimpostazione della password, non sono necessarie ulteriori azioni",
    "ct-regards": "Saluti",
    "ct-reset-having-trouble-clicking": "Se riscontri problemi facendo clic sul pulsante \"Reimposta password\", copia e incolla l'URL seguente nel browser Web:",
    "ct-your-password-updated": "La tua password aggiornata",
    "ct-your-password-on": "La tua password su",
    "ct-has-been-successfully-updated": "è stato aggiornato con successo",
    "ct-thanks-using-our-app": "Grazie per aver utilizzato la nostra applicazione!\n",
    "ct-receiving-because-password-updated": "Ricevi questa email perché la password è stata aggiornata correttamente.",
    "ct-welcome-members-area-of": "Benvenuti nell'area membri di",
    "ct-component-BlogRssComponent": "RSS Feed",
    "ct-high-complexity": "A causa dell'elevata complessità di questa applicazione, alcune modifiche hanno effetto solo al momento dell'anteprima o della pubblicazione",
    "ct-need-valid-thumbnail": "È necessaria una miniatura valida",
    "ct-need-valid-url": "Serve un indirizzo valido",
    "ct-component-BlogAuthorCardComponent": "Card Author",
    "ct-height-image": "Height Image",
    "ct-background-color": "Colore Sfondo",
    "cheetah-template-325825": "Business Membership Area",
    "ct-move-panel-down": "Porta il pannello in basso",
    "ct-move-panel-up": "Porta il pannello sopra",
    "ct-emailSubject": "Soggetto",
    "ct-emailCC": "CC",
    "ct-emailBody": "Corpo",
    "ct-Emailcc-error": "Il campo CC deve essere un indirizzo email valido",
    "ct-component-blog-news-slider-component": "Blog news slider",
    "ct-option-blog-news-settings": "Impostazioni Articoli Blog",
    "ct-blog-news-source-modal": "Sorgente Articolo",
    "ct-blog-news-latest-modal": "Nuovi Articoli",
    "ct-blog-news-featured-modal": "Articoli in Primo Piano",
    "ct-blog-news-total-modal": "Totale Articoli",
    "ct-blog-news-show-title-modal": "Mostra Titolo",
    "ct-blog-news-show-desc-modal": "Mostra Descrizione",
    "ct-blog-news-redirect-modal": "Articolo di reindirizzamento",
    "ct-size-image-helper": "La dimensione ideale è 320x180",
    "ct-emailBCC": "CCN",
    "ct-Emailbcc-error": "Il campo CC deve essere un indirizzo email valido",
    "ct-element-video-gallery": "Galleria Video",
    "ct-show-categories": "Mostra categorie",
    "ct-show-author": "Mostra Autore",
    "ct-option-blog-post-settings": "Impostazioni Articoli Blog ",
    "ct-shadow-h": "Offset orizzontale dell'ombra",
    "ct-shadow-v": "Offset verticale dell'ombra",
    "ct-shadow-b": "Raggio di sfocatura",
    "ct-shadow-s": "Raggio di diffusione",
    "ct-shadow-color": "Colore dell'ombra",
    "ct-shadow-inset": "Ombra interna?",
    "cheetah-template-325445": "NL015 - Corretor de Seguros",
    "cheetah-template-329079": "Assicuratori 01",
    "cheetah-template-330473": "Nutra11",
    "ct-blog-title-style-headline": "Stile Titolo",
    "ct-blog-colors-headline": "Colori",
    "ct-blog-color-1": "Colore 1",
    "ct-customize-divider": "Personalizzare il formato?",
    "ct-customize-divider-helper": "Alcuni formati non possono ancora essere personalizzati",
    "ct-blog-color-2": "Colore 2",
    "ct-blog-color-3": "Colore 3",
    "ct-blog-color-4": "Colore 4",
    "ct-blog-color-5": "Colore 5",
    "ct-blog-sizes-headline": "Dimensioni",
    "ct-shape-divider-first-size": "Prima forma\n",
    "ct-shape-divider-second-size": "Seconda forma\n",
    "ct-blog-image-height": "Altezza Miniatura",
    "ct-shape-divider-third-size": "Terza forma\n",
    "ct-shape-divider-fourth-size": "Quarta forma\n",
    "ct-blog-image-width": "Larghezza Miniatura",
    "ct-blog-content-height": "Altezza Contenuto",
    "ct-blog-content-width": "Larghezza Contenuto",
    "ct-blog-title-height": "Altezza Titolo",
    "ct-blog-title-width": "Larghezza Titolo",
    "ct-blog-button-div-height": "Altezza Tasto Spaziatura ",
    "ct-blog-button-div-width": "Larghezza Tasto Spaziatura",
    "ct-blog-button-height": "Altezza Tasto",
    "ct-blog-button-width": "Larghezza Tasto",
    "ct-blog-card-height": "Altezza Carta",
    "ct-blog-content-style-headline": "Stile Contenuto",
    "ct-blog-button-style-headline": "Stile Tasto",
    "ct-blog-author-style-headline": "Stile Autore",
    "ct-blog-categories-style-headline": "Stile Categorie",
    "ct-component-BlogArticleListComponent": "Articoli",
    "ct-display-options": "Opzioni di visualizzazione",
    "ct-show-thumbnail": "Mostra Miniature",
    "ct-show-date": "Mostra Data",
    "ct-show-content": "Mostra Contenuto",
    "ct-show-button": "Mostra Tasto",
    "ct-featured-options": "Opzioni in evidenza",
    "ct-feed-options": "Opzione del Feed",
    "ct-amount": "Quantità",
    "ct-without-featured": "Without featured",
    "ct-filters": "Filters",
    "ct-author": "Author",
    "ct-order": "Ordine",
    "ct-headline": "headline",
    "ct-date-format": "Formato della Data",
    "ct-show-socialbar": "Mostra Barra dei Social",
    "ct-copy-social": "Copia Url",
    "ct-views": "Views",
    "ct-title-helper-p": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam consequat elit vitae molestie vestibulum. Pellentesque in consequat ipsum, ut hendrerit lacus. Nam laoreet ligula congue nibh maximus dapibus. Aenean eleifend nisi pretium, dignissim turpis ac, hendrerit libero. Donec dolor erat, condimentum vel pellentesque quis, convallis eget sem. Vivamus scelerisque ac tortor feugiat pharetra. Vivamus non laoreet mauris. ",
    "ct-element-blog-featured": "Blog Featured",
    "ct-element-blog-feednews": "Blog FeedNews",
    "ct-element-blog-general-apps": "Blog General",
    "ct-element-blog-group-news": "Blog Groups",
    "ct-element-blog-post": "Articoli del Blog",
    "ct-helper-select-valid-filter": "Nessun articolo trovato",
    "ct-no-articles-selected": "No articles found",
    "ct-border-color": "Colore Bordo",
    "ct-border-shape": "Forma del Bordo\n",
    "ct-border-size": "Dimensione Bordo",
    "ct-return": "Indietro",
    "ct-panel-oto-page": "OTO Page ",
    "ct-panel-membership-area": "Area Membri",
    "ct-panel-lead-magnet-page": "Lead Magnet Page ",
    "ct-panel-reverse-squeeze-page": "Squeeze Inverso",
    "ct-panel-sales-letter-page": "Sales Letter Page ",
    "ct-panel-application-page": "Application Page ",
    "ct-panel-ask-page": "Pagina \"Questionario\" ",
    "ct-panel-bridge-page": "Bridge Page ",
    "ct-panel-downsale-page": "Downsale Page ",
    "ct-panel-thank-you-page": "Thank You Page ",
    "ct-panel-vsl-page": "VSL Page ",
    "ct-panel-webinar-confirmation": "Webinar Confirmation ",
    "ct-panel-webinar-indocrination": "Webinar Indocrination ",
    "ct-panel-webinar-registration": "Webinar Registration ",
    "ct-panel-webinar-replay": "Webinar Replay ",
    "ct-panel-squeeze-page": "Squeeze Page ",
    "ct-align-socialbar": "Align socialbar",
    "ct-blogpost": "Articoli del Blog",
    "ct-ct-blog-color-1": "Colore 1",
    "ct-ct-blog-color-2": "Colore 2",
    "ct-ct-blog-color-3": "Colore 3",
    "ct-members-elearning-logout-page": "Dopo essere uscito da elearning, reindirizzare a\n",
    "ct-choose-elearning-redirection-logout": "Scegli la pagina dove reindirizzare ",
    "ct-automatic-emails-integrations": "Email Automatiche - Integrazioni",
    "ct-email-theme-sale-completed": "Acquisto completato",
    "ct-email-theme-sale-canceled": "Acquisto cancellato",
    "ct-email-theme-sale-recurrence-completed": "Ricorrenza Completata",
    "ct-email-theme-sale-recurrence-canceled": "Ricorrenza cancellata",
    "ct-integrations-subject-sale-completed": "Acquistato con successo\n",
    "ct-integrations-subject-sale-canceled": "Acquisto annullato",
    "ct-integrations-subject-sale-recurrence": "Pagamento rata",
    "ct-integrations-subject-sale-recurrence-cance": " ",
    "ct-integrations-sale-completed-title": "Grazie per il tuo acquisto",
    "ct-integrations-sale-completed-description": "Apprezziamo la tua preferenza e ti ringraziamo per aver acquistato il nostro prodotto. Se hai domande, non esitare a contattarci.\n",
    "ct-integrations-thanks-app": "Grazie per aver utilizzato la nostra applicazione\n",
    "ct-integrations-sale-canceled-title": "Acquisto cancellato",
    "ct-integrations-sale-canceled-description": "I servizi che hai utilizzato sul nostro sito Web sono stati cancellati. Se hai domande, non esitare a contattarci.",
    "ct-integrations-sale-recurrence-title": "Grazie per il rinnovo dei nostri servizi",
    "ct-integrations-sale-recurrence-description": "Apprezziamo la preferenza e la ringraziamo per il rinnovo dei servizi sul nostro sito Web.",
    "ct-integrations-subject-recurrence-canceled": "Rata annullata",
    "ct-integrations-recurrence-cancel-description": "I servizi che hai utilizzato sul nostro sito Web sono stati cancellati. Se hai domande, non esitare a contattarci.",
    "ct-integrations-recurrence-cancel-title": "Il rinnovo del servizio è stato annullato\n",
    "ct-integration-code": "Codice Integrazione",
    "ct-manager-emails-integrations": "Gestisci le email automatiche per l'integrazione\n",
    "ct-integration-automatic-email": "Scegli Email Automatica",
    "ct-choose-automatic-email": "Scegli Email Automatica",
    "ct-background-page": "Sfondo Pagina",
    "ct-font-group-site": "Font del sito",
    "ct-element-blog-lists": "Blog Lists",
    "ct-tag-group-deleted": "Tag deleted",
    "cheetah-template-337774": "NL016 - Psicologi",
    "cheetah-template-339913": "NL016 - Psicologi",
    "cheetah-category-template-19": "Agenzia Marketing",
    "cheetah-template-334855": "SEO Strategy",
    "cheetah-template-337604": "Business Agency",
    "cheetah-template-338815": "Agency Design",
    "cheetah-template-180691": "Coach One Page",
    "ct-panel-3-step-thank-you-page": "Thank You Page 3 Step",
    "ct-panel-confirm-email-page": "Confirm Email Page ",
    "ct-panel-daily-deal": "Daily Deal ",
    "ct-panel-download-page": "Download Page ",
    "ct-panel-landing-page": "Landing Page ",
    "ct-panel-product-launch": "Lancio Prodotto",
    "ct-panel-product-launch-order": "Ordine Lancio Prodotto\n",
    "ct-sizes": "Dimensioni",
    "ct-min-height": "Altezza Minima",
    "ct-background-settings": "Impostazioni Sfondo",
    "ct-border-radius": "Raggio Bordo",
    "ct-layers": "Livelli",
    "ct-page-is-member": "Pagina Membri",
    "ct-page-members-create": "Crea Pagina Membri",
    "ct-page-members": "Pagina Membri",
    "ct-page-members-description": "facendo clic su Salva aggiungiamo una pagina membri al tuo sito, puoi eliminarla quando vuoi.\n",
    "ct-profile-exemple-content": "Contenuto di esempio",
    "ct-areas-exemple-content": "Contenuto di esempio",
    "ct-component-ButtonUserComponent": "Bottone Utente",
    "ct-component-ContentNavUserComponent": "Tabs Nav Utente",
    "ct-icon-enable": "Imposta icone",
    "ct-icons-enable": "Icone abilitate ",
    "ct-icons-disable": "Icona disabilitata",
    "ct-tab-content-bg-color": "Colore sfondo Tab contenuto",
    "ct-tab-text-active-color": "Colore testo Tab attiva",
    "ct-tab-bg-color": "Colore sfondo Tab",
    "ct-tab-active-bg-color": "Colore di sfondo Tab attiva",
    "ct-tab-hover-bg-color": "Colore sfondo Tab hover",
    "ct-tab-nav-border": "Bordo Tab",
    "ct-tab-content-border": "Bordo Tab contenuto",
    "ct-tab-nav-box-shadow": "Ombra Tab",
    "ct-tab-content-box-shadow": "Ombra box Tab contenuto",
    "ct-config-dropdown": "Imposta menu a discesa",
    "ct-with-dropdown": "Con dropdown",
    "ct-without-dropdown": "Senza dropdown",
    "ct-actions-format": "Formato Azioni",
    "ct-only-register": "Solo Registrati",
    "ct-only-login": "Solo Login",
    "ct-text-login": "Testo Login",
    "ct-icon-login": "Icona Login",
    "ct-text-register": "Testo Registrati",
    "ct-icon-register": "Icona Registrati",
    "ct-text-logout": "Testo Logout",
    "ct-icon-logout": "Icona Logout",
    "ct-config-regard": "Imposta saluti",
    "ct-with-regard": "Con saluto",
    "ct-without-regard": "Con Saluto",
    "ct-text-regards": "Testo Saluti",
    "ct-icon-regards": "Icona Saluti",
    "ct-dropdown-bg-color-hover": "Colore sfondo Dropdown hover",
    "ct-dropdown-border": "Bordo Dropdown",
    "ct-dropdownBoxShadow": "Ombra Box Dropdown",
    "ct-config-tabs": "Impostazioni Tabs",
    "ct-config-tab-visibled": "Tab visibili",
    "ct-config-tab-order": "Ordine Tab",
    "ct-areas": "Area Membri",
    "cheetah-template-349179": "Paesaggista 01",
    "cheetah-template-352962": "Paesaggista 02",
    "ct-alt-image": "Alt",
    "ct-title-image": "Titolo",
    "ct-imageSrc": "Image",
    "ct-sizeSticky-error": "Scegliere la dimensione",
    "ct-positionSticky-error": "Scegliere una posizione",
    "ct-button-user-config-link": "Impostazioni Link di Azione",
    "ct-members-btn-after-register": "Dopo la Registrazione l'utente viene reindirizzato a ",
    "ct-members-after-register-empty-help": " Aiuto dopo la registrazione dell'utente",
    "ct-members-btn-after-login": "Dopo il login l'utente viene reindirizzato a ",
    "ct-members-btn-after-logout": "Dopo il Logout l'utente viene reindirizzato a ",
    "ct-buttonuser": "Bottone Utente",
    "ct-profile": "Profilo",
    "ct-contentnavuser": "Contenuti dell'Utente",
    "ct-config-tab-isempty": "Ci deve essere almeno un Tab",
    "ct-website-senders": "Mittenti",
    "ct-sender-other-settings": "Mittenti per inviare e-mail e anche altre impostazioni\n",
    "ct-sender-integrations": "Mittenti per integrazioni\n",
    "ct-sender-other-settings-help": " Altre impostazioni del mittente",
    "ct-sender-integrations-help": "Mittenti devono essere registrati in MailingBoss",
    "ct-dropdownBorderRadius": "Raggio bordo Dropdown",
    "ct-exemple-name": "Nome di esempio",
    "ct-page-members-selected": "Seleziona una pagina",
    "ct-members-page-home": "Pagina principale Area Membri",
    "ct-members-choose-page-home": "Pagina principale Area Membri",
    "ct-members-selected-page-home": "Seleziona la pagina",
    "ct-members-page-home-help": "Questa pagina viene utilizzata nell'app dei contenuti dell'utente\n",
    "ct-text-color-hover": "Colore Testo hover",
    "ct-dropdown-text-color-hover": " Colore Testo dropdown hover",
    "ct-dropdown-bg-color": "Colore sfondo Dropdown",
    "cheetah-template-357242": "Artesanato",
    "cheetah-template-360194": "Artigiani",
    "ct-default-option": "Opzione di default\n",
    "ct-btnUserTextStyle": "Stile testo pulsante\n",
    "ct-dropdown-user-textstyle": "Stile testo a discesa\n",
    "ct-tab-nav-textstyle": "Stile di testo della scheda di navigazione\n",
    "ct-tab-content-textstyle": "Stile di testo contenuto\n",
    "ct-browser": "Abilita Notifica Browser\n",
    "ct-browser-error": "Notifica Browser già abilitata\n",
    "ct-bg-icon-color": "Colore Icone",
    "ct-text-counter-headline": "Conteggio Testo ",
    "ct-arrow-resource_components-slide": "Arrow",
    "ct-resource-components": "Risorse dei componenti\n",
    "ct-members-page-home-elearning-help": "Hai un elearning collegato alla tua area riservata, quando scegli di reindirizzare al corso, la tua pagina principale diventa la pagina del corso\n",
    "ct-btn-user-redirect-elearning": "Tu hai un elearning collegato alla tua area riservata, vuoi reindirizzare all'elearning dopo il login\n",
    "ct-element-btn-user-2": "Pulsante Utente\n",
    "ct-element-user-items": "Tasto per Area Membri\n",
    "ct-browser-open": "Invia Notifica",
    "ct-browser-not-exist": "Notifica Browser non ancora abilitata\n",
    "ct-browser-remove": "Disabilita la Notifica del Browser\n",
    "ct-confirm-delete-browser": "Vuoi davvero disabilitare l'invio di notifiche?\n",
    "ct-link-page-editor": "Pagina dell'editor\n",
    "ct-link-page-web": "Pagina web",
    "ct-link-action-double": "Azione di reindirizzamento\n",
    "ct-link-action-double-alert": "Hai scelto l'opzione per \"aprire in una nuova scheda\". Ora puoi selezionare una delle opzioni sopra per cambiare l'azione della pagina corrente dopo l'apertura della nuova scheda. Questa azione non è disponibile per l'anteprima nell'editor, ma solo dopo la pubblicazione della pagina.\n",
    "ct-link-page-choose": "Seleziona la pagina\n",
    "cheetah-template-366876": "NL019 - Barbearia",
    "cheetah-template-368048": "Barbiere",
    "ct-link-adv-options": "Opzioni Avanzate",
    "cheetah-template-143684": "Condividi il Funnel",
    "ct-show-info": "Mostra info",
    "ct-show": "Mostrare",
    "ct-calendar-all": "All calendar",
    "ct-calendar-group-specific": "Group specific",
    "ct-select-group": "Select group",
    "ct-component-BookingCalendarComponent": "Booking calendar",
    "ct-full-height": "Altezza intera",
    "ct-select-calendar": "Select calendar",
    "ct-browser-info": "Notifiche Browser permettono di inviare notifiche agli utenti del sito",
    "ct-browser-option": "Notifiche Browser",
    "ct-booking": "Calendari",
    "ct-option-config": "Configura elemento",
    "ct-bookingcalendar": "Prenotazione",
    "ct-order-panels": "Ordine Pannelli",
    "ct-animation-disabled": "Hai animazioni disabilitate sul tuo sistema operativo.\nPer favore, attivale per visualizzare le animazioni",
    "cheetah-template-377014": "Muscle Mass Downsale Page",
    "cheetah-template-377038": "Muscle Mass VSL Page",
    "cheetah-template-377176": "Muscle Mass Sales Letter Page",
    "cheetah-template-377239": "Muscle Mass Membership Area",
    "ct-members-elearning-not-approved": "Non approvato",
    "cheetah-template-373146": "Serviço de limpeza",
    "cheetah-template-375845": "Servizi di Pulizie",
    "cheetah-template-379765": "Muscle Mass Webinar Registration",
    "cheetah-template-379813": "Muscle Mass Webinar Confirmation",
    "cheetah-template-379850": "Muscle Mass Webinar Indocrination",
    "cheetah-template-379870": "Muscle Mass Webinar Indocrination",
    "cheetah-template-379873": "Muscle Mass Webinar Replay",
    "cheetah-template-380017": "Muscle Mass Daily Deal",
    "cheetah-template-380036": "Muscle Mass Product Launch",
    "cheetah-template-380127": "Muscle Mass Product Launch Order",
    "cheetah-template-380241": "Muscle Mass Landing Page",
    "cheetah-template-380256": "Muscle Mass 3 Step Thank You Page",
    "cheetah-template-380291": "Pagina Conferma Email Muscle Mass",
    "cheetah-template-380305": "Muscle Mass Download Page",
    "cheetah-category-template-20": "Pagine Funnel Fitness",
    "ct-booking-create": "Crea nuovo calendario",
    "ct-booking-have-create": "Puoi creare un calendario per appuntamenti nella nostra",
    "ct-booking-app": "Applicazione Booking",
    "ct-element-booking": "Booking",
    "cheetah-template-383702": "Car Squeeze Page",
    "cheetah-template-383777": "Pagina Squeeze Inverso -Auto",
    "ct-internal-background-settings": "Impostazioni Sfondo Interno",
    "ct-max-height-custom": "Custom Max height",
    "cheetah-template-387675": "Car Lead Magnet Page",
    "cheetah-template-387946": "Car Application Page",
    "cheetah-template-388006": "Car Bridge Page",
    "cheetah-template-388038": "Car Thank You Page",
    "cheetah-template-388039": "Car Thank You Page",
    "cheetah-template-388071": "Pagina \"Questionario\"  Auto",
    "cheetah-template-388097": "Car Oto Page",
    "cheetah-template-388132": "Car Downsale Page",
    "ct-mailing-boss-list": "Lista Mailingboss",
    "ct-mailing-boss-list-select": "Seleziona una Lista MailingBoss",
    "cheetah-template-389123": "Car VSL Page",
    "cheetah-template-389137": "Car Sales Letter Page",
    "cheetah-template-389311": "Car Membership Page",
    "cheetah-template-389355": "Car Webinar Registration",
    "cheetah-template-389412": "Car Webinar Confirmation",
    "cheetah-template-389466": "Car Webinar Indocrination",
    "ct-resource-hover": "Effetti Hover",
    "cheetah-template-389495": "Car Daily Deal",
    "cheetah-template-389520": "Car Webinar Replay",
    "cheetah-template-389549": "Car Product Launch",
    "cheetah-template-389608": "Car Product Launch Order",
    "cheetah-template-389651": "Car Landing Page",
    "cheetah-template-390471": "Car 3 Step Thank You Page",
    "cheetah-template-390536": "Pagina Conferma Email Automobili",
    "cheetah-template-390557": "Car Download Page",
    "cheetah-category-template-21": "Pagine Funnel Automobili",
    "cheetah-category-template-22": "Pagine Funnel Cosmetica",
    "ct-browser-settings": "Impostazioni Browser ",
    "ct-browser-title": "Notifiche Browser ",
    "ct-browser-enable-desc": "Impostazioni di caricamento",
    "ct-browser-enable-open-site": "Il pop-up di notifica si aprirà quando il sito viene caricato",
    "ct-browser-enable-open-site-desc": "Quando si disabilita questa azione, è possibile abilitare un link per visualizzare il popup di notifica",
    "ct-link-browser-n": "Notifiche Browser ",
    "ct-link-browser-n-active": "Quando si sceglie questa azione, si aprirà il popup di notifica",
    "cheetah-template-393584": "Beard Treatment Squeeze Page",
    "cheetah-template-393631": "Pagina Squeeze Inverso -Trattamento Barba",
    "cheetah-template-393636": "Beard Treatment Lead Magnet Page",
    "cheetah-template-393669": "Beard Treatment Application Page",
    "cheetah-template-393695": "Beard Treatment Bridge Page",
    "cheetah-template-393729": "Beard Treatment Thank You Page",
    "cheetah-template-393732": "Beard Treatment Thank You Page",
    "ct-enable-date-expire": "Abilita la data di scadenza\n",
    "ct-date-expire": "Data di scadenza ",
    "cheetah-template-393774": "Pagina \"Questionario\"  Trattamento Barba",
    "cheetah-template-393781": "Beard Treatment Oto Page",
    "cheetah-template-396436": "Beard Treatment Downsale Page",
    "cheetah-template-396482": "Beard Treatment VSL",
    "cheetah-template-396601": "Beard Treatment Sales Letter Page",
    "cheetah-template-396731": "Beard Treatment Membership Area",
    "cheetah-template-396798": "Beard Treatment Webinar Registration",
    "cheetah-template-396842": "Beard Treatment Webinar Confirmation",
    "cheetah-template-396854": "Beard Treatment Webinar Indocrination",
    "cheetah-template-396897": "Beard Treatment Webinar Replay",
    "cheetah-template-396909": "Beard Treatment Daily Deal",
    "cheetah-template-396926": "Beard Treatment Product Launch",
    "ct-clear-filter": "Cancella filtri ",
    "cheetah-template-399327": "Business Webinar Broadcast",
    "cheetah-template-399473": "App Webinar Broadcast",
    "cheetah-template-399475": "App Webinar Broadcast",
    "cheetah-template-399481": "Coach Webinar Broadcast",
    "cheetah-template-399503": "Agency Webinar Broadcast",
    "cheetah-template-399510": "Course Webinar Broadcast",
    "cheetah-template-399514": "Muscle Mass Webinar Broadcast",
    "cheetah-template-399524": "Car Webinar Broadcast",
    "ct-tags-advanced-title": "Link avanzato con tag ",
    "ct-tags-advanced-link": "Voglio sostituire i tag nell'indirizzo web ",
    "ct-link-tags-advanced-help": " Tags per l'aiuto avanzato",
    "cheetah-template-397650": "Landing Page - Booking",
    "cheetah-category-template-23": "Landing Page",
    "ct-featured": "Featured",
    "cheetah-template-407687": "Beard Treatment Webinar Broadcast",
    "cheetah-template-407694": "Beard Treatment Product Launch Order",
    "cheetah-template-407721": "Beard Treatment Landing Page",
    "cheetah-template-407852": "Beard Treatment 3 Step Thank You Page",
    "cheetah-template-407893": "Pagina Conferma Email Trattamento Barbe",
    "cheetah-template-407920": "Beard Treatment Download Page",
    "cheetah-template-401990": "Landing Page Support 1",
    "ct-captcha-complete-please": "Validare il captcha",
    "ct-publish-website-confirm": "Conferma le informazioni per pubblicare il tuo sito\n",
    "ct-publish-website-really": " Pubblica davvero il sito",
    "ct-notmanual-pin": "* A risoluzioni molto diverse, potrebbe esserci un cambiamento nel manuale, stiamo lavorando per migliorarlo",
    "ct-too-many-attempts": "Troppi tentativi! Per favore riprova più tardi.",
    "ct-duplicate-success": "Il tuo sito è stato duplicato",
    "ct-panel-webinar-broadcast": "Webinar Broadcast",
    "cheetah-template-371878": "Steak House Smart Tag Template",
    "cheetah-template-372381": "Snack Smart Tag Template",
    "cheetah-template-373177": "Dolci Smart Tag Template",
    "cheetah-template-373504": "Perdita Peso Coach Smart Tag Template",
    "cheetah-template-374239": "Fotografo Smart Tag Template",
    "cheetah-template-374287": "Scrittori Smart Tag Template",
    "cheetah-template-375491": "Imbianchino Smart Tag Template",
    "cheetah-template-375515": "Infermieri Smart Tag Template",
    "cheetah-template-375571": "Massaggi Smart Tag Template",
    "cheetah-template-376577": "Giornalisti Smart Tag Template",
    "cheetah-template-376720": "Avvocato Smart Tag Template",
    "cheetah-template-376792": "Giardinaggio Smart Tag Template",
    "cheetah-template-379650": "Spose Smart Tag Template",
    "cheetah-template-379691": "Dentista Smart Tag Template",
    "cheetah-template-379729": "Dottori Smart Tag Template",
    "cheetah-template-380932": "Veterinari Smart Tag Template",
    "cheetah-template-380986": "Agenzia Viaggi  Smart Tag Template",
    "cheetah-template-381036": "Psicologi Smart Tag Template",
    "cheetah-template-382177": "Stilista Personale Smart Tag Template",
    "cheetah-template-382233": "Design d'Interni  Smart Tag Template",
    "cheetah-template-382346": "Makeup Artist Smart Tag Template",
    "cheetah-template-383386": "Manicure e Pedicure Smart Tag Template",
    "cheetah-template-383400": "Sala Party Smart Tag Template",
    "cheetah-template-383471": "Commercialisti Smart Tag Template",
    "cheetah-template-384585": "Amministratori Smart Tag Template",
    "cheetah-template-384624": "Architetti Smart Tag Template",
    "cheetah-template-387526": "Biologi Smart Tag Template",
    "cheetah-template-387612": "Muratori Smart Tag Template",
    "cheetah-template-387682": "Cerimoniale Smart Tag Template",
    "cheetah-template-388982": "Recupero Crediti Smart Tag Template",
    "cheetah-template-389046": "Decoratore Smart Tag Template",
    "cheetah-template-389113": "Economisti Smart Tag Template",
    "cheetah-template-390315": "Ingegneri Smart Tag Template",
    "cheetah-template-390383": "Estetiste per Sopracciglio Smart Tag Template",
    "cheetah-template-390451": "Analista Finanziario Smart Tag Template",
    "cheetah-template-391735": "Consulente Finanziario Smart Tag Template",
    "cheetah-template-391793": "Depilazione Smart Tag Template",
    "cheetah-template-393181": "Parrucchieri Smart Tag Template",
    "cheetah-template-393297": "Organizzazione Domestica Smart Tag Template",
    "cheetah-template-396277": "Vigile del fuoco Idraulico Smart Tag Template",
    "cheetah-template-396316": "Assicuratori Smart Tag Template",
    "cheetah-template-398951": "Drenaggio Linfatico  Smart Tag Template",
    "cheetah-template-399006": "Digital Marketing Smart Tag Template",
    "cheetah-template-400356": "Organizzazione Personale  Smart Tag Template",
    "cheetah-template-400526": "Montatore Mobili Smart Tag Template",
    "cheetah-template-401739": "Intonacatore Smart Tag Template",
    "cheetah-template-401780": "Podologi Smart Tag Template",
    "cheetah-template-401874": "Protezione Rete Smart Tag Template",
    "cheetah-template-412521": "Ristrutturazioni Smart Tag Template",
    "cheetah-template-412565": "Illuminazione Residenziale Smart Tag Template",
    "cheetah-template-413740": "Terapista della Parola Smart Tag Template",
    "cheetah-template-413820": "Guida Turistica Smart Tag Template",
    "cheetah-template-414244": "Insegnanti Privati Smart Tag Template",
    "cheetah-template-421920": "Stop Smoking Squeeze Page",
    "cheetah-template-422687": "Pagina Squeeze Inverso -Smettere di fumare",
    "cheetah-template-422738": "Stop Smoking Lead Magnet Page",
    "cheetah-template-423003": "Stop Smoking Application Page",
    "cheetah-template-423018": "Stop Smoking Bridge Page",
    "cheetah-template-423026": "Stop Smoking Thank You Page",
    "cheetah-template-423061": "Pagina \"Questionario\"  Smettere di Fumare",
    "cheetah-template-423075": "Stop Smoking Oto Page",
    "cheetah-template-423104": "Stop Smoking Downsale Page",
    "cheetah-template-423120": "Stop Smoking VSL Page",
    "cheetah-template-423824": "Stop Smoking Sales Letter Page",
    "cheetah-template-423853": "Stop Smoking Membership Area Page",
    "cheetah-template-423916": "Stop Smoking Webinar Registration",
    "cheetah-template-423924": "Stop Smoking Webinar Confirmation",
    "cheetah-template-423939": "Stop Smoking Webinar Indocrination",
    "cheetah-template-423945": "Stop Smoking Webinar Broadcast",
    "cheetah-template-423949": "Stop Smoking Webinar Replay",
    "cheetah-template-423953": "Stop Smoking Daily Deal",
    "cheetah-template-423974": "Stop Smoking Product Launch",
    "cheetah-template-424052": "Stop Smoking Product Launch Order",
    "cheetah-template-424066": "Stop Smoking Landing Page",
    "cheetah-template-424078": "Stop Smoking 3 Step Thank You Page",
    "cheetah-template-424097": "Pagina Conferma Email Smetti di fumare",
    "cheetah-template-424101": "Stop Smoking Download Page",
    "ct-first-website-welcome": "Benvenuto in cheetah,",
    "ct-first-website-to-begin": "Per iniziare, è necessario creare il tuo primo sito web.",
    "ct-first-website-button": "Crea il tuo primo Sito Web",
    "ct-first-website-help": "Hai bisogno di aiuto per creare il tuo sito web? Possiamo aiutarti!",
    "ct-first-website-tutoriais": "Tutorial",
    "ct-first-website-tutoriais-desc": "Abbiamo diversi tutorial in cui puoi imparare questo fantastico strumento!",
    "ct-first-website-tutoriais-goto": "Vai ai Tutorial",
    "ct-first-website-sites": "I Nostri Siti Web",
    "ct-first-website-sites-desc": "Dai un'occhiata ad altri siti web realizzati con Cheetah!",
    "ct-first-website-sites-goto": "Cai ai Siti Web",
    "ct-first-website-atts": "Ultimi aggiornamenti",
    "ct-first-website-atts-desc": "Resta aggiornato con gli ultimi aggiornamenti di Cheetah",
    "ct-first-website-atts-goto": "Vai agli ultimi aggiornamenti",
    "ct-first-website-support": "Supporto",
    "ct-first-website-support-desc": "E non dimenticare che abbiamo un super supporto qui nel caso ne avessi bisogno!",
    "ct-first-website-support-goto": "Vai al Supporto",
    "cheetah-template-424165": "Stop Smoking Webinar Indocrination",
    "cheetah-category-template-24": "Pagine Funnel Smetti di fumare",
    "ct-joyride-dashboard-1": "Queste sono le tue pagine ... puoi crearle, duplicarle, modificarle ed eliminarle così come cambiare l'immagine di condivisone di ogni pagina. Passa il mouse su queste opzioni.",
    "ct-joyride-dashboard-2": "Qui puoi creare nuove pagine ... Puoi creare una pagina nuova vuota, importare una pagina da uno dei tuoi siti o da uno dei nostri Template già pronti.",
    "ct-joyride-dashboard-3": "Facendo clic su questo pulsante, si aprirà una nuova scheda con il nostro meraviglioso costruttore Builderall Builder dove potrai creare e personalizzare i tuoi siti web. Il nostro costruttore Builderall Builder è l'unico costruttore di siti che ha una tecnologia di posizionamenti assoluti degli oggetti per la versione desktop e un posizionamento reattivo per la versione mobile.",
    "ct-joyride-dashboard-4": "Con questo piccolo pulsante, hai accesso a impostazioni specifiche per ogni pagina, come pop-up, header, footer, nonché script di monitoraggio e altre funzionalità.",
    "ct-joyride-dashboard-5": "Con il menu laterale, hai accesso alle configurazioni generali del tuo sito web. Accedi alle statistiche, configuri i popup, gli Header, i Footer, accedi ad altri strumenti come il Super Checkout, Blog, Notifiche del browser e Appuntamenti. Qui puoi anche configurare il tuo dominio e accedervi direttamente. Semplice! Vero?",
    "ct-joyride-dashboard-6": "In questa barra in alto puoi accedere alla modalità di ordinamento in cui puoi trascinare e rilasciare le tue pagine per aiutarti a mantenerti organizzato. Puoi anche creare nuove aree membri a cui puoi rilasciare l'accesso tramite registrazione, pagamento o automaticamente. Puoi anche sfruttare la nostra funzione di filtro per trovare velocemente le tue pagine.",
    "ct-joyride-dashboard-7": "Infine, con questo pulsante puoi pubblicare il tuo sito con tutte le modifiche su cui hai lavorato. Tieni presente che potrebbero essere necessari alcuni minuti a causa della nostra robusta rete di server per vedere le modifiche in tempo reale.",
    "ct-joyride-dashboard-0": "Ciao e benvenuto nella dashboard del tuo sito web! Qui hai accesso a molte delle impostazioni del tuo sito Web e dei Funnel di vendita. Questo breve tour contiene semplici istruzioni su come creare e modificare i tuoi siti web, inclusa la pubblicazione di eventuali modifiche.",
    "ct-members-area-all": "Tutte le aree riservate",
    "ct-members-area-permission-all": "Accedi a tutto",
    "ct-members-file-export-type": "Seleziona il tipo di esportazione",
    "cheetah-template-436897": "APP Upsell Page",
    "cheetah-template-436907": "Stop Smoking Upsell Page",
    "ct-import-members-users-obs-save": "Invia un'email di benvenuto al momento della registrazione",
    "ct-import-members-users-without-password": "Abbiamo visto che non c'è una colonna password nel tuo file, quindi una password verrà aggiunta casualmente ai tuoi utenti e inviata loro via email, se vuoi una password predefinita per tutti, aggiungila al tuo file.",
    "ct-import-members-send-email": "Verrà inviata l'email di benvenuto scelta nelle impostazioni del sito",
    "cheetah-template-437114": "Stop Smoking Upsell Page",
    "cheetah-template-437960": "Muscle Mass Upsell Page",
    "cheetah-template-438186": "Beard Treatment Upsell Page",
    "cheetah-template-438235": "Car Upsell Page",
    "cheetah-template-438276": "Course Upsell Page",
    "cheetah-template-438277": "Course Upsell Oto",
    "cheetah-template-438294": "Muscle Mass Offer Wall Page",
    "cheetah-template-438322": "Coach Upsell Page",
    "cheetah-template-438323": "Coach Upsell Page",
    "cheetah-template-438352": "Agency Upsell Page",
    "cheetah-template-438381": "Business Upsell Page",
    "cheetah-template-439143": "Beard Treatment Offer Wall Page",
    "cheetah-template-439310": "Stop Smoking Offer Wall Page",
    "cheetah-template-439311": "Stop Smoking Offer Wall Page",
    "cheetah-template-439409": "Coach Offer Wall Page",
    "cheetah-template-439487": "Course Offer Wall Page",
    "cheetah-template-439521": "Car Offer Wall Page",
    "cheetah-template-439567": "APP Offer Wall Page",
    "ct-import-members-title": "Importa utenti nel tuo sito",
    "ct-import-members-user-obs": "Carica il file CSV con le informazioni per gli utenti che desideri importare. Non conosci questo formato?",
    "ct-import-members-user-helper": "Il tuo file deve rispettare il formato CSV di Builderall. Non conosci questo formato?",
    "ct-import-memeber-example": "Scarica il modello CSV.",
    "ct-import-select": "Scegli il file da importare",
    "ct-import-confirm-members-title": "Conferma gli utenti che abbiamo trovato nel tuo file",
    "ct-import-members-users-restrict": "Scegli le aree riservate da rilasciare durante la registrazione dei tuoi utenti",
    "ct-import-members-users-alert-email": "Gli utenti esistenti non verranno sovrascritti",
    "ct-import-save": "Importa",
    "cheetah-template-440258": "Beard Treatment Share Page",
    "cheetah-template-440262": "Agency Offer Wall Page",
    "ct-import-success-created": "Importato correttamente!",
    "ct-import-users": "utente(i)",
    "ct-import-error-already-exists": "Gli utenti di seguito non sono stati registrati, poiché esistevano già nei loro record. Non sovrascriviamo le informazioni, se vuoi modificarle usa l'opzione di modifica.",
    "cheetah-template-440285": "Muscle Mass Share Page",
    "cheetah-template-440327": "Business Offer Wall Page",
    "ct-member-user-selected": "Sono stati selezionati",
    "ct-member-user-rs": "utente(i)",
    "ct-member-many-edit-users-obs": "Durante il salvataggio, le impostazioni scelte dovevano essere applicate a tutti gli utenti selezionati.",
    "ct-member-many-edit-users": "Modifica di più utenti",
    "ct-member-many-edit-confirm": "Conferma la modifica da più utenti\n",
    "ct-member-many-edit-confirm-obs": "Quando confermi questa impostazione, non può essere annullata.",
    "ct-export-members-title": "Esporta Utenti",
    "ct-members-export-helper": "L'esportazione viene eseguita in base agli utenti filtrati",
    "ct-members-file-export-type-select": "Seleziona l'estensione del file\n",
    "ct-export-save": "Esporta",
    "ct-export-members-success-obs": "La tua esportazione è andata a buon fine",
    "ct-export-members-success-title": "Esportazione riuscita",
    "ct-members-data": "Dati Utente",
    "ct-members-add-new": "Aggiungi nuovo utente",
    "ct-members-import": "Importa membri\n",
    "ct-members-export": "Esporta Membri",
    "ct-selected-users-edit": "Totale utenti selezionati\n",
    "ct-members-all-user": "Tutti gli utenti",
    "cheetah-template-440405": "Stop Smoking Share Page",
    "cheetah-template-440429": "APP Share Page",
    "cheetah-template-440438": "Course Share Page",
    "cheetah-template-440452": "Coach Share Page",
    "cheetah-template-440468": "Agency Share Page",
    "cheetah-template-440479": "Car Share Page",
    "cheetah-template-440480": "Car Share Page",
    "cheetah-template-440496": "Business Share Page",
    "cheetah-template-440607": "Stop Smoking Offer Wall Page",
    "cheetah-template-443587": "Stop Smoking Calendar Page",
    "cheetah-category-template-25": "Pagine Calendario",
    "cheetah-template-443990": "Pagina \"Squeeze\" Tema Bianco",
    "cheetah-category-template-26": "Pagine Funnel Tema Bianco",
    "cheetah-template-445138": "Car Calendar Page",
    "cheetah-template-445146": "Business Calendar Page",
    "cheetah-template-445156": "Agency Calendar Page",
    "cheetah-template-445163": "Course Calendar Page",
    "cheetah-template-445168": "APP Calendar Page",
    "cheetah-template-445175": "Muscle Mass Calendar Page",
    "cheetah-template-445179": "Beard Treatment Calendar Page",
    "cheetah-template-445192": "Coach Calendar Page",
    "ct-new-member-title": "Aggiungi nuovo utente",
    "members-select-all": "Seleziona tutti gli utenti",
    "ct-import-members-success-title": "Importazione riuscita",
    "ct-import-error": "Si è verificato un errore durante la registrazione dei tuoi utenti",
    "ct-import-prepare-maxsize": "La dimensione del file supera la dimensione consentita",
    "cheetah-template-446307": "Pagina \"Squeeze Inverso\" Tema Bianco",
    "cheetah-template-446466": "Pagina \"Lead Magnet\" Tema Bianco",
    "ct-members-update-password": "Aggiornamento password",
    "ct-member-password-update-obs": "Aggiornamento della password",
    "cheetah-template-446610": "Pagina \"Application\" Tema Bianco",
    "cheetah-template-446650": "Pagina \"Bridge\" Tema Bianco",
    "cheetah-template-446668": "Pagina \" Thank You\" Tema Bianco",
    "cheetah-template-446682": "Pagina \"Questionario\" Tema Bianco",
    "cheetah-template-446717": "Pagina \"Oto\" Tema BIanco",
    "cheetah-template-447528": "Pagina \"Downsale\" Tema Bianco",
    "cheetah-template-447605": "Pagina \"VSL\" Tema Bianco",
    "cheetah-template-447623": "Pagina \"Sales Letter\" Tema Bianco",
    "cheetah-template-447787": "Pagina \"Membership Area\" Tema Bianco",
    "cheetah-template-447863": "Pagina \"Webinar Registration\" Tema Bianco",
    "cheetah-template-447877": "Pagina \"Webinar Confirmation\" Tema Bianco",
    "cheetah-template-447894": "Pagina \"Webinar Indocrination\" Tema Bianco",
    "cheetah-template-447910": "Pagina \"Webinar Broadcast\" Tema Bianco",
    "cheetah-template-447959": "Stop Smoking Checkout",
    "cheetah-template-447958": "Beard Treatment Checkout",
    "cheetah-template-447957": "Car Checkout",
    "cheetah-template-447953": "Muscle Mass Checkout",
    "cheetah-template-447952": "Course Checkout",
    "cheetah-template-447951": "Coach Checkout",
    "cheetah-template-447988": "Pagina \"Webinar Replay\" Tema Bianco",
    "cheetah-template-447950": "Agency Checkout",
    "cheetah-template-447949": "App Checkout",
    "cheetah-template-447948": "Business Checkout",
    "cheetah-template-448005": "Pagina \"Daily Deal\" Tema Bianco",
    "ct-members-form-general": "Impostazioni Avanzate",
    "ct-form-members-hidden-password": "Password non richiesta alla registrazione",
    "ct-form-members-hidden-password-obs": "Quando si abilita questa opzione, verrà creata automaticamente una password automatica e sarà inviata tramite e-mail all'utente",
    "ct-access-ba-user": "Accedi con le credenziali Builderall",
    "cheetah-template-453206": "Pagina \"Product Launch\" Tema Bianco",
    "cheetah-template-453298": "Pagina \"Product Launch Order\" Tema Bianco",
    "cheetah-template-453346": "Pagina \"Landing Page\" Tema Bianco",
    "cheetah-template-454370": "Pagina \"3 Step Thank You\" Tema Bianco",
    "cheetah-template-454394": "Pagina Conferma Email Tema Bianco",
    "cheetah-template-454433": "Pagina \"Download\" Tema Bianco",
    "cheetah-template-454621": "Pagina \"Upsell\" Tema Bianco",
    "cheetah-template-454641": "Pagina \"Squeeze\" Tema Scuro",
    "cheetah-template-454730": "Pagina \"Offer Wall\" Tema Bianco",
    "cheetah-template-454752": "Pagina \"Share\" Tema Bianco",
    "cheetah-template-454767": "Pagina \"Checkout\" Tema Bianco",
    "cheetah-template-454811": "Pagina \"Calendar\" Tema Bianco",
    "cheetah-template-455712": "Pagina \"Squeeze Inverso\" Tema Scuro",
    "cheetah-template-455716": "Pagina \"Squeeze\" Tema Scuro",
    "cheetah-template-455764": "Pagina \"Lead Magnet\" Tema scuro",
    "cheetah-template-455773": "Pagina \"Squeeze Inverso\" Tema Rosa",
    "cheetah-template-455800": "Pagina \"Lead Magnet\" Tema Rosa",
    "cheetah-template-455870": "Pagina \"Application\" Tema Rosa",
    "cheetah-template-455879": "Pagina \"Application\" Tema Scuro",
    "cheetah-template-455916": "Pagina \"Bridge\" Tema Rosa",
    "cheetah-template-455924": "Pagina \"Bridge\" Tema Scuro",
    "cheetah-template-456045": "Pagina \"Thank You\" Tema Rosa",
    "cheetah-template-456049": "Pagina \"Questionario\" Tema Rosa",
    "cheetah-template-456066": "Pagina \"Oto\" Tema Rosa",
    "cheetah-template-456116": "Pagina\"Thank You\" Tema Scuro",
    "cheetah-template-456122": "Pagina \"Downsale\" Tema Rosa",
    "cheetah-template-456162": "Pagina \"Questionario\" Tema Scuro",
    "cheetah-template-456170": "Pagina \"VSL\" Tema Rosa",
    "cheetah-template-456192": "Pagina \"Oto\" Tema Scuro",
    "cheetah-template-456222": "Pagina \"Sales Letter\" Tema Rosa",
    "cheetah-template-456242": "Pagina \"Downsale\" Tema Scuro",
    "cheetah-template-456262": "Pagina \"Vsl\" Tema Scuro",
    "cheetah-template-456283": "Pagina \"Sales Letter\" Tema Scuro",
    "cheetah-template-456292": "Pagina \"Membership Area\" Tema Rosa",
    "cheetah-template-456312": "Pagina \"Webinar Registration\" Tema Rosa",
    "cheetah-template-456367": "Pagina \"Webinar Confirmation\" Tema Rosa",
    "cheetah-template-456391": "Pagina \"Membership Area\" Tema Scuro",
    "cheetah-template-456403": "Pagina \"Webinar Indocrination\" Tema Rosa",
    "cheetah-template-456414": "Pagina \"Webinar Broadcast\" Tema Rosa",
    "cheetah-template-456435": "Pagina \"Webinar Replay\" Tema Rosa",
    "cheetah-template-456443": "Pagina \"Daily Deal\" Tema Rosa",
    "ct-automatically-grant-access-partners-premiu": "Concedi l'accesso automaticamente ai partner Builderall attivi <b>premium</b>",
    "ct-members-ba-user": "Utente Builderall",
    "cheetah-template-457721": "Pagina \"Webinar Registration\" Tema Scuro",
    "cheetah-template-457753": "Pagina \"Webinar Confirmation\" Tema Scuro",
    "cheetah-template-457772": "Pagina \"Webinar Indocrination\" Tema Scuro",
    "cheetah-template-457779": "Pagina \"Webinar Broadcast\" Tema Scuro",
    "cheetah-template-457789": "Pagina \"Webinar Replay\" Tema Scuro",
    "cheetah-template-457801": "Pagina \"Daily Deal\" Tema Scuro",
    "cheetah-template-457813": "Pagina \"Product Launch\" Tema Scuro",
    "cheetah-template-458169": "Pagina \"Product Launch Order\" Tema Scuro",
    "cheetah-template-458182": "Pagina \"Landing Page\" Tema Scuro",
    "cheetah-template-458196": "Pagina \"3 Step Thank You\" Tema Scuro",
    "cheetah-template-458210": "Pagina Conferma Email Tema Scuro",
    "cheetah-template-458225": "Pagina \"Download\" Tema Scuro",
    "cheetah-template-458247": "Pagina \"Upsell\" Tema Scuro",
    "cheetah-template-458357": "Pagina Muro Offerte Tema Nero",
    "cheetah-template-458360": "Pagina \"Offer Wall\" Tema Scuro",
    "cheetah-template-458393": "Pagina \"Share\" Tema Scuro",
    "cheetah-template-458407": "Pagina \"Checkout\" Tema Scuro",
    "cheetah-template-458420": "Pagina \"Calendar\" Tema Scuro",
    "ct-button-margin": "Margini Tasto",
    "cheetah-category-template-27": "Pagine Funnel Tema Dark",
    "cheetah-template-461290": "Pagina \"Product Launch\" Tema Rosa",
    "cheetah-template-461307": "Pagina \"Product Launch Order\" Tema Rosa",
    "cheetah-template-461350": "Pagina \"Landing Page\" Tema Rosa",
    "cheetah-template-461477": "Pagina \"3 Step Thank You\" Tema Rosa",
    "cheetah-template-461536": "Pagina Conferma Email Tema Viola",
    "cheetah-template-461581": "Pagina \"Download\" Tema Rosa",
    "cheetah-template-461595": "Pagina \"Upsell\" Tema Rosa",
    "cheetah-template-461646": "Pagina \"Offer Wall\" Tema Rosa",
    "cheetah-template-461705": "Pagina \"Share\" Tema Rosa",
    "cheetah-template-461715": "Pagina \"Checkout\" Tema Rosa",
    "cheetah-template-461722": "Pagina \"Calendar\" Tema Rosa",
    "cheetah-category-template-28": "Pagine Funnel Tema Pink",
    "cheetah-template-462621": "Pagina \"Squeeze\" Tema Verde",
    "cheetah-template-462906": "Pagina \"Squeeze Inverso\" Tema Verde",
    "cheetah-template-462962": "Pagina \"Lead Magnet\" Tema Verde",
    "cheetah-template-463000": "Pagina \"Application\" Tema Verde",
    "cheetah-template-463015": "Pagina \"Squeeze\" Tema Blu",
    "cheetah-template-463074": "Pagina \"Bridge\" Tema Verde",
    "cheetah-template-463110": "Pagina \"Thank You\" Tema Verde Page",
    "cheetah-template-463128": "Pagina \"Squeeze Inverso\" Tema Blu",
    "cheetah-template-463138": "Pagina \"Questionario\" Tema Verde",
    "cheetah-template-463143": "Pagina \"Lead Magnet\" Tema Blu",
    "cheetah-template-463175": "Pagina \"Oto\" Tema Verde",
    "cheetah-template-463237": "Pagina \"Application\" Tema Blu",
    "cheetah-template-464055": "Pagina \"Downsale\" Tema Verde",
    "cheetah-template-465522": "Pagina \"Downsale\" Tema Verde",
    "cheetah-template-465523": "Pagina \"Downsale\" Tema Verde  ",
    "cheetah-template-465536": "Pagina \"Vsl\" Tema Verde",
    "cheetah-template-465573": "Pagina \"Sales Letter\" Tema Verde",
    "cheetah-template-465795": "Pagina \"Membership Area\" Tema Verde",
    "cheetah-template-465818": "Pagina \"Webinar Registration\" Tema Verde",
    "cheetah-template-465842": "Pagina \"Webinar Confirmation\" Tema Verde",
    "cheetah-template-465884": "Pagina \"Webinar Indocrination\" Tema Verde",
    "cheetah-template-465918": "Pagina \"Webinar Broadcast\" Tema Verde",
    "cheetah-template-465925": "Pagina \"Bridge\" Tema Blu",
    "cheetah-template-465938": "Pagina \"Webinar Replay\" Tema Verde",
    "cheetah-template-465942": "Pagina \"Thank You\" Tema Blu",
    "cheetah-template-465961": "Pagina \"Daily Deal\" Tema Verde",
    "cheetah-template-466004": "Pagina \"Product Launch\" Tema Verde",
    "cheetah-template-466006": "Pagina \"Questionario \" Tema Blu",
    "cheetah-template-466016": "Pagina \"Oto\" Tema Blu",
    "cheetah-template-466047": "Pagina \"Product Launch Order\" Tema Verde",
    "cheetah-template-466078": "Pagina \"Downsale\" Tema Blu",
    "cheetah-template-466104": "Pagina \"Landing Page\" Tema Verde",
    "cheetah-template-466106": "Pagina \"VSL\" Tema Blu",
    "cheetah-template-466138": "Pagina \"Sales Letter\" Tema Blu",
    "ct-placeholder-color": "Scegli colore segnaposto ",
    "cheetah-template-466237": "Pagina \"Membership Area\" Tema Blu",
    "cheetah-template-466267": "Pagina \"Webinar Registration\" Tema Blu",
    "cheetah-template-466279": "Pagina \"Webinar Confirmation\" Tema Blu",
    "cheetah-template-466293": "Pagina \"Webinar Indocrination\" Tema Blu",
    "cheetah-template-466308": "Pagina \"Webinar Broadcast\" Tema Blu",
    "cheetah-template-466310": "Pagina \"Webinar Replay\" Tema Blu",
    "cheetah-template-466316": "Pagina \"Daily Deal\" Tema Blu",
    "cheetah-template-466327": "Pagina \"Product Launch\" Tema Blu",
    "cheetah-template-466341": "Pagina \"Product Launch Order\" Tema Blu",
    "cheetah-template-466349": "Pagina \"Landing Page\" Tema Blu",
    "cheetah-template-466359": "Pagina \"3 Step Thank You\" Tema Blu",
    "cheetah-template-466369": "Pagina Conferma Email Tema Blu",
    "cheetah-template-466376": "Pagina \"Download\" Tema Blu",
    "cheetah-template-466383": "Pagina \"Upsell\" Tema Blu",
    "cheetah-template-466392": "Pagina \"Offer Wall\" Tema Blu",
    "cheetah-template-466406": "Pagina \"Share\" Tema Blu",
    "cheetah-template-466415": "Pagina \"Checkout\" Tema Blu",
    "ct-component-CheckoutComponent": "Super Checkout ",
    "cheetah-template-466427": "Pagina \"Calendar\" Tema Blu",
    "cheetah-template-466837": "Pagina \"3 Step Thank You\" Tema Verde",
    "cheetah-template-466847": "Pagina Conferma Email Tema Verde",
    "cheetah-category-template-29": "Pagine Funnel Tema Blu",
    "cheetah-template-466866": "Pagina \"Download\" Tema Verde",
    "cheetah-template-466898": "Pagina \"Upsell\" Tema Verde",
    "cheetah-template-466972": "Pagina \"Offer Wall\" Tema Verde",
    "cheetah-template-467027": "Pagina \"Share\" Tema Verde",
    "cheetah-template-467071": "Pagina \"Checkout\" Tema Verde",
    "cheetah-template-467085": "Pagina \"Calender\" Tema Verde",
    "ct-social-proof": "Social Proof  ",
    "ct-social-proof-settings": "Impostazioni Social Proof",
    "ct-social-proof-campaign": "Campagna Social Proof",
    "ct-social-proof-select": "Seleziona una campagna di Social Proof",
    "ct-social-proof-obs": "Quando abiliti questa opzione e scegli una campagna, ogni volta che un nuovo utente si registra sul tuo sito verrà registrato anche nella campagna.",
    "ct-social-proof-new": "Nuova Campagna",
    "ct-campaign-new-title": "Nuova campagna di  social proof",
    "ct-campaign-name": "Nome Campagna",
    "ct-social-proof-empty-campaign": "Non hai ancora nessuna campagna Social Proof ",
    "cheetah-category-template-30": "Pagine Funnel Tema Verde",
    "ct-select-this": "Seleziona questo",
    "ct-select-template-your-site": "Scegli il Template per il tuo sito web",
    "ct-select-template-your-site-help": "Ora puoi scegliere il Template che più si adatta alla tua attività tra i tantissimi a disposizione. Ogni Template è completamente modificabile. Puoi visualizzare in anteprima ogni Template prima di sceglierlo! E se non ti piace quello che scegli, torni qui e scegli un nuovo Template, ok?",
    "ct-templates": "Templates ",
    "ct-normal": "Standard",
    "ct-template-normal-desc": "Voglio scegliere un template, e personalizzarlo",
    "ct-smart": "Smart ",
    "ct-template-smart-desc": "Voglio un template Smart Tag, già con i miei tag",
    "ct-register-your-tags": "Registrazione dei tuoi tag standard",
    "ct-register-your-tags-desc": "Qui assegnerai valori ai tuoi tag standard. I valori dei tag standard verranno assegnati alle posizioni specifiche del tuo template intelligente, generando un sito web più personalizzato per il tuo tipo di attività",
    "cheetah-template-470799": "Pagina \"Squeeze\" Tema Giallo",
    "ct-confirm-template-save": "Conferma",
    "ct-confirm-template-save-obs": "Dopo aver confermato l'operazione, il tuo sito web verrà automaticamente pubblicato e potrai accedere alle impostazioni",
    "ct-template-saving": "Stiamo costruendo il tuo sito web",
    "ct-template-saving-help": "Stiamo costruendo il tuo sito web.",
    "ct-selecionar-template": "Seleziona Template",
    "ct-my-website-title": "Il mio sito Cheetah",
    "ct-my-website-description": "Questa è la descrizione del mio sito",
    "ct-advanced-tags": "Tag Avanzati",
    "cheetah-template-471894": "Pagina \"Squeeze Inverso\" Tema Giallo",
    "cheetah-template-471925": "Pagina \"Lead Magnet\" Tema Giallo",
    "cheetah-template-472063": "Pagina \"Application\" Tema Giallo",
    "cheetah-template-472243": "Pagina \"Bridge\" Tema Giallo",
    "cheetah-template-472282": "Pagina \"Bridge\" Tema Giallo",
    "cheetah-template-472286": "Pagina \"Questionario\" Tema Giallo",
    "cheetah-template-472302": "Pagina \"Oto\" Tema Giallo",
    "ct-group-tags-label": "Gruppo Tag",
    "ct-select-group-tags": "Seleziona il gruppo di tag",
    "ct-tags-manager": "Gestisci tag",
    "cheetah-template-473424": "Pagina \"Downsale\" Tema Giallo",
    "cheetah-template-473470": "Pagina \"Vsl\" Tema Giallo",
    "cheetah-template-473493": "Pagina \"Webinar Registration\" Tema Giallo",
    "cheetah-template-473517": "Pagina \"Webinar Confirmation\" Tema Giallo",
    "cheetah-template-473573": "Pagina \"Webinar Indocrination\" Tema Giallo",
    "cheetah-template-473588": "Pagina \"Sales Letter\" Tema Giallo",
    "cheetah-template-473589": "Pagina \"Sales Letter\" Tema Giallo",
    "cheetah-template-473892": "Pagina \"Webinar Confirmation\" Tema Giallo",
    "cheetah-template-473911": "Pagina \"Webinar Brodcast\" Tema Giallo",
    "cheetah-template-473931": "Pagina Webinar Replay\" Tema Giallo",
    "cheetah-template-473958": "Pagina \"Daily Deal\" Tema Giallo",
    "cheetah-template-473993": "Pagina \"Product Launch\" Tema Giallo",
    "cheetah-template-474035": "Pagina \"Product Launch Order\" Tema Giallo",
    "cheetah-template-474057": "Pagina \"Landing Page\" Tema Giallo",
    "cheetah-template-474077": "Pagina \"3 Step Thank You\" Tema Giallo",
    "cheetah-template-474097": "Pagina Conferma Email tema Giallo",
    "cheetah-template-474115": "Pagina \"Download\" Tema Giallo",
    "cheetah-template-474903": "Pagina \"Upsell\" Tema Giallo",
    "cheetah-template-474954": "Pagina \"Share\" Tema Giallo",
    "ct-tag-group-created": "Gruppo di tag creato con successo",
    "ct-tag-group-not-deleted": "Non è stato possibile eliminare",
    "ct-tag-group-saved": "Salvato con successo",
    "cheetah-template-475016": "Pagina \"Checkout\" Tema Giallo",
    "cheetah-template-475091": "Pagina \"Calendar\" Tema Giallo",
    "cheetah-category-template-31": "Pagine Funnel Tema Giallo",
    "cheetah-template-475141": "Pagina \"Sales Letter\" Tema Giallo",
    "cheetah-template-475392": "Pagina \"Offer Wall\" Tema Giallo",
    "cheetah-template-475481": "Pagina \"Membership Area\" Tema Giallo",
    "cheetah-template-475578": "Pagina \"Thank You\" Tema Giallo",
    "ct-pixel-settings": "Impostazioni Pixel",
    "ct-enable-synchronous-script": "Abilita la sicronizzazione degli script",
    "ct-info-script-seo": "Gli script relativi alla SEO si trovano nella sezione SEO",
    "ct-info-script-seo-link": "clicca qui per le impostazioni SEO",
    "ct-script-settings": "Impostazioni Script",
    "ct-info-script": "Altri script sono nella sezione script",
    "ct-info-script-link": "Fare clic qui per le impostazioni dello script",
    "ct-order-elements": "Ordine degli Elementi su Mobile",
    "ct-no-sites-found": "No sites found",
    "ct-coming-soon": "Coming soon",
    "ct-checkout-more-config": "Più configurazioni",
    "ct-checkout-create-product": "Crea un prodotto",
    "ct-loading": "Caricamento",
    "ct-loading-products": "Caricamento prodotto",
    "ct-checkout-select-product": "Scegli il prodotto",
    "ct-checkout-select-product-info": "Seleziona uno dei prodotti sottostanti per utilizzarlo nel modulo di pagamento, puoi anche modificare un prodotto esistente o crearne uno nuovo, fai clic sul tasto \"CREA PRODOTTO\" per accedere alla dashboard completa del Super-checkout.",
    "ct-checkout-erro-retrieving-token": "Errore durante il recupero del token di supercheckout.",
    "ct-checkout-shipping": "Spedizione",
    "ct-checkout-where-to": "Dove?",
    "ct-checkout-your-info": "I tuoi dati",
    "ct-checkout-pay-it": "Pagalo!",
    "ct-checkout-secure-payments": "Pagamenti sicuri al 100% .",
    "ct-checkout-empty-input": "Questo è un input vuoto\n",
    "ct-checkout-filled-input": "Questo è un input completo",
    "ct-country": "Nazione",
    "ct-checkout-business-name": "Nome Azienda",
    "ct-checkout-contact-email": "Email Contatto",
    "ct-checkout-contact-phone": "Telefono contatto",
    "ct-checkout-gateway-config": "Configurazione gateway",
    "ct-checkout-select-language": "Scegli la lingua",
    "ct-format": "Formato",
    "ct-niche": "Nicchia",
    "ct-checkout-chose-niche": "Scegli una nicchia",
    "ct-price": "Prezzo",
    "ct-currency": "Valuta",
    "ct-checkout-refund-period": "Periodo di Rimborso",
    "ct-checkout-no-refund": "Nessun rimborso",
    "ct-checkout-ty-page": "Thank you page ",
    "ct-checkout-select-page": "Scegli la pagina",
    "ct-checkout-sales-page": "Pagina di vendita",
    "ct-checkout-business-info": "Informazioni Azienda",
    "ct-config-field": "Configura i campi",
    "ct-icon-settings": "Impostazioni icona",
    "ct-change-icon": "Cambia icona",
    "ct-checkout-form-config": "Configurazione modulo",
    "ct-checkout-form-config-info": "Usa quest'area per configurare il tuo modulo di checkout",
    "ct-baloon-text": "Testo del fumetto",
    "ct-checkout-baloon-text-info": "Se configuri questo testo, verrà visualizzato nella parte superiore del modulo.",
    "ct-checkout-buy-button-text": "Testo Pulsante Acquista",
    "ct-checkout-buy-button-subtext": "Sottotesto Pulsante Acquista",
    "ct-checkout-bottom-info-text": "Testo informativo inferiore",
    "ct-checkout-pay-button-text": "Testo del pulsante di pagamento",
    "ct-checkout-select-another-product": "Seleziona un altro prodotto",
    "ct-success-connect": "Dominio connesso con successo.",
    "ct-success-disconnect": "Dominio disconnesso con successo.",
    "ct-hidePanel": "Nascondi Panello",
    "ct-hide-time": "Nascondi per (sec):",
    "ct-save-tag-group": "Salva",
    "ct-group-tags-desc": "Qui puoi modificare i tuoi tag.",
    "ct-cheetah-turbo-page": "Cheetah Turbo Page",
    "ct-content-settings": "Content Settings",
    "ct-sub-headline": "Sub Headline",
    "ct-action-text": "Text Action",
    "ct-terms-of-use-text": "Testo dei termini di utilizzo",
    "ct-terms-of-use-page": "Pagina dei termini di utilizzo",
    "ct-privacy-policy-text": "Privacy policy text",
    "ct-privacy-policy-page": "Página de política de privacidade",
    "ct-input-a-valid-domain": "Per favore, inserisci un dominio valido",
    "ct-checkout-product-create-format-digital": "Digitale",
    "ct-checkout-product-create-format-regular": "Fisico",
    "ct-checkout-gateway-stripe-info-line1": "Si prega di scrivere una breve descrizione qui.",
    "ct-checkout-gateway-stripe-info-line2": "Nel menu a sinistra, fai clic su Sviluppatori e quindi su Chiavi API.",
    "ct-checkout-gateway-stripe-info-line3": "Hai già un PK e un SK predefiniti.",
    "ct-checkout-gateway-stripe-info-line4": "Copia la tua chiave pubblica e incollala qui.",
    "ct-checkout-gateway-stripe-info-line5": "Copia la tua chiave segreta e incollala qui.",
    "ct-cliente-id": "ID cliente",
    "ct-line_1": "Line 1",
    "ct-checkout-gateway-stripe-one-click-payments": "Pagamenti con un clic",
    "ct-line_2": "Line 2",
    "ct-checkout-gateway-paypal-info-line1": "Si prega di scrivere una breve descrizione qui.",
    "ct-checkout-gateway-paypal-info-line2": "Fai clic su Accedi nell'angolo in alto a destra, quindi inserisci la tua email e password PayPal.",
    "ct-checkout-gateway-paypal-info-line3": "Nella sezione Le mie app e credenziali, fai clic su Crea app. ",
    "ct-line_3": "Line 3",
    "ct-checkout-gateway-paypal-info-line4": "Digita il nome dell'app, puoi usare qualsiasi cosa, quindi fai clic su Crea app.",
    "ct-checkout-gateway-paypal-info-line5": "Copia l'ID Cliente e il Secret, quindi incollali nei seguenti campi.",
    "ct-line_4": "Line 4",
    "ct-line_5": "Line 5",
    "ct-line_6": "Line 6",
    "ct-company-data": "Company Data",
    "ct-checkout-gateway-paypal-create-sandbox": "Crea sandbox",
    "ct-checkout-gateway-pagseguro-exclusive-info": "GATEWAY ESCLUSIVO PER IL BRASILE",
    "ct-production": "Produzione",
    "ct-sandbox": "-",
    "ct-call_to_action_text": "Call To Action text",
    "ct-call_to_action_page": "Call to Action URL",
    "ct-checkout-gateway-pagseguro-making-sales": "Impostazioni per effettuare vendite",
    "ct-checkout-gateway-pagseguro-making-sales-1": "Informe uma Descrição breve desta configuração para que você possa localizá-la facilmente no futuro. ",
    "ct-checkout-gateway-pagseguro-making-sales-2": "Insira login, senha e clique em Entrar. ",
    "ct-checkout-gateway-pagseguro-making-sales-3": "No menu vertical esquerdo na seção VENDA ONLINE, acesse Integrações. ",
    "ct-checkout-gateway-pagseguro-making-sales-4": "Em Utilização de API's, gere um novo token ou solicite por e-mail.  ",
    "ct-checkout-gateway-pagseguro-making-sales-5": "Lembre-se que sua conta deve estar como Vendedor e que ao gerar um novo token, seu token antigo não funcionará mais. ",
    "ct-checkout-gateway-pagseguro-acess-page-here": "Accedi a PagSeguro da qui:",
    "ct-checkout-gateway-pagseguro-making-tests": "Configurações para teste (SANDBOX) ",
    "ct-checkout-gateway-pagseguro-making-tests-1": "Informe uma Descrição breve desta configuração para que você possa localizá-la facilmente no futuro. ",
    "ct-checkout-gateway-pagseguro-making-tests-2": "Insira login, senha e clique em Entrar. ",
    "ct-checkout-gateway-pagseguro-making-tests-3": "No menu vertical esquerdo na seção PERFIS DE INTEGRAÇÃO acesse Vendedor. ",
    "ct-checkout-gateway-pagseguro-making-tests-4": "Copie \"Seu e-mail é\", \"Seu token é\" e cole nos campos ao lado .",
    "ct-checkout-gateway-pagseguro-making-tests-5": "Lembre-se que o campo Habilitar modo SANDBOX (apenas para testes) deverá estar habilitado. ",
    "ct-checkout-gateway-pagseguro-making-tests-6": "Para concluir uma venda de teste acesse o painel de Sandbox do Pagseguro e altere o status da compra pendente para \"Paga\". ",
    "ct-checkout-gateway-pagseguro-create-boleto": "Crea distinta di pagamento",
    "ct-checkout-gateway-pagseguro-enable-ticket": "Abilita l'assicurazione del biglietto",
    "ct-checkout-gateway-paypal-acess-page-here": "Accedi a PayPal da qui:",
    "ct-client-id": "ID Cliente",
    "ct-checkout-gateway-stripe-acess-page-here": "Accedi e accedi a Stripe qui:",
    "ct-checkout-product-create-category-1": "eBooks o file multimediali",
    "ct-checkout-product-create-category-2": "Corsi o Abbonamenti",
    "ct-checkout-product-create-category-3": "Servizi",
    "ct-checkout-product-create-category-4": "Consulenze",
    "ct-checkout-product-create-category-5": "Vestiti, scarpe e accessori",
    "ct-checkout-product-create-category-6": "Cosmetici e Profumi",
    "ct-checkout-product-create-category-7": "Giochi e giocattoli",
    "ct-checkout-product-create-category-8": "Libri, quaderni o diari",
    "ct-checkout-product-create-category-9": "Cibo o bevande",
    "ct-checkout-product-create-category-10": "Salute e Benessere",
    "ct-checkout-product-create-category-11": "Altro",
    "ct-element-checkout": "Supercheckout",
    "ct-no-mirrors-yet": "Non ci sono ancora Mirror",
    "ct-website-mirror": "Abilita Mirror",
    "ct-edit-product": "Modifica Prodotto",
    "ct-create-product": "Crea prodotto",
    "ct-selected-element": "Selected element",
    "ct-multiple-actions": "Azioni multiple",
    "ct-option-supercheckout": "Configurazione Supercheckout",
    "cheetah-category-template-32": "Vuoto",
    "cheetah-template-494968": "Template Vuoto",
    "ct-checkout-always-ask-address": "Chiedi sempre l'indirizzo",
    "ct-checkout-ask-address": "Richiedi indirizzo",
    "ct-last-page": "Última",
    "ct-checkout-payment-bottom-info-text": "Testo in fondo al pagamento",
    "ct-website-name-here": "Nome Sito Web",
    "ct-mailingboss-url-list": "Impostazioni URL Lista",
    "ct-mailingboss-select-list": "Modulo Mailingboss ",
    "ct-mailingboss-create-list": "Crea una Lista ",
    "ct-option-socialproof": "Social Proof",
    "ct-sp-mailingboss-form-helper": "Puoi accedere a Social Proof tramite l'ufficio e creare la tua campagna per MailingBoss.",
    "ct-display-resource_components": "Componenti",
    "ct-feed-resource_components": "Componenti Feed:",
    "ct-add-icon-title": "Icona",
    "ct-icon-not-found": "Icona non trovata",
    "ct-social-proof-tag": "Campo da utilizzare come nome utente",
    "ct-social-proof-select-tag": "seleziona un campo da utilizzare come nome utente",
    "ct-element-lists": "Elenchi",
    "ct-goto-social-proof": "Vai al Nuovo Social Proof",
    "ct-panel-calendar-page": "Pagina Calendario",
    "ct-panel-checkout-page": "Pagina Checkout",
    "ct-panel-offer-wall-page": "Pagina Muro Offerte",
    "ct-panel-share-page": "Pagina Condividi",
    "ct-panel-upsell-page": "Pagina Upsell",
    "ct-success-reorder": "riordinato con successo",
    "ct-page-name-plch": "Nome pagina",
    "ct-page-title-plch": "Titolo pagina (usato per il SEO della pagina)",
    "ct-page-description-plch": "Descrizione della pagina (usata per il SEO della pagina)",
    "ct-page-script-plch": "Puoi aggiungere qui gli script che ritieni necessari per la tua pagina",
    "ct-key-words-plch": "Le parole chiave SEO sono termini aggiunti ai contenuti online al fine di migliorare il posizionamento nei motori di ricerca per tali termini.",
    "ct-metatag-plch": "<meta name=\"autore\" content=\"Builderall\">",
    "ct-info-split-test": "In quest'area puoi creare split test per valutare quali cambiamenti nella tua pagina principale possono influenzare le tue vendite, ti consigliamo piccole modifiche come testi e pulsanti.",
    "ct-split-add-test": "Aggiungi Split Test",
    "ct-split-add-page": "Aggiungi Pagina",
    "ct-split-test": "Split Test ",
    "ct-split-test-main": "Pagina Principale:",
    "ct-split-test-target": "Pagina Destinazione:",
    "ct-split-test-view-data": "Visualizza i dati dello Split Test",
    "ct-split-test-view-data-button": "Visualizza  Dati",
    "ct-split-new-variation": "Nuova Variazione",
    "cheetah-template-538587": "Pagina \"Squeeze\" Tema Vuoto",
    "ct-split-variations": "Variazioni",
    "ct-split-remove-test": "Rimuovi Split Test",
    "cheetah-template-538889": "Pagina \"Squeeze Inverso\" Tema Vuoto",
    "cheetah-template-538890": "Pagina \"Squeeze Inverso\" Tema Vuoto",
    "cheetah-template-538907": "Pagina \"Lead Magnet\" Tema Vuoto",
    "cheetah-template-538948": "Pagina \"Application\" Tema Vuoto",
    "cheetah-template-539007": "Pagina \"Bridge\" Tema Vuoto",
    "cheetah-template-539025": "Pagina \"Thank You\" Tema Vuoto",
    "cheetah-template-539035": "Pagina \"Questionario\" Tema Vuoto",
    "cheetah-template-539150": "Pagina \"Oto\" Tema Vuoto",
    "cheetah-template-539200": "Pagina \"Downsale\" Tema Vuoto",
    "cheetah-template-539240": "Pagina \"VSL\" Tema Vuoto",
    "cheetah-template-539290": "Pagina \"Sales Letter\" Tema VuotoPage",
    "cheetah-template-539320": "Pagina \"Membership Area\" Tema Vuoto",
    "ct-tests-view-page": "Pagina",
    "ct-tests-view-access": "Accesso",
    "ct-tests-view-forward": "Inoltrare",
    "ct-tests-view-helper": "Attenzione. Quando rimuovi una pagina, i dati dello split test verranno ripristinati.",
    "ct-deleted-true": "Cancellato",
    "cheetah-template-540617": "Pagina \"Webinar Registration\" Tema Vuoto",
    "cheetah-template-540635": "Pagina \"Webinar Confirmation\" Tema Vuoto",
    "ct-split-test-error-no-origin": "Devi selezionare la pagina di origine",
    "ct-split-test-error-no-target": "Devi selezionare la pagina di destinazione",
    "ct-split-test-error-same-page": "Serve selezionare pagine differenti",
    "ct-split-test-error-need-page": "Serve selezionare una pagina",
    "cheetah-template-540655": "Pagina \"Webinar Indocrination\" Tema Vuoto",
    "cheetah-template-540666": "Pagina \"Webinar Broadcast\" Tema Vuoto",
    "cheetah-template-540682": "Pagina \"Webinar Replay\" Tema Vuoto",
    "cheetah-template-540697": "Pagina \"Daily Deal\" Tema Vuoto",
    "cheetah-template-540731": "Pagina \"Product Launch\" Tema Vuoto",
    "cheetah-template-540748": "Pagina \"Product Launch Order\" Tema Vuoto",
    "cheetah-template-541047": "Pagina \"Landing Page\" Tema Vuoto",
    "cheetah-template-541079": "Pagina \"3 Step Thank You\" Tema Vuoto",
    "cheetah-template-541096": "Pagina \"Confirm Email\" Tema Vuoto",
    "cheetah-template-541134": "Pagina \"Download\" Tema Vuoto",
    "cheetah-template-541135": "Pagina \"Download\" Tema Vuoto",
    "cheetah-template-541164": "Pagina \"Upsell\" Tema Vuoto",
    "cheetah-template-541181": "Pagina \"Offer Wall\" Tema Vuoto",
    "cheetah-template-541256": "Pagina \"Share\" Tema Vuoto",
    "cheetah-template-541272": "Pagina \"Checkout\" Tema Vuoto",
    "cheetah-template-541369": "Pagina \"Calendar\" Tema Vuoto",
    "cheetah-category-template-33": "Pagine Funnel Tema Vuoto",
    "ct-update-cache": "Update cache",
    "ct-sp-simple-form-helper": "Puoi accedere a Social Proof tramite l'ufficio e creare la tua campagna per il Modulo di Contatto.",
    "ct-sp-sync": "Aggiorna l'elenco delle campagne",
    "cheetah-template-548792": "Oriental",
    "ct-sub-menu-is-empty": "Questo menu non ha sottomenu",
    "ct-subitem-add": "Aggiungi sottomenu",
    "ct-menu-settings": "Impostazioni Menu",
    "ct-files-selected-length": "Numero di file selezionati",
    "ct-files-selected-length-more-max": "Il numero massimo di file da selezionare è",
    "cheetah-template-571831": "Sales Page Structure",
    "ct-mobile-columns-helper": "Attenzione, attiva questa funzione solo se hai una conoscenza avanzata sulla costruzione di layout, serve per posizionare gli elementi in orizzontale nella versione mobile.",
    "ct-enable": "Abilita",
    "ct-mobile-columns": "Colonne su Mobile (Avanzate)",
    "ct-grid": "Colonne",
    "ct-guru-product-id": "ID Prodotto",
    "ct-guru-product-help": "L'ID prodotto deve corrispondere a quello fornito in Digital Manager Guru",
    "ct-api-token": "Token API",
    "ct-api-token-help": "Token API è fornita da Digital Manager Guru",
    "ct-transfer-info-blog-turbo": "Le pagine del blog e le pagine turbo non vengono trasferite con il sito.",
    "ct-transfer-mirror": "La duplicazione e il trasferimento non sono consentiti in questa situazione.",
    "ct-heat-map": "Click map ",
    "ct-heat-map-desc": "Lo strumento Click Map e Heat Analysis del tuo sito web ti aiuterà a identificare le aree più cliccate dai visitatori del tuo sito web, permettendoti di migliorare i tuoi risultati in base al comportamento del tuo pubblico.",
    "ct-heat-map-enable-site": "Abilitato",
    "ct-heat-map-title": "Click Map ",
    "ct-heat-map-enable-site-desc": "Disabilitando la Click map sul tuo sito sarà disabilitata",
    "ct-goto-heat-map": "Vai a Click map",
    "ct-options-empty": "Non è ancora presente alcuna opzione registrata",
    "ct-add-option": "Aggiungi opzione",
    "ct-fields-empty": "Non è ancora presente alcun campo registrato",
    "cheetah-template-620953": "Cookbook Squeeze Page",
    "cheetah-template-621083": "Pagina Squeeze Inverso -Ricettario  ",
    "cheetah-template-621149": "Cookbook Lead Magnet Page",
    "cheetah-template-625058": "Cookbook Application Page",
    "ct-redirect": "Reindirizzare",
    "ct-invalid-email-regex": "formato email non valido",
    "ct-check-configs": "Controlla le impostazioni",
    "ct-delete-default-value": "Rimuovi valore predefinito",
    "ct-config-action-receiver": "Configura un ricevente o un'azione",
    "ct-gallery-theme": "Tema",
    "ct-matriz": "Matrice",
    "ct-alternating": "Alternativo",
    "ct-tiles": "Tiles",
    "ct-mixed": "Misto",
    "ct-one-main": "Uno principale",
    "ct-delete-comment": "Delete Comment",
    "cheetah-template-652189": "Cookbook Bridge Page",
    "cheetah-template-652205": "Influencer Squeeze Page",
    "cheetah-template-652709": "Cookbook Thank You Page",
    "cheetah-template-652744": "Pagina \"Questionario\" Ricettario",
    "cheetah-template-653787": "Pagina Squeeze Inverso -Influencer",
    "cheetah-template-653867": "Influencer Lead Magnet Page",
    "cheetah-template-653868": "Influencer Lead Magnet Page",
    "cheetah-template-451786": "Açai Berry Shop",
    "cheetah-category-template-34": "Negozio di bacche di Acai",
    "cheetah-template-654146": "Influencer Application Page",
    "cheetah-category-template-35": "Pub & Ristoranti",
    "cheetah-template-455692": "Pub",
    "cheetah-category-template-36": "Barbecue",
    "cheetah-template-482988": "Barbecue",
    "cheetah-template-654169": "Influencer Bridge Page",
    "cheetah-template-538547": "Candy",
    "cheetah-category-template-37": "Dolci e Caramelle",
    "cheetah-category-template-38": "Coffee Shop",
    "cheetah-template-571832": "Coffee Shop",
    "cheetah-template-585246": "Fitness",
    "cheetah-template-654198": "Influencer Bridge Page",
    "cheetah-template-654205": "Influencer Thank You Page",
    "cheetah-template-654250": "Pagina \"Questionario\"  Influencer",
    "cheetah-template-654326": "Influencer Oto Page",
    "ct-select-time-unity": "Selezione l'unità di tempo",
    "ct-define-time": "Imposta il tempo in",
    "ct-input-name": "Metti un nome per il pannello",
    "ct-show-hide-panel": "Mostra Pannello Nascosto ",
    "ct-choose-panel": "Scegli Pannello da mostrare  ",
    "ct-choose-text-on-show": "Scegli il testo in evidenza ",
    "cheetah-template-655345": "Influencer Downsale Page",
    "ct-seconds": "Secondi",
    "ct-minutes": "Minuti",
    "cheetah-template-655381": "Influencer VSL Page",
    "cheetah-template-655686": "Influencer Webinar Registration Page",
    "cheetah-template-655776": "Influencer Webinar Brodcast Page",
    "cheetah-template-655827": "Influencer Webinar Confirmation Page",
    "cheetah-template-655840": "Influencer Webinar Indocrination Page",
    "cheetah-template-655864": "Influencer Webinar Replay Page",
    "cheetah-template-655941": "Influencer Sales Letter Page",
    "cheetah-template-656832": "Influencer Daily Deal Page",
    "cheetah-template-656833": "Influencer Daily Deal Page",
    "cheetah-template-656868": "Influencer Product Launch Page",
    "cheetah-template-656909": "Cookbook Oto Page",
    "cheetah-template-657256": "Influencer Product Launch Order Page",
    "cheetah-template-657303": "Influencer Landing Page",
    "cheetah-template-657352": "Influencer 3 Step Thank You Page",
    "cheetah-template-657474": "Cookbook Downsale Page",
    "cheetah-template-657570": "Cookbook VSL Page",
    "cheetah-template-658632": "Cookbook Sales Letter Page",
    "cheetah-template-658794": "Cookbook Membership Area Page",
    "cheetah-template-658837": "Influencer Membership Area Page",
    "cheetah-template-658842": "Influencer Confirm Email Page",
    "cheetah-template-658936": "Influencer Download Page",
    "cheetah-template-659018": "Cookbook Webinar Registration Page",
    "cheetah-template-659035": "Influencer Upsell Page",
    "cheetah-template-659114": "Cookbook Webinar Confirmation Page",
    "cheetah-template-659115": "Cookbook Webinar Confirmation Page",
    "cheetah-template-659124": "Influencer Offer Wall Page",
    "cheetah-template-659190": "Influencer Share Page",
    "cheetah-template-659203": "Cookbook Webinar Indocrination Page",
    "cheetah-template-659225": "Influencer Checkout Page",
    "cheetah-template-659233": "Influencer Checkout Page",
    "cheetah-template-659270": "Cookbook Webinar Broadcast Page",
    "cheetah-template-659286": "Cookbook Webinar Replay Page",
    "cheetah-template-659316": "Cookbook Daily Deal Page",
    "cheetah-template-659343": "Influencer Calendar Page",
    "cheetah-template-663261": "Cookbook Product Launch Page",
    "cheetah-template-663496": "Cookbook Product Launch Order Page",
    "cheetah-category-template-39": "Pagine Funnel Influencer ",
    "cheetah-template-663603": "Cookbook Landing Page",
    "cheetah-template-663813": "Cookbook 3 Step Thank You Page",
    "cheetah-template-665091": "Cookbook Confirm Email Page",
    "cheetah-template-665125": "Cookbook Download Page",
    "cheetah-template-665160": "Cookbook Upsell Page",
    "cheetah-template-665226": "Cookbook Offer Wall page",
    "cheetah-template-665292": "Cookbook Share Page",
    "cheetah-template-665303": "Cookbook Checkout Page",
    "cheetah-template-665311": "Cookbook Calendar Page",
    "cheetah-category-template-40": "Pagine Funnel Ricette di cucina",
    "cheetah-template-669605": "Complete Home Renovation Squeeze Page",
    "cheetah-template-669743": "\"Squeeze Page\" Corso Chef",
    "cheetah-template-669871": "Pagina Squeeze Inverso -Corso Chef ",
    "cheetah-template-669872": "Pagina Squeeze Inverso -Corso Chef",
    "cheetah-template-669933": "Chef Course Lead Magnet Page",
    "cheetah-template-669947": "Influencer Lead Magnet Page",
    "cheetah-template-669984": "Chef Course Lead Magnet Page",
    "ct-emails-dont-match": "Verification email does not match",
    "cheetah-template-673723": "Pagina Squeeze Inverso -Ristrutturazioni",
    "cheetah-template-674169": "Complete Home Renovation Lead Magnet Page",
    "cheetah-template-674170": "Chef Course Application Page",
    "cheetah-template-674186": "Complete Home Renovation Application Page",
    "cheetah-template-674260": "Chef Course Bridge Page",
    "cheetah-template-674364": "Chef Course Thank You Page",
    "cheetah-template-674400": "Pagina \"Questionario\"  Corso Chef",
    "cheetah-template-674414": "Complete Home Renovation Bridge Page",
    "cheetah-template-674489": "Complete Home Renovation Thank You Page",
    "cheetah-template-674505": "Pagina \"Questionario\" Ristrutturazione",
    "cheetah-template-675535": "Complete Home Renovation Oto Page",
    "cheetah-template-675542": "Chef Course Oto Page",
    "cheetah-template-675556": "Chef Course Downsale Page",
    "cheetah-template-675598": "Complete Home Renovation Downsale Page",
    "cheetah-template-675599": "Complete Home Renovation Downsale Page",
    "cheetah-template-675839": "Complete Home Renovation VSL Page",
    "cheetah-template-675874": "Complete Home Renovation Sales Letter Page",
    "cheetah-template-675954": "Complete Home Renovation Membership Area Page",
    "cheetah-template-676015": "Complete Home Renovation Webinar Registration Page",
    "cheetah-template-676057": "Complete Home Renovation Webinar Confirmation Page",
    "cheetah-template-676062": "Chef Course VSL Page",
    "cheetah-template-676085": "Complete Home Renovation Webinar Indocrination Page",
    "cheetah-template-676109": "Chef Course Sales Letter Page",
    "cheetah-template-676110": "Complete Home Renovation Webinar Broadcast Page",
    "cheetah-template-676125": "Complete Home Renovation Webinar Replay Page",
    "cheetah-template-676146": "Complete Home Renovation Daily Deal Page",
    "cheetah-template-676171": "Chef Course Membership Area Page",
    "cheetah-template-676193": "Chef Course Webinar Registration Page",
    "ct-layer-down": "Livello in basso",
    "ct-layer-up": "Livello in alto",
    "cheetah-template-676237": "Chef Course Webinar Confirmation Page",
    "cheetah-template-676256": "Chef Course Webinar Confirmation Page",
    "cheetah-template-676262": "Chef Course Webinar Indocrination Page",
    "cheetah-template-676278": "Chef Course Webinar Broadcast Page",
    "cheetah-template-676298": "Chef Course Webinar Replay Page",
    "cheetah-template-677225": "Complete Home Renovation Product Launch Page",
    "cheetah-template-677267": "Chef Course Daily Deal Page",
    "cheetah-template-677272": "Complete Home Renovation Product Launch Order Page",
    "cheetah-template-677311": "Chef Course Product Launch Page",
    "cheetah-template-677329": "Complete Home Renovation Landing Page",
    "cheetah-template-677371": "Chef Course Product Launch Order Page",
    "cheetah-template-677393": "Chef Course Landing Page",
    "cheetah-template-677427": "Chef Course 3 Step Thank You Page",
    "cheetah-template-677508": "Complete Home Renovation 3 Step Thank You Page",
    "cheetah-template-677545": "Complete Home Renovation Confirm Email Page",
    "cheetah-template-677586": "Complete Home Renovation Download Page",
    "cheetah-template-677609": "Complete Home Renovation Upsell Page",
    "cheetah-template-677652": "Chef Course Confirm Email Page",
    "cheetah-template-677669": "Chef Course Download Page",
    "cheetah-template-677670": "Chef Course Download Page",
    "cheetah-template-677671": "Chef Course Download Page",
    "cheetah-template-677694": "Chef Course Upsell Page",
    "cheetah-template-677707": "Complete Home Renovation Offer Wall Page",
    "cheetah-template-677745": "Chef Course Offer Wall Page",
    "cheetah-template-677768": "Complete Home Renovation Share Page",
    "cheetah-template-677792": "Complete Home Renovation Checkout Page",
    "cheetah-template-677797": "Chef Course Share Page",
    "cheetah-template-677806": "Complete Home Renovation Calendar Page",
    "cheetah-template-677828": "Chef Course Checkout Page",
    "cheetah-template-677829": "Chef Course Checkout Page",
    "cheetah-category-template-41": "Pagine Funnel Ristrutturazione completa della casa",
    "cheetah-template-677857": "Chef Course Calendar Page",
    "cheetah-category-template-42": "Pagine Funnel Corso Chef ",
    "cheetah-template-54331": "Fotógrafo",
    "cheetah-template-685908": "Travel Packages Squeeze Page",
    "cheetah-template-687019": "Pagina Squeeze Inverso -Pacchetto viaggi",
    "ct-hotmart-help": "Only one element per page is allowed, make sure you enter the correct key",
    "ct-key": "Key",
    "ct-hotmart-key-empty": "La chiave Hotmart è vuota",
    "ct-hotmart-enabled-on-box": "Hotmart abilitato sul box",
    "cheetah-template-687054": "Travel Packages Lead Magnet Page",
    "cheetah-template-687062": "Travel Packages Application Page",
    "cheetah-template-687116": "Travel Packages Bridge Page",
    "cheetah-template-687150": "Travel Packages Thank You Page",
    "cheetah-template-687163": "Pagina \"Questionario\"  Pacchetto Viaggio",
    "cheetah-template-687327": "Travel Packages Oto Page",
    "cheetah-template-687526": "Travel Packages Downsale Page",
    "discard": "Abbandona",
    "ct-discard-confirm": "Vuoi davvero annullare le modifiche?",
    "ct-discard-yes": "Si, abbandona",
    "ct-large-content-editor": "Modifica Grandi Contenuti ",
    "ct-domain-disconnect": "Voglio disconnettere il dominio",
    "ct-domain-disconnect-action": "Si, voglio disconnettere il dominio",
    "ct-domain-message-steps": "Affinché il tuo dominio funzioni correttamente, se non li hai già fatti, devi seguire questi passaggi:",
    "ct-domain-step-1": "Accedi alla piattaforma in cui è registrato il tuo dominio (goddaddy, namecheap,register, o qualsiasi essa sia.)",
    "ct-domain-step-2": "Accedi all'area delle impostazioni per modificare il server NS (Nameserver-DNS) del tuo dominio usando i dati che trovi qui sotto",
    "ct-domain-step-3": "Attendi circa un'ora affinché la propagazione sia completa (in alcuni casi può richiedere fino a 48 ore)",
    "ct-domain-info": "Dominio",
    "cheetah-category-template-43": "Allenamento Funzionale",
    "cheetah-category-template-44": "Abbigliamento e Accessori per il Fitness",
    "cheetah-category-template-45": "Cibo Salutare",
    "cheetah-category-template-46": "Dentista ",
    "cheetah-category-template-47": "Palestra ",
    "cheetah-category-template-48": "Veterinario",
    "cheetah-category-template-49": "Nutrizione",
    "cheetah-template-656897": "Fitness Clothing and Accessories",
    "cheetah-template-675573": "Cibo Salutare - 01",
    "cheetah-template-678831": "Dentist",
    "cheetah-template-663053": "Gym",
    "cheetah-template-655319": "Veterinary",
    "cheetah-template-668255": "Functional Training 02",
    "cheetah-template-691052": "Travel Packages VSL Page",
    "cheetah-template-691092": "Travel Packages Sales Letter Page",
    "cheetah-template-691199": "Travel Packages Membership Area Page",
    "cheetah-template-691221": "Travel Packages Webinar Registration Page",
    "cheetah-template-692166": "Travel Packages Webinar Confirmation Page",
    "cheetah-template-692185": "Travel Packages Webinar Indocrination Page",
    "cheetah-template-692271": "Travel Packages Webinar Broadcast Page",
    "cheetah-template-692292": "Travel Packages Webinar Replay Page",
    "cheetah-template-692564": "Travel Packages Daily Deal Page",
    "cheetah-template-692629": "Travel Packages Product Launch Page",
    "cheetah-template-692688": "Travel Packages Product Launch Order Page",
    "cheetah-template-692774": "Travel Packages Landing Page",
    "cheetah-template-692862": "Travel Packages 3 Step Thank You Page",
    "cheetah-template-696606": "Travel Packages Confirm Email Page",
    "cheetah-template-696617": "Travel Packages Download Page",
    "cheetah-template-696662": "Travel Packages Upsell Page",
    "cheetah-template-696708": "Travel Packages Offer Wall Page",
    "cheetah-template-696927": "Travel Packages Share Page",
    "cheetah-template-696939": "Travel Packages Checkout Page",
    "cheetah-template-696954": "Travel Packages Calendar Page",
    "cheetah-template-696956": "Travel Packages Calendar Page",
    "cheetah-category-template-50": "Pagine Funnel Pacchetti di Viaggio",
    "cheetah-template-610788": "Integratori Alimentari",
    "cheetah-template-711118": "Launch a Book Squeeze Page",
    "cheetah-template-711203": "Pagina Squeeze Inverso -Lancio di un libro",
    "cheetah-template-711448": "Launch a Book Lead Magnet Page",
    "cheetah-template-712756": "Launch a Book Application Page",
    "cheetah-template-712814": "Launch a Book Bridge Page",
    "cheetah-template-712963": "Launch a Book Thank You Page",
    "cheetah-template-712964": "Launch a Book Thank You Page",
    "cheetah-template-713006": "Pagina \"Questionario\" Lancio di un Libro",
    "cheetah-template-713143": "Launch a Book Oto Page",
    "cheetah-template-714625": "Launch a Book Downsale Page",
    "cheetah-template-714663": "Launch a Book Vsl Page",
    "cheetah-template-714675": "Launch a Book Sales Letter Page",
    "cheetah-template-714705": "Launch a Book Membership Area Page",
    "cheetah-template-721381": "Launch a Book Webinar Registration Page",
    "cheetah-template-721416": "Launch a Book Webinar Confirmation Page",
    "cheetah-template-721465": "Launch a Book Webinar Indocrination Page",
    "cheetah-template-721679": "Launch a Book Webinar Broadcast Page",
    "cheetah-template-721690": "Launch a Book Webinar Replay Page",
    "cheetah-template-721706": "Launch a Book Daily Deal Page",
    "cheetah-template-721731": "Launch a Book Product Launch Page",
    "cheetah-template-721780": "Launch a Book Product Launch Order Page",
    "cheetah-template-721799": "Launch a Book Landing Page",
    "cheetah-template-721887": "Launch a Book 3 Step Thank You Page",
    "cheetah-template-721903": "Launch a Book Confirm Email Page",
    "cheetah-template-721920": "Launch a Book Download Page",
    "cheetah-template-723076": "Launch a Book Download Page",
    "cheetah-template-723078": "Launch a Book Upsell Page",
    "cheetah-template-723089": "Launch a Book Offer Wall Page",
    "ct-platforms": "Piattaforma",
    "ct-pixel-event": "Nome Evento Pixel",
    "cheetah-template-723165": "Launch a Book Share Page",
    "cheetah-template-723186": "Launch a Book Share Page",
    "cheetah-template-723188": "Launch a Book Checkout Page",
    "cheetah-template-723208": "Launch a Book Calendar Page",
    "ct-link-rotator": "Link Rotator",
    "ct-pixel-event-before": "Esegui il pixel prima dell'azione",
    "cheetah-category-template-51": "Pagine del Funnel Lancio di un Libro",
    "ct-remove-recaptcha-confirm": "do you really want to remove the recaptcha?",
    "ct-option-remove-recaptcha": "Remove ReCaptcha",
    "want-connect-domain": "Voglio davvero connettere il dominio",
    "ct-showing-results-for": "Visualizzazione dei risultati per ",
    "ct-search-and-enter": "Scrivi che template stai cercando (in lingua inglese, e in italiano) e premi invio",
    "cheetah-template-744787": "Coach Course Squeeze Page",
    "cheetah-template-744809": "Pagina Squeeze Inverso -Corso Coach",
    "cheetah-template-744846": "Coach Course Lead Magnet Page",
    "cheetah-template-745139": "Coach Course Application Page",
    "cheetah-template-745161": "Coach Course Thank You Page",
    "cheetah-template-745184": "Pagina \"Questionario\" Corso Coach",
    "cheetah-template-745209": "Coach Course Oto Page",
    "cheetah-template-745256": "Coach Course Downsale Page",
    "cheetah-template-745273": "Coach Course VSL Page",
    "ct-overlay-color": "Colore Sovrapposizione",
    "ct-button-color": "Button Color",
    "ct-icon-color": "Icon Color",
    "ct-overlay-setting": "Impostazioni Sovrapposizione",
    "cheetah-template-746391": "Coach Course Sales Letter Page",
    "cheetah-template-746442": "Coach Course Membership Area Page",
    "cheetah-template-746452": "Coach Course Webinar Registration Page",
    "cheetah-template-746610": "Coach Course Thank You Page",
    "cheetah-template-746612": "Coach Course Webinar Confirmation Page",
    "cheetah-template-746645": "Coach Course Webinar Indocrination Page",
    "cheetah-template-746673": "Coach Course Webinar Broadcast Page",
    "cheetah-template-746682": "Coach Course Webinar Replay Page",
    "cheetah-template-746683": "Coach Course Webinar Replay Page",
    "cheetah-template-746689": "Coach Course Webinar Replay Page",
    "ct-launch-position": "La tua posizione in classifica",
    "ct-launch-count": "Persone registrate tramite il tuo Link",
    "ct-launch-copy": "Copia",
    "cheetah-template-746743": "Coach Course Daily Deal Page",
    "cheetah-template-746764": "Coach Course Product Launch Page",
    "cheetah-template-746812": "Launch a Book Product Launch Order Page",
    "cheetah-template-746813": "Coach Course Product Launch Order Page",
    "cheetah-template-746831": "Coach Course Landing Page",
    "ct-component-LaunchAppComponent": "Lancio",
    "ct-general-configs": "Impostazioni Generali",
    "ct-url-thank-you-page": "Indirizzo URL pagina promossa",
    "ct-mysite": "mysite",
    "ct-show-ranking": "Mostra posizione in classifica",
    "ct-yes-show": "si, mostra",
    "ct-dont-show": "Non mostrare",
    "ct-show-people-count": "Mostra il numero di persone registrate",
    "ct-share-config": "Configurazione Condivisione",
    "ct-social-share": "Pulsanti Condivisione Social",
    "ct-button-config": "Impostazioni Tasto",
    "ct-button-width": "Button Width",
    "button-height": "Altezza del tasto",
    "vertical-padding": "Spaziatura Verticale",
    "ct-margin-left": "Margine sinistro",
    "ct-text-configs": "Impostazioni Testo",
    "ct-vertical-padding": "Spaziatura Verticale",
    "ct-central-padding": "Spaziatura centrale",
    "ct-input-configs": "Impostazioni Inserimento dati",
    "ct-button-height": "Button height",
    "cheetah-template-746882": "Coach Course 3 Step Thank You Page",
    "cheetah-template-746891": "Coach Course Confirm Email Page",
    "cheetah-template-746900": "Coach Course Download Page",
    "cheetah-template-746916": "Coach Course Upsell Page",
    "cheetah-template-746928": "Coach Course Offer Wall Page",
    "cheetah-template-746956": "Coach Course Share Page",
    "cheetah-template-746957": "Coach Course Share Page",
    "cheetah-template-746975": "Coach Course Checkout Page",
    "cheetah-template-746992": "Coach Course Calendar Page",
    "ct-launchapp": "Lancio Virale",
    "cheetah-template-747970": "Coach Course Bridge Page",
    "cheetah-category-template-52": "Pagine Funnel Corso Coach",
    "cheetah-template-691139": "Ice Cream Shop",
    "cheetah-category-template-53": "Gelateria",
    "cheetah-category-template-54": "Cibo & Bevande",
    "cheetah-category-template-55": "Servizi",
    "cheetah-category-template-56": "Feste & Club",
    "cheetah-template-709888": "Party Snacks",
    "cheetah-template-687069": "NightClub 01",
    "cheetah-category-template-57": "Moda & Bellezza",
    "cheetah-template-732260": "Pizzeria",
    "cheetah-template-763985": "Air Conditioning Service Squeeze Page",
    "cheetah-template-763987": "Air Conditioning Service Squeeze Page",
    "cheetah-template-764014": "Pagina Squeeze Inverso -Servizio Aria Condizionata",
    "cheetah-template-764244": "Air Conditioning Service Lead Magnet Page",
    "cheetah-template-764368": "Air Conditioning Service Application Page",
    "cheetah-template-764470": "Air Conditioning Service Bridge Page",
    "cheetah-template-765476": "Air Conditioning Service Bridge Page",
    "cheetah-template-765486": "Air Conditioning Service Thank You Page",
    "cheetah-template-765506": "Pagina \"Questionario\"  Servizio Aria Condizionata",
    "cheetah-template-765539": "Air Conditioning Service Oto Page",
    "cheetah-template-765540": "Air Conditioning Service Oto Page",
    "cheetah-template-765600": "Air Conditioning Service Downsale Page",
    "cheetah-template-765642": "Air Conditioning Service VSL Page",
    "cheetah-template-765678": "Air Conditioning Service Sales Letter Page",
    "cheetah-template-766030": "Air Conditioning Service Membership Area Page",
    "cheetah-template-766043": "Air Conditioning Service Membership Area Page",
    "cheetah-template-766100": "Air Conditioning Service Webinar Registration Page",
    "cheetah-template-766132": "Air Conditioning Service Webinar Confirmation Page",
    "cheetah-template-766154": "Air Conditioning Service Webinar Indocrination Page",
    "cheetah-template-766179": "Air Conditioning Service Webinar Broadcast Page",
    "cheetah-template-766210": "Air Conditioning Service Webinar Replay Page",
    "cheetah-template-766238": "Air Conditioning Service Daily Deal Page",
    "cheetah-template-767299": "Air Conditioning Service Product Launch Page",
    "cheetah-template-767349": "Air Conditioning Service Product Launch Order Page",
    "cheetah-template-767403": "Air Conditioning Service Landing Page",
    "cheetah-template-767443": "Air Conditioning Service 3 Step Thank You Page",
    "cheetah-template-767462": "Air Conditioning Service Confirm Email Page",
    "cheetah-template-767491": "Air Conditioning Service Download Page",
    "cheetah-template-767752": "Air Conditioning Service Upsell Page",
    "cheetah-template-767775": "Air Conditioning Service Offer Wall Page",
    "cheetah-template-767776": "Air Conditioning Service Offer Wall Page",
    "cheetah-template-767801": "Air Conditioning Service Share Page",
    "cheetah-template-767810": "Air Conditioning Service Checkout Page",
    "cheetah-template-767857": "Air Conditioning Service Calendar Page",
    "ct-tag-name-lead": "Lead Name",
    "cheetah-category-template-58": "Pagine del Funnel di Servizio Aria Condizionata",
    "cheetah-template-701536": "Giardinaggio 01",
    "ct-hotmart-product-id-help": "Quando si registra l'ID prodotto, tutte le vendite chiamate da Webhook verranno conteggiate creando record nell'area membri",
    "ct-key-words-plch-seo": "Es: Digital marketing, Sales funnel, ecc.",
    "ct-robots-plch-seo": "Es: User-agent: *\nNon consentire: /nomepagina",
    "ct-metatag-seo": "I meta tags sono parte degli HTML tags. Descrivono il contenuto della tua pagina per i motori di ricerca e per i visitatori del tuo sito.",
    "ct-robots-seo": "I robot funzionano come un filtro per i robot dei motori di ricerca e controllano il permesso di accedere a determinate pagine del sito.",
    "ct-ads-plch-seo": "Es: google.com, pub-0000000000000000, DIRECT, f08c47fec0942fa0",
    "ct-ads-seo": "I file ads.txt ti aiutano ad avere un maggiore controllo su chi è autorizzato a fare le ADS sul tuo sito.",
    "ct-tablet-version": "Tablet Version",
    "ct-tag-plch": "Tag nome",
    "ct-alert-tag": "Attenzione: l'attributo tag deve essere utilizzato solo da utenti esperti. Con questo tag è possibile manipolare gli elementi utilizzando il selettore di tag di dati.",
    "ct-versao-tablet": "Questa versione definisce quale verrà visualizzata sui dispositivi tablet. Esempio: se selezioni \"desktop\", la versione desktop del tuo sito web verrà visualizzata sul tablet.",
    "ct-time-animation": "Il tempo deve essere impostato in secondi.",
    "ct-select-icon": "Select Icon",
    "ct-new-tab": "New Tab",
    "ct-position": "Position",
    "ct-default-message": "Default Message",
    "ct-left-soft": "Spaced Left",
    "ct-right-soft": "Spaced Right",
    "ct-squared": "Squared",
    "ct-rounded": "Rounded",
    "ct-only-mobile-devices": "Only Mobile",
    "ct-welcome-message": "Welcome message",
    "ct-clicks": "Clicks",
    "ct-type-your-message": "Type your message",
    "ct-text-color": "Text Color",
    "cheetah-template-799818": "Gym Squeeze Page",
    "cheetah-template-799888": "Pagina Squeeze Inverso -Palestra",
    "cheetah-template-799925": "Gym Lead Magnet Page",
    "ct-option-grid": "Grid",
    "cheetah-category-template-59": "Pagina Vuota",
    "ct-eduzz-code-empty": "Codice Eduzz Vuoto",
    "ct-wl-upgrade": "PRO ",
    "cheetah-template-797863": "Mais Voz Telecom",
    "cheetah-template-764294": "Mais Voz Telecom",
    "cheetah-template-765492": "Funis Mais Voz",
    "cheetah-category-wizard-1": "Negozio",
    "cheetah-template-861403": "Blank One",
    "ct-pixel-event-add": "Aggiungi Pixel Evento",
    "ct-origin-url": "Origin URL",
    "cheetah-template-885879": "ESTRATÉGIAS SECRETAS PARA ATRAIR SEGUIDORES ENGAJADOS PARA SEU INSTAGRAM 1",
    "ct-login-expires-at": "L'accesso scade alle:",
    "ct-custom-sizes": "Custom Sizes",
    "ct-div-sizes": "Div Sizes",
    "ct-container-size": "Container sizes",
    "ct-button-size": "Button container size",
    "ct-field": "Campo",
    "ct-quiz-config": "Configurazione quiz",
    "ct-quiz-have-create": "Devi creare un quiz nel nostro",
    "ct-quiz-app": "App quiz",
    "ct-quiz-create": "Crea quiz",
    "ct-component-QuizComponent": "Quiz",
    "ct-element-quiz": "Quiz",
    "ct-select-quiz": "Seleziona quiz",
    "ct-facebook-api-test": "Per testare l'api, usa il parametro Facebook test_event_code nel tuo sito web Url",
    "ct-facebook-one-event-whitout-api": "Se non hai una chiave api usa solo un evento per pagina",
    "ct-page-importer": "Importatore di contenuti",
    "ct-page-importer-url": "URL del contenuto",
    "ct-page-importer-helper": "Attenzione, al momento è possibile importare contenuti solo da ClickFunnels",
    "ct-need-save-element-to-update": "è necessario salvare l'elemento perché questa modifica abbia effetto",
    "ct-exclude": "Delete",
    "ct-name-new-popup": "New popup name",
    "ct-new-name-header": "New header name",
    "ct-new-name-footer": "New footer name",
    "ct-name-new-header": "New header name",
    "ct-name-new-footer": "New footer name",
    "ct-empty-elements": "Non ci sono elementi registrati",
    "ct-sticky-panel": "Fixed Panel",
    "cheetah-category-wizard-2": "Sito Express",
    "cheetah-template-901508": "Candy - Smart Template",
    "cheetah-category-wizard-3": "Blog",
    "cheetah-template-922045": "Marketing Digital - Blog Smart Template",
    "cheetah-category-wizard-4": "fisico",
    "cheetah-category-wizard-5": "digitale",
    "cheetah-category-wizard-6": "leads",
    "cheetah-category-wizard-7": "webinar",
    "cheetah-category-wizard-8": "membri",
    "cheetah-template-924197": "Clothes - Ecommerce Smart Template",
    "cheetah-template-924198": "Glasses - Ecommerce Smart Template",
    "cheetah-template-924199": "Cell - Ecommerce Smart Template",
    "cheetah-template-924200": "Cosmetics - Ecommerce Smart Template",
    "cheetah-template-924201": "Home appliance - Ecommerce Smart Template",
    "cheetah-template-924202": "Academy Products - Ecommerce Smart Template",
    "cheetah-template-924203": "Bath - Ecommerce Smart Template",
    "cheetah-template-924312": "Chef Course Membership Page",
    "cheetah-template-924313": "Influencer Membership Page",
    "cheetah-template-924314": "Cookbook Membership Page",
    "cheetah-template-924315": "Agency Membership Page",
    "cheetah-template-924316": "Complete Home Renovation Membership Page",
    "cheetah-template-924317": "Launch a Book Tag Membership Area Page",
    "cheetah-template-924318": "Travel Packages Tag Membership Area Page",
    "cheetah-template-924319": "Coach Course Tag Membership Area Page",
    "cheetah-template-924321": "App Tag Membership Area Page",
    "cheetah-template-924322": "Marketing Tag Membership Area Page",
    "cheetah-template-925085": "Marketing Digital",
    "ct-update-success": "Aggiornamento riuscito!",
    "cheetah-template-936743": "Insurance Broker - Smart Template",
    "cheetah-template-936744": "Food Supplement - Smart Template",
    "cheetah-template-936745": "Pizzeria - Smart Template",
    "cheetah-template-936746": "Travel Agency - Smart Template",
    "cheetah-template-936747": "Doctors - Smart Template",
    "cheetah-template-936748": "Running Training - Smart Template",
    "cheetah-template-936749": "Finalcial Coach - Smart Template",
    "cheetah-template-936750": "Personal Trainer - Smart Template",
    "cheetah-template-936751": "Bar - Smart Template",
    "cheetah-template-936752": "Steak House - Smart Template",
    "cheetah-template-936754": "Painter- Smart Template",
    "cheetah-template-936755": "Restaurant - Smart Template",
    "cheetah-template-936756": "Credit Recovery - Smart Template",
    "cheetah-template-936758": "Photographer - Smart Template",
    "cheetah-template-936759": "Interior Design - Smart Template",
    "cheetah-template-936760": "Crossfit - Smart Template",
    "cheetah-template-936766": "Ice Cream Shop - Smart Template",
    "cheetah-template-936767": "Gardening - Smart Template",
    "cheetah-template-936768": "Fitness Clothing and Accessories - Smart Template",
    "cheetah-template-936769": "Barbecue- Smart Template",
    "cheetah-template-936770": "Hairdresser - Smart Template",
    "cheetah-template-936771": "Marketing Digital - Smart Template",
    "cheetah-template-936772": "Engineers - Smart Template",
    "cheetah-template-936775": "Bricklayer - Smart Template",
    "cheetah-template-936777": "Sweets - Smart Template",
    "cheetah-template-936779": "Nurses - Smart Template",
    "cheetah-template-936780": "Psychologist - Smart Template",
    "cheetah-template-936781": "Brides - Smart Template",
    "cheetah-template-936782": "Pub - Smart Template",
    "cheetah-template-936783": "FoodTruck - Smart Template",
    "cheetah-template-936784": "Nightclub - Smart Template",
    "cheetah-template-936785": "Party Room - Smart Template",
    "cheetah-template-936786": "Administrator - Smart Template",
    "cheetah-template-936787": "Party Snacks - Smart Template",
    "cheetah-template-936788": "Personal Stylist - Smart Template",
    "cheetah-template-936789": "Biologist - Smart Template",
    "cheetah-template-936790": "Eyebrow - Smart Template",
    "cheetah-template-936791": "Gym - Smart Template",
    "cheetah-template-936792": "Journalists - Smart Template",
    "cheetah-template-936793": "Journalists - Smart Template",
    "cheetah-template-936794": "Accountants - Smart Template",
    "cheetah-template-936796": "Remodeling - Smart Template",
    "cheetah-template-936797": "Decorator - Smart Template",
    "cheetah-template-936798": "Massage - Smart Template",
    "cheetah-template-936799": "Lymphatic Drainage - Smart Template",
    "cheetah-template-936800": "Podiatrist - Smart Template",
    "cheetah-template-936802": "Financial Analyst - Smart Template",
    "cheetah-template-936803": "Hydraulic Firefighter",
    "cheetah-template-936805": "Snack",
    "cheetah-template-936806": "Nutritionist",
    "cheetah-template-936808": "Functional Training",
    "cheetah-template-936809": "Coffee Shop",
    "cheetah-template-936810": "Dentist - Smart Template",
    "cheetah-template-936811": "Acai Berry Shop - Smart Template",
    "cheetah-template-936812": "Healthy Food - Smart Template",
    "cheetah-template-936813": "Planned Furniture - Smart Template",
    "cheetah-template-936814": "Weight Loss Coach - Smart Template",
    "cheetah-template-936815": "Architects - Smart Template",
    "cheetah-template-936816": "Hair Removal - Smart Template",
    "cheetah-template-936817": "Tutor - Smart Template",
    "cheetah-template-936818": "Manicure and Pedicure",
    "ct-action-popups-is-empty": "Non hai ancora nessun popup.",
    "ct-action-anchors-is-empty": "Non hai ancora nessuna ancora.",
    "cheetah-template-941468": "Cook Book - Info Product",
    "cheetah-template-941469": "Chef Course - Info Product",
    "cheetah-template-941470": "Agency Sales Page Structure",
    "cheetah-template-941471": "APP Sales Page Structure",
    "cheetah-template-941472": "Marketing Sales Page Structure",
    "cheetah-template-941474": "Coach Sales Page Structure",
    "cheetah-template-941475": "Launch a Book Page Structure",
    "cheetah-template-941476": "Influencer Page Structure",
    "cheetah-template-941477": "Complete Home Renovation Page Structure",
    "ct-checkout-continue-button-label": "Testo Bottone Continua",
    "ct-checkout-continue-button": "Continua",
    "ct-checkout-security-title-label": "Titolo del messaggio di sicurezza",
    "ct-checkout-security-title": "Le tue informazioni sono al sicuro",
    "ct-checkout-security-content": "Non venderemo né cederemo a terzi le tue informazioni personali per scopi di marketing commerciale.",
    "ct-checkout-payment-button-label": "Testo del pulsante di pagamento",
    "ct-checkout-payment-button": "Paga con :gateway",
    "ct-checkout-payment-button-help": "Digitare il testo del pulsante di pagamento; la parte :gateway sarà sostituita in automatico dal nome del gateway, ad esempio: Stripe, Molly. La parte :price sarà sostituita in automatico dal totale dell'acquisto, ad esempio: € 10,00.",
    "ct-checkout-thankyou-title-label": "Titolo passo Thank you (completato)",
    "ct-checkout-thankyou-title": "Thank You",
    "ct-checkout-thankyou-text-label": "Testo passo Thank you",
    "ct-checkout-thankyou-text": "Il tuo pagamento è stato elaborato e approvato con successo! Clicca sul pulsante qui sotto per continuare",
    "ct-checkout-thankyou-get-product-button-label": "Testo del pulsante Accedi al tuo prodotto",
    "ct-checkout-thankyou-get-product-button": "Accedi al tuo prodotto",
    "ct-checkout-threestep-tip": "Suggerimento: Clicca sui passi per visualizzare le altre pagine",
    "ct-invalid-domain": "Invalid domain",
    "ct-connect": "Connetti",
    "ct-restore-page": "Ripristina pagina",
    "cheetah-template-948186": "Coach Course",
    "cheetah-template-948268": "Air Conditioning Service",
    "cheetah-template-948269": "Chef Course",
    "cheetah-template-948270": "Influencer",
    "cheetah-template-948271": "Launch a Book",
    "cheetah-template-948272": "Travel Packages",
    "cheetah-template-948273": "Complete Home Renovation",
    "cheetah-template-948274": "Cookbook",
    "cheetah-template-948275": "App",
    "cheetah-template-948276": "Agency",
    "ct-total-action": "Total actions",
    "ct-multi-action-edit": "Modifica azione multipla",
    "ct-multi-action": "Azione multipla",
    "ct-add-action": "Aggiungi un'azione multipla ",
    "ct-enable-rotator": "Enable Rotator",
    "ct-vote-quest": "Question",
    "ct-vote-system": "Sistema di votazione",
    "ct-vote-create-options": "Crea opzioni",
    "ct-vote-add-answers": "Aggiungi opzione",
    "ct-total-answers": "Totale voti ",
    "ct-option": "Opzione ",
    "ct-vote-enter-your-answer": "Testo Risposta",
    "ct-create-vote": "Crea una domanda",
    "ct-click-interval": "Intervallo di click",
    "ct-create-new-multiaction": "Nuova azione multipla ",
    "ct-name-new-multiaction": "new multi action",
    "ct-vote-event-before": "Sistema di votazione",
    "ct-question": "Question",
    "ct-answer": "Risposta",
    "ct-multiaction": "Multiple Actions",
    "ct-vote-settings": "Votazione",
    "ct-empty-vote": "Vuoto",
    "ct-link-multiple": "Multipla",
    "ct-link-vote": "Vota",
    "ct-mutiple-actions": "Multiple Actions",
    "ct-vote-action": "Voti ",
    "ct-change-file-download": "Cambia file per il download",
    "ct-modify-on-scroll": "Modifica su scorrimento",
    "ct-which-secondary-header": "Scegliere header secondario",
    "ct-sticky-footer": "Footer fissato in basso",
    "ct-restore-pages": "Ripristinare pagine",
    "ct-versions": "Versions",
    "ct-undelete": "Undelete",
    "ct-confirm-restore-page": "Sei sicuro di voler ripristinare la pagina selezionata? l'url sarà cambiato e sarà necessario modificarlo",
    "ct-page-restored-success": "Pagina ripristinata con successo",
    "ct-alert-domain": "Please check your domain",
    "ct-copyed-success": "Successfully copied",
    "ct-version-active": "Version Active",
    "ct-rollback": "Rollback",
    "ct-confirm-rollback": "Vuoi davvero ripristinare il contenuto di questa pagina a questa versione?",
    "ct-version-changed-success": "Version changed with success",
    "ct-version-date": "Version date",
    "ct-version-type": "Type",
    "ct-version-control": "Version Control",
    "ct-rollback-this-version": "Rollback to this version",
    "ct-component-VideoComponent": "Ba Hosting",
    "ct-update": "Update",
    "ct-available-videos": "Available Videos",
    "ct-plan-limited": "This plan requires a domain to be published",
    "ct-vote-text-options": "Possibili risposte",
    "ct-plan-limited-transfer": "questo piano non consente il trasferimento di siti web",
    "ct-mobile-height": "Mobile Height",
    "ct-members-user-edit": "Modifica membro",
    "ct-members-log-login": "Registri di accesso",
    "ct-members-log-voltar": "Indietro",
    "ct-access-denied-type-link": "Tipo di reindirizzamento",
    "ct-access-link-home": "Home",
    "ct-access-link-web": "Web",
    "ct-access-link-page": "Pagina",
    "ct-access-denied-value-link-page": "Pagina",
    "ct-access-denied-value-link-web": "Indirizzo web",
    "ct-login-log-is-empty": "Registro vuoto. Questo utente non ha ancora effettuato l'accesso.",
    "ct-access-denied-btn-position": "Posizione del pulsante sulla tua pagina di accesso negato",
    "ct-access-link-btn-top": "In alto",
    "ct-access-link-btn-left": "A sinistra",
    "ct-access-link-btn-bottom": "In basso",
    "ct-access-link-btn-right": "A destra",
    "ct-new-domain": "Nuovo dominio",
    "cheetah-template-947176": "Limpeza de carros de luxo",
    "cheetah-template-964088": "Cleaning Service For Luxury Vehicle",
    "cheetah-template-969511": "LIMPIEZA PROFESIONAL PARA AUTOMÓVIL DE LUJO",
    "cheetah-category-template-60": "FUNNEL DI NICCHIA",
    "ct-version-api": "Usa l'API standard di Hotmart. Stiamo lavorando per rendere l'integrazione di Hotmart API 2.0 presto disponibile.",
    "ct-overview-btn-text": "Panoramica",
    "ct-overview-box-description": "Costruisci i tuoi siti web, le pagine e i funnel con il semplicissimo 100% Drag-and-Drop Builder.",
    "ct-overview-close-fullscreen": "Chiudi schermo intero",
    "ct-overview-btn-box-text": "Maggiori informazioni",
    "ct-hide-register-btn": "Nascondi il pulsante di registrazione",
    "ct-personal-tab-help": "Gli elementi o pannelli personali sono elementi che una volta salvati possono essere usati su altre pagine e siti web.<br/>\nPer salvare usa l'opzione \"Salva elemento\" nell'elemento o pannello.<br/>\nPuoi visualizzare e utilizzare i tuoi elementi personali qui sotto.",
    "ct-personal-elemts-empty": "Non ha ancora elementi personali.",
    "ct-personal-panel-empty": "Non hai ancora pannelli personali.",
    "ct-textarea-height": "Altezza della textarea",
    "ct-sub-text-color-hover": "Colore del testo della sezione hover",
    "ct-create-new-list-mb4": "Crea una nuova lista MB 4.0",
    "ct-create-new-list-mb5": "Crea una nuova lista MB 5.0",
    "ct-reload-list": "Ricarica la lista",
    "ct-box-hover-normal": "Normale",
    "ct-box-hover-edit": "Hover",
    "ct-box-hover-view": "Mostra",
    "ct-component-BoxHoverComponent": "Box hover",
    "ct-box-hover-effect-1": "Miniatura 1",
    "ct-box-hover-effect-2": "Scorrimento 2",
    "ct-box-hover-effect-3": "Scala 3",
    "ct-box-hover-effect-4": "Rientra 4",
    "ct-box-hover-effect-5": "Ruota 5",
    "ct-box-hover-effect-6": "Flip 6",
    "ct-box-hover-effect-7": "Tenda 7",
    "ct-box-hover-effect-8": "Appeso 8",
    "ct-box-hover-effect-9": "Pagina 9",
    "ct-box-hover-effect-10": "Sovrapposto 10",
    "ct-box-hover-config": "Effetto",
    "ct-box-hover-direction": "Direzione",
    "ct-box-hover-scale-up": "Aumentare ",
    "ct-box-hover-scale-down": "Ridurre le dimensioni",
    "ct-box-hover-scale-down-up": "ridimensionare verso l'alto",
    "ct-box-hover-left-to-right": "Da sinistra a destra",
    "ct-box-hover-right-to-left": "Da destra a sinistra",
    "ct-box-hover-bottom-to-top": "Dal basso verso l'alto",
    "ct-box-hover-top-to-bottom": "Dall'alto in basso",
    "ct-box-hover-img": "Impostazioni Immagine",
    "ct-element-box-hover": "Box hover",
    "ct-automatic-emails-config-normal": "Utilizzato in integrazione non ricorrenza permette",
    "ct-automatic-emails-integrations-desc": "È possibile creare e personalizzare le email  da inviare insieme al rilascio dell'area membri. Dopo la creazione e la modifica, collega il tuo tema e-mail con le impostazioni di integrazione desiderate.",
    "ct-automatic-emails-config-recurrence": "Usato quando l'integrazione ha abilitazioni di ricorrenza",
    "ct-auto-play": "Riproduzione automatica",
    "ct-ipn-password": "Password IPN",
    "ct-ipn-password-help": "La tua password configurata in CopeCart.",
    "ct-username": "Nome utente",
    "ct-pabbly-username-help": "Controlla il campo \"Proteggi l'URL del webhook con l'autenticazione di base\" e metti username e password uguali per una maggiore sicurezza.",
    "ct-vote-url": "URL",
    "ct-vote-unique": "Permettere il voto solo una volta",
    "ct-vote-help": "Se vuoi reindirizzare a un URL se hai già votato una volta",
    "ct-disconnect-domain-before-transfer": "Disconnetti il dominio prima del trasferimento!",
    "ct-webhook-create": "Crea webhook",
    "ct-webhook-name": "Nome",
    "ct-webhook-url": "URL",
    "ct-webhook-action": "Azione",
    "ct-webhook": "webhook",
    "ct-send-test-webhook": "Invia un webhook di prova",
    "ct-integration-webhook-save": "Salva per generare il tuo webhook url",
    "ct-action-copy-text": "Testo",
    "ct-link-copy": "Copia",
    "ct-action-copy-empty": "Il testo richiesto è vuoto.",
    "ct-action-copy-placeholder": "Digita le informazioni che vuoi copiare.",
    "ct-upload-images-maxname": "Il nome della tua immagine supera il limite massimo di 100 caratteri.",
    "ct-upload-videos-maxname": "Il nome del tuo video supera il limite massimo di 100 caratteri.",
    "ct-upload-files-maxname": "Il nome del tuo file supera il limite massimo di 100 caratteri.",
    "ct-webhook-action-create": "Nuovo utente",
    "ct-webhook-action-delete": "Cancellare l'utente",
    "ct-webhook-action-login": "Login",
    "ct-webhook-action-selected": "Seleziona l'azione",
    "ct-webhook-action-integration-completed": "Integrazione completata\t",
    "ct-webhook-action-integration-canceled": "Integrazione cancellata\t",
    "ct-supercheckout-count-obs": "L'elenco è limitato a 14 prodotti; se qualcuno non compare, copia il link direttamente da SuperCheckout.",
    "ct-element-accordion-link-tutorial": "https://www.youtube.com/",
    "cheetah-category-template-61": "Prendi il nostro design",
    "cheetah-template-1176424": "NETWORK",
    "cheetah-template-1175568": "3 FREE COURSES",
    "cheetah-template-1174266": "Branding Demo",
    "cheetah-template-1174271": "Podcast",
    "cheetah-template-1173114": "Speaker",
    "cheetah-category-template-62": "I 10 migliori Funnel di affiliazione",
    "cheetah-template-1203695": "Template - Chad Bartlet",
    "cheetah-template-1202037": "Template -  Chad Bartlet",
    "cheetah-template-1202555": "Template - Katharina Kislewski",
    "cheetah-template-1203275": "Template - Barbie Figueroa",
    "cheetah-template-1204029": "Template - Shelly Turner",
    "cheetah-template-1204242": "Template - Salvatore Caretto",
    "cheetah-template-1203760": "Template - Ricardo Santos",
    "cheetah-template-1203295": "Template - Franko Dorival",
    "cheetah-template-1202514": "Template - Alex Freedman",
    "cheetah-template-1204548": "Blueprint - Marco Vantroba",
    "cheetah-template-1204551": "Blueprint - James Neville Taylor",
    "ct-origin-url-plh": "Pagina principale o /home",
    "ct-panel-move-order": "Spostare l'ordine dei pannelli",
    "ct-panel-move-popup-helper": "La numerazione dei pannelli verrà aggiornata dopo aver fatto clic su Sposta",
    "ct-show-panel-move-order": "Cambiare l'ordine dei pannelli",
    "ct-panel-order-empty": "Questa pagina non ha pannelli o ne ha solo uno, non è possibile cambiare l'ordine.",
    "cheetah-category-template-63": "Servizi professionali",
    "cheetah-category-template-64": "Salute e benessere",
    "cheetah-category-template-65": "Coaching, Conversazione, marketing",
    "cheetah-category-template-66": "Immobili",
    "cheetah-category-template-67": "OTO (offerta una tantum)",
    "cheetah-category-template-68": "Opt-in/reverse optin",
    "cheetah-category-template-69": "Registrazione a webinar/eventi",
    "cheetah-category-template-70": "Lead magnet",
    "cheetah-category-template-71": "Squeeze/ reverse squeeze page",
    "cheetah-category-template-72": "Pagina di ringraziamento",
    "cheetah-category-template-73": "Bridge page",
    "cheetah-category-template-74": "Lancio del prodotto",
    "cheetah-category-template-75": "Check out",
    "cheetah-category-template-76": "Tema bianco",
    "cheetah-category-template-77": "Tema scuro",
    "cheetah-category-template-78": "Pink Theme",
    "cheetah-category-template-79": "Tema blu",
    "cheetah-category-template-80": "Tema verde",
    "cheetah-category-template-81": "Tema giallo",
    "cheetah-category-template-82": "Tema vuoto",
    "ct-template-color": "Colore",
    "ct-template-industry": "Settore ",
    "ct-template-type": "Tipo",
    "ct-template-all": "Tutti",
    "ct-template-reset": "Reset",
    "ct-template-exclusive": "Esclusivo",
    "ct-reset": "Azzeramento valori",
    "ct-custom-sizes-title": "Personalizzazione delle dimensioni",
    "ct-copy-settings-from-desktop": "Copiare le impostazioni del desktop",
    "ct-create-website-blank": "Crea un sito web vuoto",
    "ct-website-global-color-new": "Il mio nuovo colore generale",
    "ct-website-global-colors": "Colori generali",
    "ct-website-global-colors-desc": "Crea i tuoi colori e configura l'elemento ad essi collegato, in modo da poterli cambiare tutti in una volta.",
    "ct-new-color": "Nuovo colore",
    "ct-colors-global": "Colori generali",
    "ct-equal": "Equal",
    "ct-bigger": "Bigger",
    "ct-smaller": "Smaller",
    "ct-tag-mboss-helper": "Attenzione, questa è una funzione avanzata ed è necessaria per avere il pieno controllo sull'automazione dei tag.",
    "ct-mailing-boss-list-panels": "Mailing Boss List",
    "ct-manage-user-font": "Impostazioni dei font",
    "ct-maneger-user-font": "Impostazioni del font",
    "ct-manage-user-font-message": "Quando si elimina questo font, esso non sarà più disponibile sul sito; ciò può causare un'interruzione del layout; assicurarsi di procedere con questa azione.",
    "ct-manage-user-font-confirm-message": "Confermo di voler eliminare questo font",
    "ct-manage-user-font-title": "Cancellare il font",
    "ct-panda-video-config": "Impostazioni video Panda",
    "ct-panda-video-security": "Per sicurezza, non memorizziamo la chiave API dell'utente.",
    "ct-panda-video-get-my-api-token": "Chiave API",
    "ct-panda-video-verify": "Ottieni l'elenco dei video",
    "ct-video-panda-have-create": "Non ci sono ancora video",
    "ct-panda-video-link-selected": "Video selezionato",
    "ct-panda-video-link": "Controlla il tuo video qui",
    "ct-component-PandaVideoComponent": "Panda Video",
    "ct-spaceBetween": "Space between images (px)",
    "ct-sliderInfinitePanel": "Element loop animation",
    "ct-backDrop": "enable backdrop",
    "ct-gapBetween": "Space between Panels",
    "ct-option-effect-side-padding": "Side Padding",
    "ct-marginBetween": "Panel size displayed on the sides",
    "ct-warning-side-padding-effect": "A minimum of three panels are required for the effect to be applied, in case of fewer panels the effect applied will be the Slider",
    "cheetah-template-1309338": "Physical Product",
    "cheetah-category-template-83": "Physical Product",
    "cheetah-template-1306637": "Online Course",
    "cheetah-category-template-84": "Online Course",
    "cheetah-template-1309229": "SEO Marketing Agency",
    "cheetah-template-1305571": "Yoga",
    "cheetah-template-1308169": "Special Burger",
    "cheetah-template-1315689": "Business Coach",
    "ct-member-many-delete-users": "Cancellazione di massa degli utenti ",
    "ct-member-many-delete-users-obs": "Quando si salva, gli utenti selezionati vengono eliminati. Una volta confermata, l'azione non può essere annullata.",
    "ct-users-delete-array-and": "e",
    "ct-users-confirm-delete": "Confermo la cancellazione di massa",
    "ct-selected-users-clear": "Deselezionare",
    "ct-checkBoxTextBackgroundHover": "Enable hover color",
    "ct-resource-textBackgroundColorHover": "Text color hover",
    "ct-isGradientText": "Enable gradient text",
    "ct-panda-video-meet": "Crea ora il tuo account Panda Video",
    "ct-cursorType": "Cursor type",
    "ct-option-cursor-type-crosshair": "Crosshair",
    "ct-option-cursor-type-pointer": "Pointer",
    "ct-option-cursor-type-text": "Text",
    "ct-option-cursor-type-wait": "Wait",
    "ct-option-cursor-type-help": "Help",
    "ct-save-permissions": "Salva le nuove autorizzazioni",
    "ct-remove-permissions": "Rimuovi le autorizzazioni",
    "ct-member-many-edit-users-danger": "Quando salvi, gli utenti selezionati vengono eliminati. Una volta confermata, l'azione non può essere annullata.",
    "ct-component-MultiStepFormComponent": "Modulo MultiStep",
    "ct-next-text": "Testo successivo",
    "ct-next-icon": "Icona successiva",
    "ct-button-next": "Pulsante successivo",
    "ct-button-previous": "Pulsante precedente",
    "ct-previous-icon": "Icona precedente",
    "ct-button-sub-next-headline": "Pulsante sottotitoli titolo successivo",
    "ct-next-subtext": "Sottotesto successivo",
    "ct-button-sub-previous-headline": "Pulsante sottotitoli titolo precedente",
    "ct-previous-subtext": "Sottotesto precedente",
    "ct-boxShadow-submit": "Ombra del Box \"invia\"",
    "ct-next-boxShadow": "Ombra del box successivo",
    "ct-previous-boxShadow": "Ombra precedente del Box",
    "ct-add-group": "Aggiungi gruppo",
    "ct-group-name": "Nome del gruppo",
    "ct-group-description": "Descrizione del gruppo",
    "ct-group-icon": "Icona del gruppo",
    "ct-group-fields": "Campi del gruppo",
    "ct-checkout-security-content-label": "Etichetta del contenuto di sicurezza",
    "ct-navbar-type": "Tipo di barra di navigazione",
    "ct-show-title": "Mostra titolo",
    "ct-show-description": "Mostra la descrizione",
    "ct-show-previous-button": "Mostra il pulsante precedente",
    "ct-show-title-nav": "Mostra il titolo della navigazione",
    "ct-width-button-submit": "Larghezza pulsante di invio",
    "ct-height-button-submit": "Altezza del Pulsante invia",
    "ct-next-width-button": "Larghezza pulsante successivo",
    "ct-next-height-button": "Altezza Pulsante successivo",
    "ct-previous-width-button": "Larghezza Pulsante precedente",
    "ct-previous-height-button": "Altezza precedente del Pulsante",
    "ct-button-margin-submit": "Margine del pulsante invia",
    "ct-bg-color-submit": "Invio colore di sfondo",
    "ct-next-bg-color": "Colore di sfondo successivo",
    "ct-previous-bg-color": "Colore dello sfondo precedente",
    "ct-bg-color-hover-submit": "Colore di sfondo al passaggio del mouse",
    "ct-next-bg-color-hover": "Colore di sfondo successivo al passaggio del mouse",
    "ct-previous-bg-color-hover": "Colore di sfondo precedente al passaggio del mouse",
    "ct-bg-color-text-hover-submit": "Invio colore di sfondo del testo al passaggio del mouse",
    "ct-next-bg-color-text-hover": "Prossimo colore di sfondo testo al passaggio del mouse",
    "ct-previous-bg-color-text-hover": "Colore sfondo precedente del testo al passaggio del mouse",
    "ct-navbar-bg-color": "Colore di sfondo della barra di navigazione",
    "ct-navbar-bg-color-inactive": "Colore di sfondo della barra di navigazione non attivo",
    "ct-navbar-color": "Colore della barra di navigazione",
    "ct-navbar-color-inactive": "Colore della barra di navigazione non attivo",
    "ct-border-submit": "Bordo  di \"invia\"",
    "ct-next-border": " Bordo successivo",
    "ct-previous-border": "Bordo precedente",
    "ct-borderRadius-submit": "Raggio del bordo \"invia\"",
    "ct-next-borderRadius": "Raggio del bordo successivo",
    "ct-previous-borderRadius": "Raggio del bordo precedente",
    "ct-navbar-borderRadius": "Raggio del bordo della barra di navigazione",
    "ct-text-submit": "Invia il testo",
    "ct-icon-submit": "icona invio",
    "ct-previous-text": "Testo precedente",
    "ct-subtext-submit": "Invio Sottotesto ",
    "ct-element-multistepformcomponent": "Modulo multiplo",
    "ct-text-gradient-color": "Gradiente Colore ",
    "ct-component-LottieFileComponent": "File Lottie",
    "ct-external-url": "URL esterno",
    "ct-or": "O",
    "ct-autoplay": "Autoplay ",
    "ct-controls": "Controlli",
    "ct-upload-lottie-json": "Impostazioni di upload dei file Lottie",
    "ct-tab-upload-lottie-file": "Upload file ",
    "ct-tab-see-lottie-files": "Elenco dei file",
    "ct-upload-lottie-json-obs": "Invia il tuo file Lottie",
    "ct-upload": "Upload",
    "ct-upload-lottie-json-preview-obs": "Quando inviate il vostro file Lottie, dovreste vederne un'anteprima; se non appare, controllate che si tratti davvero di un file Lottie.",
    "ct-upload-lottie-json-is-valid": "Invia il file di Lottie",
    "ct-upload-lottie-save": "Salva",
    "ct-element-lottie-file": "File Lottie",
    "ct-upload-lottie-list-is-empty": "L'elenco dei file Lottie è vuoto",
    "ct-upload-lottie-file": "File Lottie",
    "ct-card-site-edit": "Modifica",
    "ct-acess-page": "Vai alla pagina",
    "ct-card-site-settings": "Impostazioni",
    "ct-website-list-pages": "Elenco delle pagine",
    "ct-dashboard": "Dashboard",
    "ct-page-edit-settings": "Impostazioni della pagina",
    "ct-meet-smart-templates": "Con l'opzione dei template smart, è possibile creare un sito web con informazioni testuali predefinite di propria scelta, utilizzando tag specifici che corrispondono a un determinato tipo di testo, come ad esempio informazioni sull'azienda, social media, descrizione e altro ancora.\nSelezionando questa opzione, sarà possibile scegliere o creare un gruppo di tag da applicare al modello.",
    "ct-goto-smart-templates": "Smart Templates ",
    "ct-bb-home": "Builderall Builder Home ",
    "ct-save-template-btn": "Get Started",
    "ct-borderRadiusContainer": "Raggio del bordo del contenitore",
    "ct-acess-website": "Vai al sito",
    "cheetah-category-template-85": "Servizi Professionali",
    "cheetah-category-template-86": "Salute e Fitness",
    "cheetah-category-template-87": "Corsi e Webinar",
    "cheetah-category-template-88": "Prodotti Digitali",
    "cheetah-category-template-89": "Coaching, Relatori",
    "cheetah-category-template-90": "Marketing",
    "cheetah-category-template-91": "Settore immobiliare",
    "cheetah-category-template-92": "Agenzie",
    "cheetah-category-template-93": "Business ",
    "cheetah-category-template-94": "Generale",
    "cheetah-category-template-95": "Negozi",
    "ct-editor-new-page": "Create New Page",
    "ct-editor-duplicate": "Duplicate Page",
    "ct-select-tag-group": "Il gruppo di Tag è obbligatorio",
    "ct-website-manager": "Gestione Siti Web",
    "ct-card-eye": "View",
    "ct-card-sitepage-edit": "Edit Name",
    "ct-template-full-website": "Siti Completi",
    "ct-template-full-funnel": "Single Page/Funnel Page",
    "ct-card-site-edit-config": "Edit Name",
    "ct-modal-initial-text": "Il tuo sito web non ha una homepage selezionata",
    "ct-verify": "Verifica",
    "ct-template-website-type": "Tipo di modello",
    "ct-home-dont-delete": "La pagina iniziale non può essere cancellata, selezionare una nuova pagina per continuare.",
    "ct-modal-initial-obs": "Il tuo sito web deve avere una pagina iniziale selezionata. Per assegnare una home page al tuo sito web, scegli una pagina e vai alle impostazioni. Accanto al nome della pagina, selezionare \"sì\" sull'opzione \"Home Page\".",
    "cheetah-template-1372307": "Teste geo",
    "cheetah-template-1372317": "Theme 04 - Full",
    "cheetah-template-1372309": "Theme 03 - Full",
    "cheetah-template-1372304": "Theme 02 - Full",
    "cheetah-template-1372293": "Theme 01 - Full",
    "cheetah-template-1372207": "Coach - Full",
    "cheetah-template-1372196": "App - Full",
    "cheetah-template-1372134": "Agency - Full",
    "cheetah-template-1372129": "Course - Full",
    "cheetah-template-1372110": "Beard Treatment - Full",
    "cheetah-template-1372115": "Car - Full",
    "cheetah-template-1372103": "Muscle Mass - Full",
    "cheetah-template-1372101": "Business - Full",
    "cheetah-template-1372096": "Stop Smoking - Full",
    "cheetah-template-1372093": "Dark Theme - Full",
    "cheetah-template-1372087": "Pink Theme - Full",
    "cheetah-template-1372086": "Blue Theme - Full",
    "cheetah-template-1372085": "Green Theme - Full",
    "cheetah-template-1372081": "Yellow Theme - Full",
    "cheetah-template-1372074": "Blank Theme - Full",
    "cheetah-template-1371903": "Influencer - Full",
    "cheetah-template-1371825": "Cookbook  - Full",
    "cheetah-template-1371817": "Complete Home Renovation - Full",
    "cheetah-template-1371804": "Chef Course - Full",
    "cheetah-template-1371796": "Travel Packages - Full",
    "cheetah-template-1371444": "Launch a Book - Full",
    "cheetah-template-1371435": "Air Conditioning Service - Full",
    "cheetah-template-1371341": "Coach Course - Full",
    "ct-website-overview": "Statistiche Sito web",
    "ct-text-smart-type": "Che tipo di testo desideri generare?",
    "ct-text-smart-description": "Scrivi una breve descrizione del contenuto che vorresti che Magic Text generasse.",
    "ct-text-smart-about": "Di che tipo di attività si tratta?",
    "ct-text-smart-product": "Che tipo di prodotto, servizio, promozione, caratteristica o vantaggio vuoi far conoscere?",
    "ct-text-generate": "Genera",
    "ct-text-choose": "Scegli",
    "ct-edit-text-smart": "Generazione di testo",
    "ct-text-smart-type-1": "Crea 3 titoli di esempio",
    "ct-text-smart-type-2": "Creare 3 sottotitoli di esempio",
    "ct-text-smart-type-3": "Creare 3 articoli di esempio",
    "ct-text-smart-type-4": "Creare un articolo",
    "ct-text-smart-type-5": "Crea contenuti personalizzati",
    "ct-choose-text-smart": "Scegliere il tipo",
    "ct-edit-text-smart-obs": "Il nuovo strumento di generazione di testo AI di Builderall.",
    "ct-text-smart-about-plch": "Es: Liberarsi dalle preoccupazioni",
    "ct-action-magic-text": "Testo Magico",
    "ct-text-smart-product-plch": "Es: Ebooks, PDF, infoprodotti...",
    "ct-generating": "Generazione",
    "ct-magic-text-three-breack-line": "in sole tre interruzioni di riga",
    "ct-magic-text-one-breack-line": "in una sola riga di interruzione",
    "ct-magic-text-for-business": "per un'azienda",
    "ct-magic-text-about": "circa",
    "ct-magic-text-for-one-website": "per un sito web",
    "ct-mboss-integration-key-helper": "Come individuare la chiave di integrazione: Accedere all'applicazione Mailing Boss, andare alla sezione integrazione del menu e lì sarà disponibile il token.",
    "ct-beta": "Beta",
    "ct-magic-text-prompt-end": "Restituire solo i testi. Nessuna disposizione in ordine di numerazione. Non aggiungere l'introduzione, il saluto, il benvenuto o il testo esplicativo.",
    "ct-magic-text-prompt-custom": "Creare un contenuto personalizzato senza dialoghi interattivi, aiuti o suggerimenti su",
    "ct-get-response-alert-input": "Quando si sceglie un campo correlato da GetResponse, il tipo di campo sarà identico a quello di GetResponse.",
    "ct-invalid-url-page-name": "Nome URL non valido",
    "ct-invalid-page-name": "Nome pagina non valido",
    "cheetah-template-1428822": "Z Theme Test",
    "cheetah-template-1429601": "teste 1",
    "cheetah-category-template-96": "Italian (it_IT)",
    "cheetah-template-1432874": "Template - Agenzia",
    "cheetah-category-template-97": "Inglese (en_US)",
    "cheetah-category-template-98": "Portoghese (pt_BR)",
    "cheetah-category-template-99": "Spagnolo (es_ES)",
    "cheetah-category-template-100": "Francese (fr_FR)",
    "cheetah-category-template-101": "Tedesco (de_DE)",
    "cheetah-category-template-102": "All Langs (en_US, pt_BR, es_ES, fr_FR, it_IT, de_DE)",
    "cheetah-template-1434513": "Template - Agency",
    "cheetah-template-1434726": "Template - Agência",
    "cheetah-template-1434897": "Template - Agencia",
    "cheetah-template-1435330": "thumb frances",
    "cheetah-template-1421688": "Modello - Agenzia",
    "cheetah-template-1435167": "Template - Agency",
    "cheetah-template-1435261": "Template - Agência",
    "cheetah-template-1421687": "Plantilla - Agencia",
    "cheetah-template-1435323": "Modèle - Agence",
    "cheetah-template-1435332": "Vorlage - Agentur",
    "ct-website-redirect-to": "Reindirizzare l'intero sito web a",
    "ct-website-redirect-to-helper": "Quando si inserisce un URL, è necessario che la voce di cui sopra sia protetta da SSL e che punti ai nostri Nameserver. Tutte le pagine di questo sito web saranno reindirizzate all'URL registrato sopra. Per applicare la configurazione, è necessario ripubblicare il sito web.",
    "ct-invalid-redirect-to-regex": "URL non valido, deve iniziare con https://",
    "ct-invalid-domain-for-redirect-to": "URL non registrato nel gestore DNS",
    "cheetah-template-1442146": "template_teste",
    "ct-pixel-custom-event": "Evento personalizzato Pixel",
    "ct-pixel-standard-event": "Evento Pixel Standard",
    "ct-select-a-page": "Selezionare una pagina",
    "ct-select-or-insert-an-event": "Selezionare o inserire un pixel evento",
    "ct-seo-metatag-default": "DESCRIZIONE DALLE IMPOSTAZIONI DEL SITO WEB",
    "ct-seo-robots-default": "DOMINIO",
    "ct-publish-only-one-site-with-domain": "Questo piano consente di pubblicare un solo sito web con un dominio collegato.",
    "ct-place-menu-enable-link": "Abilitare il link",
    "ct-place-menu-link": "Configurare il link",
    "ct-place-menu-enable-line-break": "Abilita l'interruzione di riga",
    "ct-mirror-websites": "Siti web a specchio",
    "ct-websites-selected-all": "Seleziona tutti",
    "ct-status-all": "Tutti",
    "ct-filter-by": "Filtra per",
    "ct-modal-deleted-attention": "Attenzione!",
    "ct-modal-deleted-website-description": "Sei sicuro di voler eliminare questi siti web? Questa azione è irreversibile.",
    "ct-modal-deleted-pages-description": "Sei sicuro di voler cancellare queste pagine? Questa azione è irreversibile.",
    "ct-published": "Pubblicato",
    "ct-unpublished": "Non pubblicato",
    "ct-my-websites": "I miei siti web",
    "ct-websites-unselect-all": "Deselezionare",
    "ct-modal-deleted-confirm-email": "Conferma questa azione inserendo il tuo indirizzo e-mail",
    "ct-modal-deleted-confirm-email-error": "Controlla il tuo indirizzo e-mail e riprova",
    "ct-modal-deleted-all-websites-description": "Sei sicuro di voler eliminare tutti i tuoi siti web? Questa azione è irreversibile.",
    "ct-modal-deleted-websites-description": "Sei sicuro di voler eliminare questi siti web? Questa azione è irreversibile.",
    "ct-modal-deleted-page-description": "Sei sicuro di voler eliminare questa pagina? È possibile ripristinarla in un secondo momento utilizzando l'opzione di menu \"Ripristina pagine\".",
    "ct-left-margin": "Margine sinistro",
    "ct-bottom-margin": "Margine inferiore",
    "ct-start-menu-item": "Inizio dell'articolo",
    "ct-type-open-container-by-click": "Con un clic",
    "ct-type-open-container-by-hover": "Al passaggio del mouse",
    "ct-settings-start-menu-item": "Beginning of item",
    "ct-start-menu": "Apertura del menu",
    "ct-width-full": "100% della larghezza",
    "ct-type-open-container": "Aprire le voci del menu su:",
    "ct-max-width": "Larghezza massima",
    "ct-republishing": "Ripubblicando il tuo sito web",
    "ct-component-FloatingButtonComponent": "Pulsante Variabile",
    "ct-call-to-action": "Invito all'azione",
    "ct-send-us-a-message": "Inviaci un messaggio",
    "ct-enable-call-to-action": "Abilitare l'invito all'azione",
    "ct-position-call-to-action": "Posiziona l'invito all'azione",
    "ct-phone-number": "Numero di telefono",
    "ct-linkedin-profile-link": "Link al profilo Linkedin",
    "ct-facebook-page-name": "Nome della pagina Facebook",
    "ct-video-link": "Collegamento video",
    "ct-x-account": "X Account",
    "ct-element-floating-button": "Pulsante Variabile",
    "cheetah-template-1493685": "Personal Brand",
    "ct-favicon": "Favicon",
    "ct-custom-validation": "Convalida personalizzata",
    "ct-please-enter-valid-full-name": "Inserire un nome completo valido",
    "ct-full-name": "Nome e cognome",
    "ct-unlock": "Sbloccare",
    "cheetah-premium-template-1501290": "Sito web della salute",
    "cheetah-premium-template-1502139": "Sito web dell'avvocato",
    "cheetah-premium-template-1502141": "Sito web di bellezza",
    "cheetah-premium-template-1502143": "Sito web dedicato al fitness",
    "cheetah-premium-template-1502145": "Sito web dedicato al fitness",
    "cheetah-premium-template-1502147": "Sito web della cucina",
    "cheetah-premium-template-1502149": "Sito web della motivazione",
    "cheetah-premium-template-1502151": "Sito web di vendita",
    "cheetah-premium-template-1502168": "Sito web immobiliare",
    "cheetah-premium-template-1502263": "Sito web immobiliare",
    "cheetah-premium-template-1502266": "Sito web per ristorante",
    "cheetah-premium-template-1502269": "Sito web del dentista",
    "cheetah-premium-template-1502271": "Sito web finanziario",
    "cheetah-premium-template-1502273": "Sito web eventi",
    "cheetah-premium-template-1502276": "Sito web di coaching",
    "cheetah-premium-template-1502278": "Sito web di yoga",
    "cheetah-premium-template-1502284": "Sito web aziendale",
    "cheetah-premium-template-1502287": "Sito web costruzioni",
    "cheetah-premium-template-1502289": "Sito web prodotti",
    "cheetah-premium-template-1502297": "Sito web per animali domestici",
    "cheetah-premium-template-1502299": "Sito dell'agenzia",
    "cheetah-premium-template-1502302": "Sito web di consulenza",
    "cheetah-premium-template-1502308": "Sito web prodotti",
    "cheetah-premium-template-1502310": "Azienda",
    "cheetah-premium-template-1502312": "Spa",
    "cheetah-premium-template-1502314": "Sito web fotografico",
    "cheetah-premium-template-1502317": "Sito web dei servizi contabili",
    "cheetah-premium-template-1502320": "Sito web di Business Coaching",
    "cheetah-premium-template-1502323": "Sito web per palestra",
    "cheetah-premium-template-1502329": "Sito web di Business Coach",
    "cheetah-premium-template-1502331": "Sito web dei servizi di contabilità",
    "cheetah-premium-template-1502333": "Sito web del dentista",
    "cheetah-premium-template-1502336": "Sito web dei servizi di pulizia",
    "cheetah-premium-template-1502341": "Sito web del ristorante",
    "cheetah-premium-template-1502343": "Sito web di psicologia",
    "cheetah-premium-template-1502353": "Sito web del coach della salute",
    "cheetah-premium-template-1502355": "Organizzatore di matrimoni",
    "cheetah-premium-template-1502358": "Funnel per Squeeze Page",
    "cheetah-premium-template-1502360": "Funnel per i quiz",
    "cheetah-premium-template-1502362": "Sito web per corsi",
    "cheetah-premium-template-1502364": "Sito web del coach",
    "cheetah-premium-template-1502366": "Life Coaching",
    "cheetah-premium-template-1502368": "Accademia di danza",
    "cheetah-premium-template-1502371": "Sito web per i corsi",
    "cheetah-premium-template-1502373": "Sito web per agenti immobiliari",
    "cheetah-premium-template-1502377": "Sito web immobiliare",
    "cheetah-premium-template-1502382": "Sito web immobiliare",
    "cheetah-premium-template-1502385": "Sito web per dentista",
    "cheetah-premium-template-1502390": "Sito web per dentista",
    "cheetah-premium-template-1502392": "Sito web per dentista",
    "cheetah-premium-template-1502395": "Sito web di Life Coaching",
    "cheetah-premium-template-1502398": "Coach aziendale",
    "cheetah-premium-template-1502400": "Sito web dedicato alla salute",
    "cheetah-premium-template-1502403": "Life Coach",
    "cheetah-premium-template-1502406": "Sito web dello psicologo",
    "cheetah-premium-template-1502413": "Coach della salute, coaching",
    "cheetah-premium-template-1502426": "Sito web per i corsi",
    "cheetah-premium-template-1503104": "Sito web dedicato al fitness",
    "cheetah-premium-template-1503106": "Sito web per la palestra",
    "cheetah-premium-template-1503109": "Funnel di lead magnet",
    "cheetah-premium-template-1503113": "Flussi, funnel per webinar",
    "cheetah-premium-template-1503115": "Sito web dedicato alla contabilità",
    "cheetah-premium-template-1503117": "Funnel Lead magnet",
    "cheetah-premium-template-1503120": "Sito web per agenzia",
    "cheetah-premium-template-1503122": "Sito web finanziario",
    "cheetah-premium-template-1503124": "Sito web Investimenti",
    "cheetah-premium-template-1503127": "Sito web Investimenti",
    "cheetah-premium-template-1503129": "Sito web per allenatori di fitness",
    "cheetah-premium-template-1503131": "Funnel per competizione",
    "cheetah-premium-template-1503134": "Funnel VSL",
    "cheetah-premium-template-1503137": "Sito web per matrimoni",
    "ct-buy": "Acquista",
    "ct-premium-template-unlocked": "Modello premium sbloccato con successo",
    "ct-show-premium-templates": "Mostra i modelli premium",
    "ct-free": "Gratuito",
    "ct-premium-templates-cannot-transfer": "I modelli premium non possono essere trasferiti",
    "ct-load-more": "Per saperne di più",
    "ct-new-file-created": "Esito positivo. È stato generato un nuovo file con la modifica",
    "ct-error-to-copy-file": "Errore nella modifica del file. Riprovare",
    "ct-new-website": "Nuovo sito web",
    "ct-smart-templates": "Modelli intelligenti",
    "ct-new-group": "Nuovo Gruppo",
    "ct-bundle-exit-popup-message": "Gestione dei pop-up\nPer creare e accedere ai pop-up, accedere al Website Manager di uno dei siti, quindi fare clic su Elementi globali > Pop-up.",
    "ct-modal-create-popup-title-type": "DOVE VERRÀ VISUALIZZATO IL POP-UP?",
    "ct-modal-create-popup-title-internal": "VISUALIZZARE SU QUESTO SITO WEB",
    "ct-modal-create-popup-title-external": "VISUALIZZAZIONE SU UN SITO WEB ESTERNO",
    "ct-modal-create-popup-option-internal-title": "Su questo sito web",
    "ct-modal-create-popup-option-internal-descrip": "Se il pop-up viene visualizzato sul sito web che si sta modificando, scegliere questa opzione.",
    "ct-modal-create-popup-option-external-title": "Su un sito web esterno",
    "ct-modal-create-popup-option-external-descrip": "Se il pop-up viene visualizzato su un sito web esterno, scegliere questa opzione. Si noti che per i siti web esterni, il pop-up funzionerà solo come pop-up con intento di uscita.",
    "ct-modal-create-popup-config-internal-title": "Sito web di Builderall",
    "ct-modal-create-popup-config-internal-descrip": "Aggiungere un nome al pop-up e fare clic su Avanti per creare il pop-up.",
    "ct-modal-create-popup-config-external-title": "Sito web esterno",
    "ct-modal-create-popup-config-external-descrip": "Aggiungi il nome, l'URL del sito e copia lo script nell'area HEAD della pagina del sito.",
    "ct-modal-create-popup-config-label-name": "Nome del pop-up",
    "ct-modal-create-popup-config-label-url": "URL del sito web esterno",
    "ct-modal-create-popup-config-label-script": "Script",
    "ct-modal-create-popup-config-placeholder-name": "Inserire il nome",
    "ct-modal-create-popup-config-placeholder-url": "Inserire l'URL",
    "ct-popup-list-total-impressions": "Totale visualizzazioni",
    "ct-popup-list-item-total-impressions": "Totale visualizzazioni",
    "ct-popup-list-total-impressions-tooltip": "Il tuo piano ha un limite mensile di %impressioni_limite% di visualizzazioni. Per maggiori dettagli, accedere a Piano e limiti facendo clic su questa casella.",
    "ct-domains": "Domini",
    "ct-visitors": "Visitatori",
    "ct-all-websites": "Tutti i siti web",
    "ct-info": "Info",
    "ct-mirrors-websites": "Siti web a specchio",
    "ct-new-page": "Nuova pagina",
    "ct-new-page-turbo": "Nuova pagina Turbo",
    "ct-gdpr-border-type": "Tipo di bordo",
    "ct-gdpr-thickness": "Spessore",
    "ct-browser-notifications": "Notifiche del browser",
    "ct-premium": "Premium",
    "ct-others": "Altro",
    "ct-sitemap": "Mappa del sito",
    "ct-access-sitemap": "Accesso alla mappa del sito",
    "ct-new-split-test": "Nuovo Split Test",
    "ct-remove-split-test": "Rimuovere lo Split Test",
    "ct-new-multiple-actions": "Nuove azioni multiple",
    "ct-create-multiple-actions": "Creare azioni multiple",
    "ct-new-vote-system": "Nuovo sistema di voto",
    "ct-new": "Nuovo",
    "ct-your-changes-saved": "Le modifiche sono state salvate e anche gli aggiornamenti",
    "ct-7-days": "7 giorni",
    "ct-30-days": "30 giorni",
    "ct-all-time": "Per sempre",
    "ct-text-go-here": "Il testo va qui...",
    "ct-banner-subtitle": "Costruire siti web con la tecnologia drag-and-drop",
    "ct-banner-description": "Crea siti web reattivi, connettiti con i clienti usando gli strumenti di Builderall e molto altro ancora.",
    "ct-redir-after-scheduling": "Reindirizzamento dopo la pianificazione",
    "ct-booking-standard": "Booking standard",
    "ct-modal-create-popup-config-error-name": "Il campo è obbligatorio",
    "ct-modal-create-popup-config-error-url": "URL non valido",
    "ct-exit-popup-list-title": "Elenco Pop-up",
    "ct-click-here-to-test-download": "Click here to test the download",
    "ct-activity": "Activity",
    "ct-undo": "Annulla",
    "ct-redo": "Rifare",
    "cheetah-premium-template-1548260": "Motivational Speaker",
    "cheetah-premium-template-1548277": "Course Program",
    "cheetah-premium-template-1548293": "Digital Workshop",
    "cheetah-premium-template-1548295": "Educator Book",
    "cheetah-premium-template-1548297": "Payroll",
    "cheetah-premium-template-1548299": "Yoga Meditation",
    "cheetah-premium-template-1548301": "Creative agency",
    "cheetah-premium-template-1548305": "Spa Salon",
    "cheetah-premium-template-1548307": "Consulting Website",
    "cheetah-premium-template-1548309": "Chocolate Sweeties",
    "cheetah-premium-template-1548363": "Skincare",
    "cheetah-premium-template-1548365": "Sales product 01",
    "cheetah-premium-template-1548367": "Solar Energy 01",
    "cheetah-premium-template-1548369": "Solar Energy 02",
    "cheetah-premium-template-1548371": "Marketing Digitale",
    "cheetah-premium-template-1548373": "Photography Course",
    "cheetah-premium-template-1548375": "Social Media Course",
    "cheetah-premium-template-1548377": "Sales product 02",
    "cheetah-premium-template-1548379": "Conference",
    "cheetah-premium-template-1548381": "Life Coaching",
    "cheetah-premium-template-1554550": "Beauty Salon",
    "cheetah-premium-template-1554549": "Life Coach",
    "cheetah-premium-template-1554548": "Fitness Zone",
    "cheetah-premium-template-1554547": "Real State",
    "cheetah-premium-template-1554546": "Natural Solutions",
    "cheetah-premium-template-1554545": "Healthy Products",
    "cheetah-premium-template-1554544": "Natural Products",
    "cheetah-premium-template-1554543": "Personal Trainer",
    "cheetah-premium-template-1554542": "Agency & Community",
    "cheetah-premium-template-1554541": "Book Magic",
    "cheetah-premium-template-1560167": "Bike01",
    "cheetah-premium-template-1560168": "Bike02",
    "cheetah-premium-template-1560169": "Restaurant01",
    "cheetah-premium-template-1560170": "Camping Shop",
    "cheetah-premium-template-1560171": "Restaurant 02",
    "ct-primary-color": "Colore primario",
    "ct-secondary-color": "Colore secondario",
    "ct-newest": "Più recente",
    "ct-oldest": "Più vecchio",
    "top-menu--university--training--viral-team-description": "Benvenuti alla Builderall University, dove avete accesso a corsi di formazione, contenuti esclusivi e canali di social media.",
    "ct-import-members-users-without-error": "Importazione membri riuscita senza errori",
    "ct-form-members-theme": "Tema modulo membri",
    "ct-password-recovery-settings": "impostazioni recupero password",
    "ct-members-recovery-password-manual": "Recupero manuale password dei membri",
    "ct-members-recovery-password-fixed": "Recupero password dei membri",
    "ct-members-recovery-password-manual-obs": "Recupero manuale password dei membri",
    "ct-members-recovery-password-fixed-obs": "ct-members-recovery-password-fixed-obs",
    "ct-config-your-tags": "Configura i tuoi Tag",
    "ct-config-your-tags-desc": "Configura i tuoi tag",
    "ct-mboss-integration-key-plch": "Chiave di integrazione MailingBoss",
    "ct-mboss-reference-plch": "Riferimento MailingBoss"
}